/*
 * lfy-trade-portal.js — PACKET-03A / D21. Renders GET /apps/cipzo/trade.
 *
 * ⛔ THE TWO ROUTES ANSWER A SIGNED-OUT VISITOR DIFFERENTLY, ON PURPOSE.
 *      GET  /apps/cipzo/trade        -> 200 { signedIn: false }   (renders INTO a page)
 *      POST /apps/cipzo/trade/lines  -> 401 { ok:false, reason }  (an API)
 *    So here a 200 is NOT success — it is the start of the question "which state is this?".
 *    `res.ok` is never consulted.
 *
 * ⛔ NO PRICE (D9). The read contract carries none. This file must never render, derive or cache
 *    one, and must never imply a trade price exists — tradePricing.ts is unwired on the Cipzo side.
 *
 * ⛔ REPORTED, NEVER INFERRED. `truncated` and `otherDraftsTruncated` are stated by the server,
 *    which fetches pageSize + 1 so "there is more" is OBSERVED rather than guessed from a
 *    full-looking page. Never re-derive either by measuring the array.
 */
(function () {
  var reload = function () {};

  /* ⛔ afterWrite() USED TO LIVE HERE AND IT THREW ON EVERY WRITE. It is now declared beside
   * `var openProjectId` further down, next to activeId(). See the note at its new home: the
   * deployed bundle had it reading three identifiers that exist nowhere in the file, so the
   * exception landed in addLine's .catch and the trader was told a successful add had failed.
   *
   * ⚠️ DO NOT MOVE IT BACK UP HERE for tidiness. Every function that reads openProjectId /
   *    openProjectRef and WORKS is declared after those vars; this was the only one declared
   *    before them, and it was the only one broken. */
  "use strict";

  /* ⛔ RUN AFTER THE DOM EXISTS, WHATEVER ORDER THE SECTION EMITS US IN.
   * The section renders its script_tag BEFORE the markup, and `script_tag` produces a plain
   * parser-blocking <script src> — so this file executed while [data-lfy-portal] did not yet
   * exist, `root` was null, and it returned. The page then sat on "Loading your project…"
   * forever, which is the WORST failure shape: the initial state looks like working-but-slow,
   * so nothing reports and nobody can tell a hung fetch from a script that never ran.
   * Fixed here rather than by moving the tag, so re-ordering the section cannot reintroduce it. */
  function init() {
    // Only this page may be restyled for print. lfy-trade.css ships on EVERY page for a trade
    // customer, so an unscoped @media print rule hiding the header would break printing the whole
    // store for them.
    document.body.classList.add("lfy-portal-page");

    /* ⛔ OPEN THE CHAT IN PAGE RATHER THAN RELOADING INTO IT. The href carries ?cipzo_chat=open as a
     * fallback and works on its own; this just spares a waiting applicant a full navigation.
     *
     * ⛔ THE LAUNCHER LIVES IN A SHADOW ROOT, so querySelector from the document cannot reach it —
     *   the same boundary that made a print-leak scan report a clean sheet while the bubble kept
     *   printing (see the note below). And it TOGGLES: clicking when the panel is already open
     *   would CLOSE it, so the open state is checked first.
     *
     * If anything is missing — widget not mounted yet, shadow root absent — preventDefault is never
     * called and the browser follows the href. Failing back to the thing that already works. */
    document.addEventListener("click", function (ev) {
      var trigger = ev.target && ev.target.closest ? ev.target.closest("[data-lfy-chat]") : null;
      if (!trigger) return;
      var host = document.querySelector('div[data-cipzo-agents="1"]');
      var sr = host && host.shadowRoot;
      if (!sr) return;                                  /* let the href do it */
      var panel = sr.querySelector(".cz-panel");
      if (panel && panel.className.indexOf("open") !== -1) { ev.preventDefault(); return; }
      var bubble = sr.querySelector(".cz-bubble");
      if (!bubble) return;                              /* let the href do it */
      ev.preventDefault();
      bubble.click();
    });

    /* ⛔ A SHADOW ROOT CANNOT BE STYLED FROM THIS STYLESHEET. The chat launcher is button.cz-bubble
     * inside a shadow tree on a bare <div>, so no print rule of mine could ever reach it — which is
     * why it kept printing while a leak scan using querySelectorAll (which does not cross a shadow
     * boundary) reported the sheet clean. The HOST is reachable, so it is marked and hidden by
     * attribute for print.
     *
     * ⛔ AND TAGGING ONCE AT init() DID NOT WORK: the chat widget loads AFTER this script, so at
     *    that moment there was no shadow host to find. It is tagged again on beforeprint, which
     *    fires before the print dialog composes the page — the only moment guaranteed to be after
     *    every third-party widget has mounted. */
    /* ⛔ AND CSS CANNOT WIN THIS ONE AT ALL. The chat host carries an INLINE display with
     * !important, which beats any stylesheet rule including mine — measured: the host matched my
     * selector (matchesRule true) and still computed display:block. So the print rule is applied
     * to the ELEMENT, replacing its inline value, and put back afterwards so the widget still works
     * when the dialog closes.
     *
     * beforeprint is the hook because third-party widgets mount after this script; at init() there
     * is often no host to find yet. */
    var hiddenForPrint = [];
    function hostsToHide() {
      var out = [];
      try {
        document.querySelectorAll("body *").forEach(function (e) {
          if (e.shadowRoot && !e.querySelector(".lfy-portal") && !e.closest(".lfy-portal")) out.push(e);
        });
      } catch (err) {}
      return out;
    }
    function hideForPrint() {
      hiddenForPrint = [];
      hostsToHide().forEach(function (e) {
        hiddenForPrint.push([e, e.style.getPropertyValue("display"), e.style.getPropertyPriority("display")]);
        e.style.setProperty("display", "none", "important");
      });
    }
    function restoreAfterPrint() {
      hiddenForPrint.forEach(function (rec) {
        var e = rec[0];
        e.style.removeProperty("display");
        if (rec[1]) e.style.setProperty("display", rec[1], rec[2]);
      });
      hiddenForPrint = [];
    }
    window.addEventListener("beforeprint", hideForPrint);
    window.addEventListener("afterprint", restoreAfterPrint);

    // The logo lives in a header BLOCK setting, so Liquid here cannot reach it. Cloning the live
    // one keeps the printed sheet on brand without hardcoding a CDN URL that would rot the day the
    // founder changes the logo.
    try {
      var slot = document.querySelector("[data-print-logo]");
      var src = document.querySelector(".header__logo img, .header-logo img, header img");
      if (slot && src && src.getAttribute("src")) {
        var img = document.createElement("img");
        img.src = src.getAttribute("src");
        img.alt = "";
        slot.appendChild(img);
      }
    } catch (e) {}
  var root = document.querySelector("[data-lfy-portal]");
  if (!root) return;

  /* The add panel is not a state, so it is not shown by show(). It appears whenever the server
   * says adding is possible — which includes when there is no project, because that add is how a
   * project begins. The label carries the difference: joining an open project, or starting one. */
  /* isSent is passed IN, not read from currentState — see the note on the hidden line below. */
  function showAdd(visible, hasProject, isSent) {
    var panel = root.querySelector("[data-add-panel]");
    if (!panel) return;
    /* ⛔ THE SAME LATE-FETCH BUG AS show(), AND THE WARNING IS WRITTEN DIRECTLY BELOW THIS
     * FUNCTION. show() was taught that a late trade read must not paint over the view the URL
     * asked for; showAdd never was, so it set hidden unconditionally when the read resolved. The
     * founder opened a quote and saw "Add your first product" with a search box sitting above the
     * quote he had asked for — on a SUBMITTED project, which cannot take a product at all.
     * Shown from the first frame, so not even a race: just a guard that was never applied here.
     *
     * The permission is still RECORDED whatever the view; it is only DISPLAYED on the project. */
    /* ⛔ AND NOT ON `submitted`, WHICH IS A PROJECT VIEW AND SO PASSED THE TEST ABOVE.
     * The founder's screenshot showed "Sent for pricing · Q-260914-002" with "Add Your First
     * Product" two inches below it — two calls to action contradicting each other, the second
     * describing a project that had just been sent.
     *
     * ⛔ AND IT TOOK THREE GOES, BECAUSE I KEPT MOVING THE RULE INSTEAD OF ASKING WHAT IT READ.
     *    1. showView() — showAdd runs later and overwrote it.
     *    2. HERE, keyed on `currentState` — "the last writer wins, so put it in the last writer."
     *       Still nothing. The probe showed `not-approved` hiding correctly while `submitted`
     *       did not, which was the tell: the currentView half worked and the currentState half
     *       never did. Line 3396 calls showAdd(); line 3411 calls show("submitted"). The state
     *       variable is set FIFTEEN LINES AFTER this function reads it, so it still held the
     *       previous render's value. A correct rule reading a variable that does not hold its
     *       value yet is indistinguishable from a wrong rule, and I pushed it twice.
     *
     * ⛔ SO IT IS NOT DERIVED FROM STATE AT ALL. `currentState` is an echo of the payload; the
     *    payload is what the caller already has. `!d.project && lastSubmitted(d)` IS the submitted
     *    state, known at the call site, before any of this ordering exists. Passing the fact in
     *    removes the race rather than sequencing around it — and no new writer of panel.hidden is
     *    created, which matters on an element that already has five.
     *
     * The panel returns the moment Start a new project is pressed: that path has no lastSubmitted
     * standing alone, so the condition stops applying. Nothing is taken away.
     *
     * ⛔ AND THE RULE HAS MOVED OFF THE PANEL ONTO THE OPENERS, BECAUSE THE PANEL MOVED.
     *    It now lives inside [data-add-modal], which is hidden until a trader opens it — so
     *    panel.hidden no longer decides anything a human sees, and leaving the condition here
     *    would have quietly voided the fix above the moment the dialog shipped. What the trader
     *    sees now is the BUTTON, so that is what the permission gates. The panel is simply open
     *    whenever its dialog is.
     *
     *    This is the same failure mode as the three attempts recorded above, one layer out:
     *    a correct condition on an element that no longer governs the outcome. */
    panel.hidden = false;
    var mayAdd = !!(visible && currentView === "project" && !isSent);
    /* ⛔ ONLY THE MASTHEAD OPENER, NOT EVERY [data-start-project]. My first version hid all three
     *    with one querySelectorAll loop, on the assumption that a shared hook meant a shared
     *    purpose. It does not, and the measurement showed the cost: on the sent screen the button
     *    went to hidden/h=0 while its sibling link "or browse products" stayed at h=24 — a
     *    dangling "or" with nothing before it, and no way to begin the next job.
     *
     *    The three openers do TWO different jobs. The masthead one adds to the project on screen,
     *    so it follows the add permission. The two inside the empty and sent states BEGIN a new
     *    project, which is exactly the right action on both of those screens — the founder's
     *    instruction was to hide the add PANEL on sent, never to remove the way onward. Those two
     *    are revealed by their own state and need no gate from here.
     *
     *    A hook shared by two behaviours is a convenience for the click handler, not a licence to
     *    treat them as one control. */
    var mastheadNew = root.querySelector("[data-masthead-new]");
    if (mastheadNew) mastheadNew.hidden = !mayAdd;
    /* ⛔ THE BUTTON WAS NAMED AFTER THE DIALOG'S SECONDARY ACTION, AND IT TALKED THE FOUNDER OUT
     *    OF A FEATURE THAT WORKS. On Q-260908-003 — his own draft, one line on it, lineOps
     *    ["add","update","delete"] — the only add control read "+ New project". He asked "no
     *    option to add in draft??" and stopped, which is exactly what that label invites.
     *    Measured: clicking it opens a dialog titled "Add to your project" with the field label
     *    "Add a product to this project". One control, opening a panel that contradicts it.
     *
     *    The comment three lines down records his ORIGINAL complaint about this same button and
     *    the reasoning that settled it: "the button is the invitation; the panel says what to
     *    actually do, because a project has no existence of its own until its first product goes
     *    on it." That was true then. It stopped being true when any draft became openable — with
     *    a project on screen the invitation IS adding to it, and "New project" describes the one
     *    thing the trader did not ask for.
     *
     * ⚠ THE DIALOG STILL OFFERS BOTH, and that is fine: [data-start-alt] says "or start a separate
     *   job" in its own words. Naming a button after its secondary action is what caused this, so
     *   the button now names the primary one and the panel keeps explaining the rest.
     *
     * Same flag, same place, same rule as the three labels below — not a second writer. */
    if (mastheadNew) {
      mastheadNew.textContent = "";
      var plus = document.createElement("span");
      plus.setAttribute("aria-hidden", "true");
      plus.textContent = "+";
      mastheadNew.appendChild(plus);
      mastheadNew.appendChild(document.createTextNode(hasProject ? " Add a product" : " New project"));
    }
    /* ⛔ NO LONGER GATED ON THERE BEING NO PROJECT. I had assumed one open project at a time and
     *    built the rule into the client; the founder asked, and the server turns out to have no
     *    such rule — createEmptyTradeProject never reads the customer's existing projects, and a
     *    whole selection protocol exists to disambiguate between several (ambiguous_project,
     *    candidates, candidatesTruncated, otherDrafts, a draft cap). A cap on how many open
     *    projects a read returns is not the shape of a design that expects one.
     *
     *    So the restriction was mine, invented, and invisible: the control did not explain itself,
     *    it simply was not there, which is exactly why the founder called the page stuck. */
    /* The start-without-a-product block is inside the dialog too, and the dialog is only ever
       opened by a control that mayAdd has already gated — so it follows the same flag rather than
       re-deriving it. */
    var alt = root.querySelector("[data-start-alt]");
    if (alt) alt.hidden = !mayAdd;
    /* The same control does two different jobs now, so it says which. */
    var altLabel = root.querySelector("[data-start-label]");
    if (altLabel) altLabel.textContent = hasProject ? "Start another project" : "Start a project without a product";
    var altLede = root.querySelector("[data-start-or]");
    if (altLede) altLede.textContent = hasProject
      ? "or start a separate job \u2014 you can have more than one on the go"
      : "or, if you have a drawing rather than a list";
    var label = root.querySelector("[data-add-label]");
    /* ⛔ THE BUTTON AND THE PANEL SAID THE SAME WORDS. "Start a new project" appeared twice on
     * one screen and neither said HOW — the founder read the pair as two controls for one job.
     * The button is the invitation; the panel says what to actually do, because a project has no
     * existence of its own until its first product goes on it. */
    if (label) label.textContent = hasProject ? "Add a product to this project" : "Add your first product";
    var hint = root.querySelector("[data-add-hint]");
    if (hint) hint.hidden = hasProject;
  }

  /* Remembered so returning to the project view restores the state the server put us in,
   * rather than guessing at one. There is no [data-states] wrapper to toggle — the states are
   * siblings, so they are hidden individually and the live one is replayed. */
  var currentState = "loading";
  var currentView = "project";

  /* ⛔ A LATE FETCH MUST NOT PAINT OVER THE CHOSEN VIEW. wireViews() runs at init and honours
   * the hash, then the trade read resolves a second later and called show() — which revealed a
   * project state on top of whichever view the URL had asked for. So /pages/my-project#history
   * opened on the project every time. The state is always RECORDED; it is only DISPLAYED when the
   * project view is the one being shown. */
  function show(state) {
    currentState = state;
    if (currentView !== "project") return;
    var all = root.querySelectorAll("[data-state]");
    for (var i = 0; i < all.length; i++) all[i].hidden = all[i].getAttribute("data-state") !== state;
  }

  function text(el, value) {
    if (el) el.textContent = value;
  }

  /* ⛔ CAPABILITY IS REPORTED, NEVER ASSUMED, AND IT FAILS CLOSED.
   * The app lane shipped a flat array at the top level of GET /trade:
   *
   *     "lineOps": ["add", "update", "delete"]
   *
   * It is derived from a registry and asserted set-equal to the live handlers IN BOTH DIRECTIONS —
   * a one-way check stayed green while the registry under-reported, which this page would have
   * experienced as "the buttons never appeared".
   *
   * I had guessed three other shapes. None of them was this, which is the argument for asking.
   *
   * Read as TWO capabilities, not one: if only update ships, steppers appear and Remove does not.
   * An absent or non-array value yields neither — enabling a control that 405s is worse than
   * showing it pending, because the trader presses it, is told the feature is broken, and stops
   * trusting the page. */
  var canUpdate = false, canDelete = false, canSubmit = false;
  function opsOf(d) {
    var o = d && d.lineOps;
    return Array.isArray(o) ? o : [];
  }

  /* ⛔ SUBMIT IS NOT A LINE OPERATION, so lineOps cannot declare it — and it is not inferred from
   * "there is a project with lines in it" either, because that is exactly the guess that puts a
   * button in front of a trader which then 405s.
   *
   * CONTRACT (confirmed 2026-09-04): projectOps is a flat array at the top level, beside lineOps,
   * from the same registry with a both-directions set-equality assertion. It does NOT contain
   * "submit" on a submitted or absent project, so the button hides itself without the theme
   * reasoning about project state at all.
   *
   * The `d.ops` alternative I read while the name was unknown is GONE. Now that the shape is
   * named, accepting a second one is not caution — it is a reader that says yes to something the
   * server will never send, which is how a control appears that nothing supports. */
  /* ⛔ THE ACCEPT ATTRIBUTE IS NOT A CONTROL, IT IS A HINT. It filters the file PICKER and nothing
   * else: a file dragged onto a drop zone, or chosen with the dialog's filter switched to "All
   * files", arrives regardless. So the accept attribute is set from the server's list for
   * convenience, and this function is what actually decides — the app lane's acceptance criterion
   * is that every refusal path is provable, including the one where accept is bypassed.
   *
   * ⛔ AND IT NAMES EVERY REFUSAL. Globo's defect was not rejecting a PDF; it was accepting it,
   * clearing it, and saying nothing, so the trader sent an enquiry believing their schedule was
   * attached. A file that cannot be sent must say which file and why, at the moment it is chosen.
   *
   * Limits come from GET /trade (acceptedTypes, maxBytes) and are never hardcoded: a list in this
   * file drifts from the server's the first time theirs is widened. With no limits declared, this
   * refuses everything — the control is not rendered in that state anyway, and refusing is the
   * failure direction that cannot upload something the server will reject. */
  function validateFiles(files, limits) {
    var accepted = limits && Array.isArray(limits.acceptedTypes) ? limits.acceptedTypes : null;
    var maxBytes = limits && typeof limits.maxBytes === "number" ? limits.maxBytes : null;
    var out = { ok: [], rejected: [] };
    for (var i = 0; i < files.length; i++) {
      var f = files[i];
      var ext = (f.name.split(".").pop() || "").toLowerCase();
      if (!accepted) { out.rejected.push({ name: f.name, reason: "unsupported_type" }); continue; }
      var typeOk = accepted.indexOf(f.type) !== -1 || accepted.indexOf("." + ext) !== -1 || accepted.indexOf(ext) !== -1;
      if (!typeOk) { out.rejected.push({ name: f.name, reason: "unsupported_type" }); continue; }
      if (maxBytes !== null && f.size > maxBytes) { out.rejected.push({ name: f.name, reason: "file_too_large" }); continue; }
      out.ok.push(f);
    }
    return out;
  }

  /* ── Attaching: where the control lives, and which project it means ─────────────────────────
   *
   * ⛔ THE ENDPOINT IS NOT DEPLOYED. GET /trade/projects/:id/attachments returns 404 — and not even
   *    a JSON 404, it returns the app shell's HTML — so nothing here uploads anything. What is
   *    built is placement and gating: the control sits where the project is unambiguous, and it
   *    turns itself on the day projectOps declares "attach", with no theme deploy. Building the
   *    uploader now would mean building against a route that does not exist.
   *
   * The accepted-type list is deliberately EMPTY rather than hardcoded. It used to read
   * "PDF · DWG · DXF · XLSX · CSV · images", which is a promise this file is in no position to
   * make: the server publishes acceptedTypes, and some of those types cannot be verified from
   * their bytes and are refused outright when the merchant disallows unverifiable uploads. A list
   * printed from here would be confidently wrong in a way a trader only discovers on refusal. */
  /* ── ACCEPTING A QUOTE ─────────────────────────────────────────────────────────────────────
   * The founder, on a `quoted` Q-260908-004: "i cant see any acceptance button as a tradee so that
   * i can accept and draft order can be generated". There was no control at all — the capability
   * was declared on the wire and the theme had nothing to reveal.
   *
   * ⛔ GATED ON projectOps, NEVER ON STATUS. `accept` is declared in the app lane's registry
   *    (onlyOnStatuses ["quoted"]) precisely so this list is the one gate. A `won` project refuses
   *    it — accepting an accepted quote is an inert control, and the registry says so.
   *
   * ⛔ DISABLED WITHOUT A VERSION, AND THAT IS A RULING NOT A GUESS. missing_expected_version
   *    refuses at the accessor BEFORE the claim read and before the status gate, so an enabled
   *    button carrying no version could only ever produce a refusal — an offer the route cannot
   *    honour.
   *
   * ⛔ THE SIGNAL IS quoteRecorded, NOT version === null. `status = quoted` does NOT imply a quote
   *    row exists: Q-260907-001 is quoted with zero rows, so the server offers accept while the
   *    read carries no version. quoteRecorded is the field designed to carry that meaning, it has a
   *    documented three-state contract, and the null version is a CONSEQUENCE of the same missing
   *    row rather than the signal itself. I nearly gated on the field that did not exist yet
   *    instead of the one that did.
   *
   * ⚠️ AND THE DISABLED STATE IS REACHABLE BUT NOT WALKABLE HERE. No project on the QA account
   *    pairs `accept` with quoteRecorded:false, and Q-260907-001 is another account's. This branch
   *    is built and reasoned and has never been fired. */
  function acceptDeclared(d) {
    return Array.isArray(d && d.projectOps) && d.projectOps.indexOf("accept") !== -1;
  }

  function paintAcceptButton(d) {
    var btn = root.querySelector("[data-q-accept]");
    if (!btn) return;
    /* ⛔ PULLED ON THE FOUNDER'S INSTRUCTION, 2026-09-15 — and pulled HERE, at the painter, because
     * disarming the click handler alone was WORSE THAN THE BUG. Commenting out wireAccept() left
     * this painter running, so the button still rendered, still looked enabled, and did NOTHING on
     * click: no error, no feedback, silence. A control that fails loudly is better than one that
     * fails silently, and I nearly shipped the silent one while trying to remove the loud one.
     *
     * Every press returns 500 deterministically — 19+ calls, paced and unpaced, on the only project
     * that can exercise it. Nothing is written (confirmed independently from the API and the
     * database), so the failure is in the safe direction.
     *
     * Cause at time of pulling, NOT yet explained: Shopify renders a THEME PAGE for the app-proxy
     * URL and returns 500 (content-type text/html, render;dur=203, theme;desc=145377198164, a
     * 794KB body, no x-vercel-id) while the app lane's runtime logs show their function ALSO
     * receiving the POST. Both observations hold; the join between them is the open question.
     *
     * ⚠️ A PEER LANE RELAYED "the founder has ruled, leave it live". He had told me the opposite in
     *    his own words. A relayed decision is not the decision.
     *
     * TO RESTORE: delete the two lines below. Everything else — markup, gating, POST, copy, CSS —
     * is built, reviewed and unchanged. */
    /* ✅ RESTORED 2026-09-15 on the founder's OWN instruction, given in this window when asked
     * directly — not on a peer's relay, which I refused twice.
     *
     * ⚠️ THE GAP HE ACCEPTED, RECORDED RATHER THAN GLOSSED: the backend fix is strongly evidenced
     * (the phantom `shopify_customer_id` column is gone from origin/main with a positive control,
     * 405 suites / 5310 tests green, the build gate type-checked the pushed commit itself, both
     * hosts serving cea485900 across four polls, and a mutation reintroducing the bug reds by
     * name) — but NO REAL ACCEPT HAS EVER SUCCEEDED END TO END. The trader walk never got a
     * storefront session; the merchant-door probe may not have run. A trader can now press this
     * and nobody has watched one work. That was his call to make and he made it knowingly. */
    var declared = acceptDeclared(d);
    btn.hidden = !declared;
    text(root.querySelector("[data-q-accept-status]"), "");
    if (!declared) return;

    /* ENVELOPE level, beside `quote`, not inside it — so it survives the whole block being null,
       and it comes from the same row the quote block is built from rather than a second query. */
    var version = (d && typeof d.quoteVersion === "number") ? d.quoteVersion : null;
    var recorded = !!(d && d.quote && d.quote.quoteRecorded);

    btn.disabled = !recorded || version === null;
    btn.setAttribute("data-quote-version", version === null ? "" : String(version));
    btn.textContent = "Accept this quote";

    if (btn.disabled) {
      /* ⛔ A DISABLED BUTTON WITH NO EXPLANATION IS AN INERT CONTROL. The trader is looking at a
       *    priced quote with the one action they came for greyed out. The artefact's own gate text
       *    forbids "not yet priced" as a LIE — the quote WAS priced once, unrecorded — so the
       *    sentence says what actually happened and offers the door that is genuinely open
       *    (comment has no onlyOnStatuses, so it survives every status). */
      text(root.querySelector("[data-q-accept-status]"),
        "This quote was issued before we started keeping a copy of the figures, so it can't be accepted online. Send us a comment and we'll sort it out.");
    }
  }

  /* ⛔ THE PAYMENT LINK. The backend has been sending `invoiceUrl` on the accept response and the
   * theme read EIGHT fields off that response and not this one — so the link crossed the boundary
   * and was silently discarded. A trader accepted, saw "we'll be in touch", and had no way to pay.
   *
   * ⛔ THREE STATES, AND `if (!invoiceUrl)` WOULD COLLAPSE THEM. The app lane's own comment on the
   * replay branch is explicit: on a second accept the key is PRESENT and the value is NULL, and
   * that means "WE CANNOT SAY", never "there is none". Three distinct situations:
   *     non-empty string        -> the trader can pay NOW
   *     null, created === false -> REPLAY: the order exists, we just did not re-fetch the URL
   *     null, created === true  -> Shopify may not have populated it on create (unproven)
   * The last two are both "not yet", never "failed" — a trader who double-taps Accept must not see
   * a WORSE outcome than one who taps once. So: branch on the value BEING a non-empty string, and
   * treat everything else as pending. Absence is not falsity.
   *
   * ⚠️ SCOPE: this paints only from the response to the accept THIS trader just performed on the
   * project they are viewing, so it cannot surface another customer's link by construction. That
   * matters more here than anywhere else on this surface — a draft-order invoice URL is a PAYMENT
   * CAPABILITY, not merely information. */
  /* ⛔ ON RELOAD, A WON QUOTE SHOWED NOTHING AT ALL. paintPayLink was called from ONE place — the
   * accept response — so the panel existed for exactly as long as the trader stayed on the page.
   * The founder accepted, his draft order failed to generate, he reloaded, and the quote read WON
   * with no payment panel, no pending note and no explanation. His words: "quote is shown on won
   * status with no draft payment link pending or what's happening".
   *
   * ⇒ A STATUS THE TRADER CAN RELOAD INTO MUST BE PAINTED FROM THE READ, NOT ONLY FROM THE ACTION.
   * The accept response is a one-shot event; `won` is a durable state. Painting only from the event
   * meant the durable state had no rendering at all.
   *
   * ⚠️ THE COMMENT THAT USED TO BE HERE IS THE REASON THIS WAS BROKEN, SO IT IS KEPT AS A WARNING
   * RATHER THAN DELETED. It read: "invoiceUrl is NOT on the project read (measured: the project
   * keys are id, name, status, reference, draftOrderName, ...)". That was TRUE when I measured it
   * and FALSE within the day — the app lane shipped it — and because the comment said the field
   * could not be there, this function was written not to look, and nobody re-measured.
   * ⇒ A stale ABSENCE claim is more dangerous than a stale presence claim: it does not merely
   * mislead a reader, it justifies code that declines to try. Re-measure a documented absence
   * before building around it. */
  function paintPayStateFromRead(d) {
    var pr = d && d.project;
    if (!pr || pr.status !== "won") return;
    var wrap = root.querySelector("[data-q-pay]");
    if (!wrap) return;
    wrap.textContent = "";
    wrap.className = "lfy-portal__payWrap";

    /* ⛔ THE PROJECT READ NOW CARRIES invoiceUrl AND THIS FUNCTION WAS BUILT NOT TO LOOK. The
     * comment above once said it was absent — TRUE WHEN WRITTEN, FALSE NOW — and it is the reason
     * the reload path only ever read status and draftOrderName. Measured on the live wire
     * 2026-09-17: `invoiceUrl` is present on the project read, `present:null` on a quoted project
     * and a real URL once the draft order exists.
     *
     * 🔑 A CORRECT FIELD NOBODY READS IS BYTE-IDENTICAL TO ONE NEVER SENT. This is the scar class
     * pointing the other way: not a comment describing a fixed bug that reads as live, but a
     * comment describing a REAL ABSENCE that outlived the absence and suppressed the fix. When a
     * producer adds a field, the consumer's comment claiming it is missing becomes a control
     * nobody re-measured.
     *
     * Delegating to paintPayLink keeps ONE renderer for the button — the accept response and the
     * reload must not grow two implementations that can disagree. */
    if (typeof pr.invoiceUrl === "string" && pr.invoiceUrl.trim() !== "") {
      paintPayLink({ invoiceUrl: pr.invoiceUrl, draftOrderName: pr.draftOrderName });
      return;
    }

    var note = document.createElement("span");
    note.className = "lfy-portal__payPending";
    note.textContent = pr.draftOrderName
      ? "Order " + pr.draftOrderName + " has been raised. We'll email your payment link shortly — "
        + "it can take a little while to generate."
      /* ⛔ NO DRAFT ORDER NAME ON A WON QUOTE MEANS THE ORDER HAS NOT BEEN RAISED YET (or failed).
       * Do not say "your order is ready" here — it is not, and the founder hit exactly this case. */
      : "We're raising your order now. This can take a little while — we'll email you as soon as "
        + "it's ready, and you don't need to accept again.";
    wrap.appendChild(note);
    wrap.hidden = false;
  }

  /* ⛔ THE ORDER OUTCOME IS `orderCreate.kind`, NEVER THE PRESENCE OF A NAME OR A URL. Measured
   * 2026-09-21 against the deployed build (de3eeff7…, which contains the accept read-back merge):
   * this file read NONE of the contract — orderCreate 0, invoiceSend 0, retryAfterSeconds 0,
   * against a control of draftOrderName 19. So every one of the four outcomes fell through to the
   * single `invoiceUrl` test below, and the two that are NOT "your link is coming" were told they
   * were:
   *     failed  → "we'll send your payment link shortly."   a link that is never coming
   *     pending → the same sentence, with no idea a retry is even happening
   *
   * The app lane's own type says it: draftOrderName is "DISPLAY ONLY; the theme keys on `kind` so
   * that 'order pending' is never inferred from an absent name". This is that agreement, honoured.
   *
   * ⚠️ UNKNOWN KIND FALLS THROUGH TO THE HONEST WAIT, NOT TO SUCCESS. A kind this page has not
   *    been taught must never produce a pay link or a promise — same rule as the status
   *    fall-through elsewhere in this file, and the reason the app lane's own route uses
   *    `?? 500`: an unmapped outcome must not read as success. */
  function orderPhrase(data) {
    var oc = data && data.orderCreate;
    var kind = oc && typeof oc.kind === "string" ? oc.kind : null;
    if (kind === "failed") {
      /* Acceptance STANDS — say so first, because the trader has just committed money and the
         word "failed" belongs to the order, not to their decision. Retryable by accepting again,
         but the control is gone by now (projectOps no longer offers accept), so we do not invite
         an action they cannot take. */
      return "Your acceptance is recorded. We're finishing the order by hand and will send your payment link — nothing more is needed from you.";
    }
    if (kind === "pending") {
      return "Your acceptance is recorded and your order is being raised now. Refresh in a moment and your payment link will be here.";
    }
    return null;   // created / replay / unknown → the existing copy is correct
  }

  /* ⛔ LINES THE ORDER COULD NOT CARRY MUST BE NAMED. `orderCreate.removed` is documented in the
   * app lane's type as "NAMED — the caller must surface them", and this file surfaced nothing:
   * a grep for `removed` returned three hits, ALL of them comments. So a trader could accept a
   * quote, have lines silently dropped from the order, and pay for fewer products than they
   * agreed to — with the page saying "Order #D…" as though everything went. That is the worst
   * class of defect this portal can have: quiet, financial, and discovered by the customer. */
  function paintRemoved(data) {
    var host = root.querySelector("[data-q-pay]");
    var oc = data && data.orderCreate;
    var list = oc && Array.isArray(oc.removed) ? oc.removed : [];
    if (!host || !list.length) return;
    var box = document.createElement("div");
    box.className = "lfy-portal__payNote is-warn";
    var n = list.length;
    var lead = document.createElement("p");
    lead.textContent = n === 1
      ? "One line could not be added to the order and is not on it:"
      : n + " lines could not be added to the order and are not on them:";
    box.appendChild(lead);
    var ul = document.createElement("ul");
    list.forEach(function (row) {
      var li = document.createElement("li");
      /* Never print a raw object or an internal id at a customer. Title if we were given one,
         otherwise say plainly that we cannot name it rather than inventing a label. */
      var title = row && (row.title || row.name || row.sku);
      li.textContent = title ? String(title) : "A line we can't name here";
      ul.appendChild(li);
    });
    box.appendChild(ul);
    var tail = document.createElement("p");
    tail.textContent = "Leave a comment below and we'll sort them out before you pay.";
    box.appendChild(tail);
    host.appendChild(box);
    host.hidden = false;
  }

  function paintPayLink(data) {
    var wrap = root.querySelector("[data-q-pay]");
    if (!wrap) return;
    wrap.textContent = "";
    wrap.hidden = true;
    if (!data) return;

    /* The order outcome outranks the URL. On `failed` or `pending` there is no link to offer and
       the existing "we'll send your payment link shortly" would be a promise we cannot keep. */
    var phrase = orderPhrase(data);
    if (phrase) {
      wrap.className = "lfy-portal__payWrap";
      var note = document.createElement("span");
      note.className = "lfy-portal__payPending";
      note.textContent = phrase;
      wrap.appendChild(note);
      wrap.hidden = false;
      paintRemoved(data);
      return;
    }

    var url = data.invoiceUrl;
    var ready = typeof url === "string" && url.trim() !== "";

    if (ready) {
      /* The founder asked for both outcomes to appear in a status box, coloured by outcome. So the
       * success case is not a bare button either — it is a green panel that SAYS what is being
       * offered and then offers it. "Would you like to proceed to payment?" was his phrasing and it
       * is better than a naked button: it tells the trader the order is settled and this is the
       * next step, rather than leaving a green control to speak for itself. */
      wrap.className = "lfy-portal__payWrap is-ready";

      var lead = document.createElement("span");
      lead.className = "lfy-portal__payLead";
      lead.textContent = data.draftOrderName
        ? "Order " + data.draftOrderName + " is ready. Would you like to proceed to payment?"
        : "Your order is ready. Would you like to proceed to payment?";
      wrap.appendChild(lead);

      var a = document.createElement("a");
      a.className = "lfy-portal__pay";
      a.href = url;
      a.rel = "noopener";
      a.textContent = "Pay now";
      /* The visible label is short; the accessible name says what is being paid for. */
      if (data.draftOrderName) a.setAttribute("aria-label", "Pay now for order " + data.draftOrderName);
      wrap.appendChild(a);
      wrap.hidden = false;
      return;
    }
    /* Reset the success styling — this element is reused across repaints, and a wrap left with
       is-ready would render the amber pending note inside a green panel. */
    wrap.className = "lfy-portal__payWrap";

    /* ⛔ NOT SILENCE, NOT AN ERROR, AND NOT THE SUCCESS COPY. The order genuinely is raised and the
     * link genuinely is coming — both halves of this sentence are true in BOTH null cases, which is
     * why one sentence serves them. Distinguishing them for the trader would expose an internal
     * mechanism they cannot act on. */
    var note = document.createElement("span");
    note.className = "lfy-portal__payPending";
    note.textContent = "Your order is ready — we'll send your payment link shortly.";
    wrap.appendChild(note);
    wrap.hidden = false;
  }

  function sendAccept(btn, restore, ref, version) {
    var base = String(root.getAttribute("data-endpoint")).replace(/\/$/, "");
    var say2 = function (msg, tone) {
      var el = root.querySelector("[data-q-accept-status]");
      if (!el) return;
      el.textContent = msg || "";
      el.className = "lfy-portal__addStatus" + (tone ? " is-" + tone : "");
    };
    fetch(base + "/projects/" + encodeURIComponent(ref) + "/accept", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ quoteVersion: version }),
    })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) { return { status: res.status, data: data || {} }; });
      })
      .then(function (r) {
        btn.textContent = restore;
        btn.disabled = false;

        /* ⛔ created:false IS A THIRD STATE AND IT ARRIVES AS A 200, so it must be keyed HERE,
         *    before messageFor — which returns the success sentence for any 200 before a reason is
         *    ever read. This is the merged-vs-added precedent (:860), and :63 says why reason-first
         *    is wrong on a 2xx. A replay must not claim an acceptance just happened, and must not
         *    say anything failed: the call recorded nothing because the quote was already accepted.
         *    There is no `already_accepted` refusal — writing copy for one would be dead text. */
        if (r.status === 200 && r.data.created === false) {
          say2("This quote was already accepted" + (r.data.acceptedAt ? " on " + fmtDate(r.data.acceptedAt) : "") + ". Nothing has changed.", "warn");
        } else {
          var m = (window.LFY_TRADE && window.LFY_TRADE.messageFor)
            ? window.LFY_TRADE.messageFor(r.status, r.data.reason, "accept")
            : { tone: r.status === 200 ? "ok" : "err", text: r.status === 200 ? "Accepted." : "That couldn't be accepted." };
          say2(m.text, m.tone);
        }

        /* ⛔ RE-GATE FROM THE RETURNED projectOps RATHER THAN RELOADING. The project becomes `won`,
         *    accept is no longer offered, and the button takes itself away — the refreshed list is
         *    authoritative and a reload would race it. */
        if (r.status === 200 && Array.isArray(r.data.projectOps)) {
          var next = { projectOps: r.data.projectOps, project: (lastQuote && lastQuote.project) || null, quote: (lastQuote && lastQuote.quote) || null, quoteVersion: r.data.quoteVersion };
          paintAcceptButton(next);
          if (r.data.draftOrderName) {
            say2((r.data.created === false ? "Already accepted" : "Accepted") + " — order " + r.data.draftOrderName + ".", "ok");
          }
          paintPayLink(r.data);
          /* ⛔ ALSO ON THE SUCCESS PATH. `created` carries `removed` too — an order can be raised
           * and still have dropped lines, which is the case most likely to go unnoticed because
           * everything else on screen says it worked. paintPayLink only calls paintRemoved on its
           * own early return, so the created/replay path needs it here or the warning appears on
           * exactly the outcomes where nobody needs it and never on the one where they do. */
          if (!orderPhrase(r.data)) paintRemoved(r.data);
        }
      })
      .catch(function () {
        btn.textContent = restore;
        btn.disabled = false;
        say2("Couldn't reach the server, so nothing has been accepted. Please try again.", "err");
      });
  }

  function wireAccept() {
    var btn = root.querySelector("[data-q-accept]");
    if (!btn) return;
    btn.addEventListener("click", function () {
      if (btn.disabled) return;
      var raw = btn.getAttribute("data-quote-version");
      /* ⛔ NO VERSION MEANS DO NOT POST. The route refuses with missing_expected_version, and
       *    fabricating one is worse than being refused: a guess that happened to match would defeat
       *    the staleness check and let a trader accept figures they never saw. */
      if (!raw) return;
      var ref = quoteId || ((lastQuote && lastQuote.project) ? lastQuote.project.reference : null);
      if (!ref) return;
      var restore = btn.textContent;
      btn.textContent = "Accepting…";
      btn.disabled = true;
      sendAccept(btn, restore, ref, Number(raw));
    });
  }

  function paintAttachPanel(d) {
    var panel = root.querySelector("[data-q-attach-panel]");
    if (!panel) return;
    var declared = attachDeclared(d);
    panel.hidden = !declared;
    if (!declared) return;
    var pr = (d && d.project) || {};
    text(root.querySelector("[data-q-attach-for]"),
      pr.reference ? "Files you add here join " + pr.reference + "." : "Files you add here join this quote.");
    loadAttachments(activeId());
  }

  /* D46, applied to a destination instead of a line: never choose between valid targets. */
  function renderAttachRouter(list) {
    var box = root.querySelector("[data-attach-router]");
    if (!box) return;
    box.textContent = "";
    var projects = (list && Array.isArray(list.projects)) ? list.projects : null;

    if (!projects) {
      var e = document.createElement("p");
      e.className = "lfy-portal__muted";
      /* Same three nothings as the history. A signed-out visitor is not a trader with no projects. */
      e.textContent = signedOutNow
        ? "Sign in to attach a schedule to one of your projects."
        : "We couldn't load your projects just now. Please refresh, or ring us on the number above.";
      box.appendChild(e);
      if (!signedOutNow) box.appendChild(startHereLink());
      if (signedOutNow) {
        var al = document.createElement("a");
        al.className = "button button--primary lfy-portal__submit";
        al.setAttribute("href", "/customer_authentication/login?return_to=" + encodeURIComponent(location.pathname + (location.hash || "")));
        al.textContent = "Sign in";
        box.appendChild(al);
      }
      return;
    }
    if (!projects.length) {
      var none = document.createElement("p");
      none.className = "lfy-portal__muted";
      none.textContent = "Start a project first, then you can attach a schedule to it.";
      box.appendChild(none);
      return;
    }

    var lead = document.createElement("p");
    lead.className = "lfy-portal__muted";
    /* ⛔ ONE IS A SHORTCUT; MORE THAN ONE IS A QUESTION. With two open projects a dropped file
     * would join whichever the page happened to think was current — a silent choice between valid
     * targets. Naming them and asking costs one click and cannot be wrong. */
    lead.textContent = projects.length === 1
      ? "Open your project to attach a schedule to it."
      : "Which project is the schedule for?";
    box.appendChild(lead);

    projects.forEach(function (pj) {
      var a = document.createElement("a");
      a.className = "lfy-portal__qhRow is-openable";
      a.setAttribute("href", "#quote/" + (pj.reference || pj.id));
      var ref = document.createElement("span");
      ref.className = "lfy-portal__qhRef";
      ref.textContent = pj.reference || "Not yet referenced";
      var nm = document.createElement("span");
      nm.textContent = pj.name || "Untitled project";
      var meta = document.createElement("span");
      meta.className = "lfy-portal__qhMeta";
      /* ⛔ "products" IS MY WORD; THE SERVER COUNTS ROWS. It has never said "products" — and the
       *    two already disagree without any corrupt line, because a cut-to-length row is a LINE
       *    and not a product. A project holding one downlight and one strip-cut would read
       *    "2 products" while the draft order carries one. "Lines" is what is actually counted.
       * ⛔ NOT SOLVED BY ADDING A SECOND COUNT for a population of zero. */
      meta.textContent = typeof pj.lineCount === "number" ? lineCountText(pj.lineCount) : "";
      a.appendChild(ref); a.appendChild(nm); a.appendChild(meta);
      box.appendChild(a);
    });
  }

  /* ── Attachments: the round trip ────────────────────────────────────────────────────────────
   *
   * ⚠ WRITTEN AGAINST THE PUBLISHED CONTRACT, NOT YET ASSERTED AGAINST A LIVE ROUTE. At the time
   *   of writing GET /projects/:id/attachments answers 404 because the endpoints are on a branch
   *   that has not deployed. Nothing here has uploaded a byte. Every claim about it is a claim
   *   about the code, not about the seam — and the seam between this client and the app's storage
   *   is precisely the part nobody has exercised.
   *
   *   GET  .../attachments  -> attachmentLimits{maxBytes, acceptedTypes[], maxPerProject,
   *                            filenameMaxChars, allowUnverifiableTypes}, unverifiableTypes[],
   *                            attachments[{id, filename, bytes, uploadedAt, mimeType,
   *                            mimeVerification}], projectId, resolvedBy, truncated, pageSize, page
   *   POST .../attachments  multipart/form-data, part name "file" -> 201 {ok, projectId,
   *                            attachment, count, attachmentLimits, verificationVocabulary}
   *   GET  .../attachments/:id -> the BYTES. No signed URL, no supabase.co origin. */
  var attachLimits = null;

  /* ⛔ THE EFFECTIVE LIST IS NOT acceptedTypes. Some accepted types cannot be verified from their
   * bytes — CSV and DXF among them — and when the merchant disallows unverifiable uploads those
   * types are STILL in acceptedTypes while every upload of one is refused as type_unverifiable.
   * Printing acceptedTypes then would advertise a file the server will not take. The wire names
   * which members are unverifiable so the theme does not have to guess; without unverifiableTypes
   * this list is not computable and I would have hardcoded it, which is how it was wrong before. */
  /* ⛔ unverifiableTypes IS NESTED INSIDE attachmentLimits, NOT TOP-LEVEL. Measured on the live
   * response: top-level keys are attachmentLimits, attachments, ok, page, pageSize, projectId,
   * resolvedBy, signedIn, truncated, verificationVocabulary — and d.unverifiableTypes is undefined.
   * It sits beside acceptedTypes and allowUnverifiableTypes, which in hindsight is the obvious
   * place for it.
   *
   * ⛔ AND THIS WAS INVISIBLE WHEN I WROTE IT WRONG. allowUnverifiableTypes is currently true, so
   *    nothing is filtered either way and the page looked correct. It would have stayed correct
   *    until a merchant turned the flag off — and then the theme would have advertised CSV and DXF
   *    that the server refuses as type_unverifiable, which is exactly the failure this field was
   *    added to prevent. Same shape as `enriched`: the right field read at the wrong level, masked by
   *    the value that happened to be live.
   *
   * Read from the limits object, falling back to top-level rather than guessing, so a later move
   * in either direction keeps working. */
  function unverifiableFrom(d) {
    var lim = (d && d.attachmentLimits) || {};
    if (Array.isArray(lim.unverifiableTypes)) return lim.unverifiableTypes;
    if (d && Array.isArray(d.unverifiableTypes)) return d.unverifiableTypes;
    return null;
  }

  /* ⛔ A NULL LIST IS NOT AN EMPTY LIST. If the flag says filter but nothing tells us WHAT is
   * unverifiable, we cannot compute the effective list — and printing acceptedTypes unfiltered
   * would advertise files the server refuses. So we print nothing rather than something wrong. */
  function effectiveTypes(lim, unverifiable) {
    var accepted = (lim && Array.isArray(lim.acceptedTypes)) ? lim.acceptedTypes : [];
    if (lim && lim.allowUnverifiableTypes === false) {
      if (!Array.isArray(unverifiable)) return [];
      accepted = accepted.filter(function (t) { return unverifiable.indexOf(t) === -1; });
    }
    return accepted;
  }

  function prettyBytes(n) {
    if (typeof n !== "number" || !isFinite(n)) return "";
    if (n < 1024) return n + " B";
    if (n < 1024 * 1024) return Math.round(n / 1024) + " KB";
    return (n / (1024 * 1024)).toFixed(1) + " MB";
  }

  /* Every refusal names the file and the reason. A bare "upload failed" on a schedule someone has
   * waited for is the message that sends them back to email, which is the workflow this replaces. */
  function attachRefusal(reason, filename, lim) {
    var who = filename ? "“" + filename + "”" : "That file";
    switch (reason) {
      case "expected_multipart":  return "We couldn't read that upload. Please try choosing the file again.";
      case "empty_file":          return who + " is empty, so there was nothing to send.";
      case "filename_required":   return "That file has no name we can store it under. Please rename it and try again.";
      case "filename_too_long":   return who + " has too long a name" + (lim && lim.filenameMaxChars ? " (the limit is " + lim.filenameMaxChars + " characters)" : "") + ". Please shorten it and try again.";
      case "unknown_project":     return "That quote isn't available any more. Go back to your quote history.";
      case "unknown_attachment":  return "That file isn't there any more. Refresh the page to see what is attached.";
      case "attachments_full":    return "This quote already has all the files it can hold" + (lim && lim.maxPerProject ? " (" + lim.maxPerProject + ")" : "") + ". Please email the rest to ashfield@lightsforyou.com.au.";
      case "file_too_large":      return who + " is larger than we can accept" + (lim && lim.maxBytes ? " (the limit is " + prettyBytes(lim.maxBytes) + ")" : "") + ". Please send it to ashfield@lightsforyou.com.au instead.";
      case "type_not_accepted":   return "We can't accept " + who + ". " + (attachTypesSentence() || "Please send a drawing or schedule.");
      case "type_mismatch":       return who + " isn't the kind of file its name says it is, so we haven't stored it. Please re-save it and try again.";
      /* ⛔ NOT the same as type_not_accepted. The type IS on the accepted list; this merchant has
       * turned off the ones that cannot be checked from their contents. Saying "not accepted" here
       * would be a lie the trader could disprove by reading the list on the same screen. */
      case "type_unverifiable":   return "We can't confirm what's inside " + who + ", and we only accept files we can check. Please send it as a PDF, or email it to ashfield@lightsforyou.com.au.";
      case "type_unknown":        return "We couldn't tell what kind of file " + who + " is. Please re-save it and try again.";
      default:                    return "We couldn't attach " + who + ". Please try again, or email ashfield@lightsforyou.com.au.";
    }
  }

  function attachTypesSentence() {
    var el = root.querySelector("[data-q-drop-types]");
    var t = el && el.textContent ? el.textContent.trim() : "";
    return t ? "We can take " + t + "." : "";
  }

  function renderAttachments(d) {
    var list = root.querySelector("[data-q-files]");
    var none = root.querySelector("[data-q-files-empty]");
    if (!list) return;
    list.textContent = "";
    var files = (d && Array.isArray(d.attachments)) ? d.attachments : [];
    if (none) none.hidden = files.length > 0;

    files.forEach(function (f) {
      var li = document.createElement("li");
      li.className = "lfy-portal__file";
      var a = document.createElement("a");
      /* The bytes come back through the app, never a storage URL — the bucket is private and a
       * signed link would leak an origin the trader has no business seeing. */
      a.href = String(root.getAttribute("data-endpoint")).replace(/\/$/, "") +
               "/projects/" + encodeURIComponent(activeId()) + "/attachments/" + encodeURIComponent(f.id);
      a.textContent = f.filename || "Attachment";
      a.className = "lfy-portal__lineLink";
      li.appendChild(a);

      var meta = document.createElement("span");
      meta.className = "lfy-portal__qhMeta";
      var bits = [];
      if (typeof f.bytes === "number") bits.push(prettyBytes(f.bytes));
      if (f.uploadedAt) { var up = fmtDate(f.uploadedAt); if (up) bits.push(up); }
      meta.textContent = bits.join(" · ");
      li.appendChild(meta);

      /* mimeVerification is rendered ONLY when the server's own vocabulary contains it, the same
       * rule as every status on this surface. An unverifiable file is not a fault and is not
       * dressed as one — it is stated, because the trader chose to send it. */
      var vocab = (d && Array.isArray(d.verificationVocabulary)) ? d.verificationVocabulary : [];
      if (f.mimeVerification && vocab.indexOf(f.mimeVerification) !== -1 && f.mimeVerification === "unverifiable") {
        var v = document.createElement("em");
        v.className = "lfy-portal__cst";
        v.textContent = "contents not checked";
        li.appendChild(v);
      }
      list.appendChild(li);
    });

    if (d && d.truncated) {
      var t = document.createElement("li");
      t.className = "lfy-portal__muted";
      t.textContent = "Showing the first " + files.length + " files.";
      list.appendChild(t);
    }
  }

  function loadAttachments(id) {
    var base = String(root.getAttribute("data-endpoint") || "").replace(/\/$/, "");
    if (!base || !id) return;
    fetch(base + "/projects/" + encodeURIComponent(id) + "/attachments", { headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d) return;
        /* Same race, same guard: a file list arriving after the view moved belongs to a project the
         * trader is no longer looking at. */
        if (String(activeId()) !== String(id)) return;
        attachLimits = d.attachmentLimits || null;
        var eff = effectiveTypes(attachLimits, unverifiableFrom(d));
        text(root.querySelector("[data-q-drop-types]"), eff.length ? eff.join(" · ") : "");
        renderAttachments(d);
      })
      .catch(function () { /* the panel stays usable; a failed list is not a failed upload */ });
  }

  function wireUpload() {
    var input = root.querySelector("[data-q-file]");
    var drop = root.querySelector("[data-q-drop]");
    var msg = root.querySelector("[data-q-attach-status]");
    if (!input) return;
    var tell = function (t, tone) {
      if (!msg) return;
      msg.textContent = t || "";
      msg.className = "lfy-portal__addStatus" + (tone ? " is-" + tone : "");
    };

    function send(file) {
      if (!file || !activeId()) return;
      /* Checked here only to say so sooner; the server is still the authority and its refusal is
       * what is rendered. This never SUPPRESSES the request on a type — only on a size we know. */
      if (attachLimits && typeof attachLimits.maxBytes === "number" && file.size > attachLimits.maxBytes) {
        return tell(attachRefusal("file_too_large", file.name, attachLimits), "warn");
      }
      var base = String(root.getAttribute("data-endpoint")).replace(/\/$/, "");
      var fd = new FormData();
      fd.append("file", file, file.name);      // the part name the route reads
      tell("Sending “" + file.name + "”…", "");
      input.disabled = true;
      fetch(base + "/projects/" + encodeURIComponent(activeId()) + "/attachments", {
        method: "POST", credentials: "same-origin", body: fd,   // no Content-Type: the boundary is the browser's
      })
        .then(function (res) { return res.json().catch(function () { return {}; }).then(function (d) { return { status: res.status, d: d || {} }; }); })
        .then(function (r) {
          input.disabled = false;
          input.value = "";
          if (r.status === 200 || r.status === 201) {
            if (r.d.attachmentLimits) attachLimits = r.d.attachmentLimits;
            /* ⛔ count IS NULLABLE AND null MEANS THE COUNT FAILED — never 0. Same rule as
             * openCount. Saying "0 files attached" after a successful upload would be a visible
             * contradiction; saying nothing is merely quiet. */
            var n = r.d.count;
            tell(typeof n === "number"
              ? "Attached. This quote now has " + n + (n === 1 ? " file." : " files.")
              : "Attached.", "ok");
            loadAttachments(activeId());
            return;
          }
          tell(attachRefusal(r.d.reason, file.name, attachLimits), "warn");
        })
        .catch(function () {
          input.disabled = false;
          tell("We couldn't send that file. Please try again, or email ashfield@lightsforyou.com.au.", "err");
        });
    }

    input.addEventListener("change", function () { if (input.files && input.files[0]) send(input.files[0]); });
    if (drop) {
      ["dragenter", "dragover"].forEach(function (e) {
        drop.addEventListener(e, function (ev) { ev.preventDefault(); drop.classList.add("is-over"); });
      });
      ["dragleave", "drop"].forEach(function (e) {
        drop.addEventListener(e, function (ev) { ev.preventDefault(); drop.classList.remove("is-over"); });
      });
      drop.addEventListener("drop", function (ev) {
        var f = ev.dataTransfer && ev.dataTransfer.files && ev.dataTransfer.files[0];
        if (f) send(f);
      });
    }
  }

  function attachDeclared(d) {
    return Array.isArray(d && d.projectOps) && d.projectOps.indexOf("attach") !== -1;
  }

  function submitDeclared(d) {
    return Array.isArray(d && d.projectOps) && d.projectOps.indexOf("submit") !== -1;
  }

  /* ⛔ lastSubmitted — THE EXACT KEY, now that it has been named.
   *
   *   "lastSubmitted": { id, reference, status: "submitted", draftOrderName, lineCount }
   *   null when they have never submitted. Read-only.
   *
   * The name-then-shape scan I wrote while the key was unknown is GONE. It would have adopted ANY
   * future top-level object carrying a reference and a submitted status — a reader that guesses
   * correctly today and wrongly the moment the payload grows. A named contract is not a hint to be
   * pattern-matched against.
   *
   * Still defensive about the VALUE: null, a non-object, or one without a reference yields nothing
   * to show, because the alternative is rendering a confirmation with an empty quote number on it. */
  function lastSubmitted(d) {
    var v = d && d.lastSubmitted;
    return v && typeof v === "object" && v.reference ? v : null;
  }

  function writeLine(method, lineId, body, op, anchor) {
    var base = String(root.getAttribute("data-endpoint")).replace(/\/$/, "");
    return fetch(base + "/lines/" + encodeURIComponent(lineId), {
      method: method,
      headers: body ? { "Content-Type": "application/json", Accept: "application/json" } : { Accept: "application/json" },
      credentials: "same-origin",
      body: body ? JSON.stringify(body) : undefined,
    })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) { return { status: res.status, data: data || {} }; });
      })
      .then(function (r) {
        // ⛔ REASON FIRST. A gate denial 404s with an EMPTY body; a line that is gone 404s with
        // reason "unknown_line". Keyed on status alone the trader would be told the whole feature
        // is down when a colleague had simply already removed the line.
        var m = (window.LFY_TRADE && window.LFY_TRADE.messageFor)
          ? window.LFY_TRADE.messageFor(r.status, r.data.reason, op)
          : { tone: r.status === 200 ? "ok" : "err", text: r.status === 200 ? "Done." : "That didn't work." };
        say(m.text, m.tone, r.status === 200 ? null : anchor);
        if (r.status === 200 || r.data.reason === "unknown_line") afterWrite();
        /* ⛔ THE CALLER NEEDS THE OUTCOME. It used to resolve undefined, so every control that
         *    disabled itself before calling had no way to learn it should stop. */
        return r;
      })
      .catch(function () {
        say("That change couldn't be made. Please try again.", "err");
        /* A network failure is not a refusal, but for the CONTROL they are the same: the value
         * on screen was never accepted, so it must not stay there looking as though it was. */
        return { status: 0, data: {} };
      });
  }

  /* ⛔ THE STEPPER ALONE IS NOT A QUANTITY CONTROL. The founder: someone ordering 100 would click
   * + ninety-nine times. The steppers stay for a nudge of one or two; the number itself is now
   * typed, and commits ONCE on Enter or on leaving the field.
   *
   * ⛔ IT COMMITS ON CHANGE, NEVER ON KEYSTROKE. Typing "100" passes through 1 and 10 on the way,
   *    and a PATCH per keystroke would write both — leaving the project at whatever the last
   *    response happened to be if they raced. One value, once, when the trader has finished saying
   *    it.
   *
   * ⛔ AND IT CAN STILL NEVER SEND 0. Blank, zero, negative and non-numeric all revert to the value
   *    the server last reported rather than being sent for the API to reject. Removal stays an
   *    explicit act, which is the contract the app lane confirmed.
   */
  function qtyInput(line) {
    var i = document.createElement("input");
    /* ⛔ NOT type="number". Two reasons, and the first is the founder's: it draws NATIVE up/down
     * arrows beside the - and + buttons, so one value gets two controls. I tried hiding them with
     * ::-webkit-*-spin-button and the computed style even reported appearance:none, yet they kept
     * rendering -- a vendor pseudo-element I was measuring but evidently not defeating.
     *
     * A text input with inputmode="numeric" has no spinner to hide, still raises the numeric keypad
     * on a phone, and puts validation entirely in the change handler below rather than splitting it
     * between my code and the browser. It also makes non-numeric input TESTABLE: type="number"
     * refused a non-numeric fill outright, so that path could not be exercised through the UI and I
     * had to drop the assertion. Now it can be asserted. */
    i.type = "text";
    i.className = "lfy-portal__qtyInput";
    i.value = String(line.quantity);
    i.inputMode = "numeric";
    i.autocomplete = "off";
    i.setAttribute("pattern", "[0-9]*");
    i.setAttribute("aria-label", "Quantity of " + (line.title || line.sku || "this line"));
    i.addEventListener("keydown", function (e) { if (e.key === "Enter") { e.preventDefault(); i.blur(); } });
    i.addEventListener("change", function () {
      var raw = i.value.trim();
      var n = /^\d+$/.test(raw) ? parseInt(raw, 10) : NaN;
      if (!n || n < 1) {
        i.value = String(line.quantity);
        say("Enter a quantity of at least 1, or remove the line.", "warn");
        return;
      }
      if (n === line.quantity) return;   // nothing to say to the server
      /* ⛔ A REFUSED QUANTITY USED TO STAY ON SCREEN, IN A FIELD THAT COULD NEVER BE RE-ENABLED.
       *    The field disabled itself and called writeLine, which re-enabled on NO path: on
       *    success afterWrite() re-rendered the row and hid it, and on a 409 over the line cap
       *    the trader was left looking at the number the server had just rejected, unable to
       *    correct it. They would then send a quote priced on a quantity that was never accepted.
       *
       *    That is a data-integrity defect wearing a UI costume, and it is my own house rule
       *    broken on my own surface: a control that reports a state it does not enforce.
       *
       * ⛔ SO THE SCREEN REVERTS TO THE SERVER'S TRUTH, not to "whatever they typed". line.quantity
       *    is the value the last successful read reported, so a refusal leaves the field showing
       *    the quantity the project actually holds — and the message beside it says why. */
      i.disabled = true;
      writeLine("PATCH", line.id, { quantity: n }, "update", i).then(function (r) {
        i.disabled = false;
        if (!r || r.status !== 200) i.value = String(line.quantity);
      });
    });
    return i;
  }

  function stepBtn(label, line, next, disabled) {
    var b = document.createElement("button");
    b.type = "button";
    b.className = "lfy-portal__qtyBtn";
    b.textContent = label;
    b.disabled = !!disabled;
    b.setAttribute("data-line-id", line.id);
    b.setAttribute("data-next-quantity", String(next));
    b.setAttribute("aria-label", (label === "+" ? "Increase" : "Decrease") + " quantity of " + (line.title || line.sku || "this line"));
    b.addEventListener("click", function () {
      if (b.disabled) return;
      b.disabled = true;
      /* Same defect, same fix: the stepper disabled itself and nothing ever turned it back on
       * unless the write happened to succeed. A refused step left the control dead. */
      writeLine("PATCH", line.id, { quantity: next }, "update", b).then(function (r) {
        if (!r || r.status !== 200) b.disabled = !!disabled;
      });
    });
    return b;
  }

  /* ── Adding a product, which needs nothing from Cipzo but the endpoint that already works ──── */
  /* ⛔ EVERY WRITE ERROR USED TO RENDER IN ONE PLACE — the add panel at the top of the page —
   *    while the control that caused it could be anywhere. MEASURED: a failed edit on a 25-line
   *    project put the message at top:-1863 on a 900px viewport, and a failed "Send for pricing"
   *    at 1440 put it at top:-642. Both are off-screen. The trader presses something, nothing
   *    visibly happens, and the explanation is scrolled out of sight above them.
   *
   * ⛔ SO A MESSAGE CAN NOW NAME ITS OWN CONTROL. The panel status stays — it is the right place
   *    for anything about the project as a whole — and an anchored message ALSO appears beside
   *    the thing that was pressed. Only one anchored message exists at a time: a page dotted with
   *    stale errors from earlier attempts is its own kind of lie. */
  function say(msg, tone, anchor) {
    var el = root.querySelector("[data-portal-add-status]");
    if (el) {
      el.textContent = msg || "";
      el.className = "lfy-portal__addStatus" + (tone ? " is-" + tone : "");
    }
    root.querySelectorAll(".lfy-portal__inlineStatus").forEach(function (n) { n.remove(); });
    if (!anchor || !msg) return;
    var host = (anchor.closest && anchor.closest(".lfy-portal__line")) || anchor.parentNode;
    if (!host || !host.parentNode) return;
    var s = document.createElement("p");
    s.className = "lfy-portal__inlineStatus" + (tone ? " is-" + tone : "");
    s.setAttribute("role", "status");
    s.textContent = msg;
    host.parentNode.insertBefore(s, host.nextSibling);
  }

  /* ⛔ THE TARGET IS NAMED EXPLICITLY, ALWAYS. With one open project the server could infer it;
   *    with several it returns 409 ambiguous_project and writes nothing — measured on the real
   *    route, not inferred. The page KNOWS which project it is showing, so leaving the server to
   *    guess would be choosing on the trader's behalf and putting a light on the wrong job.
   *    projectId is the key: four other spellings were tried first and all four stayed 409,
   *    which is how I know the server ignored them rather than quietly accepting one. */
  function addLine(payload) {
    say("Adding…", "");
    if (openProjectId && !payload.projectId) payload.projectId = openProjectId;
    return fetch(String(root.getAttribute("data-endpoint")).replace(/\/$/, "") + "/lines", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify(payload),
    })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) { return { status: res.status, data: data || {} }; });
      })
      .then(function (r) {
        var m = (window.LFY_TRADE && window.LFY_TRADE.messageFor)
          ? window.LFY_TRADE.messageFor(r.status, r.data.reason, "add")
          : { tone: r.status === 200 ? "ok" : "err", text: r.status === 200 ? "Added to your project." : "That couldn't be added." };
        /* ⛔ STILL HANDLED, THOUGH THE LINE ABOVE SHOULD PREVENT IT. If projectId is ever absent
         *    or stale the trader must be asked, not guessed for. The candidates come off the
         *    refusal itself and carry id and name only — no reference — so the buttons say what
         *    the server said and invent nothing. */
        if (r.status === 409 && r.data.reason === "ambiguous_project") {
          return offerCandidates(r.data, payload);
        }
        /* ⛔ A MERGED ADD IS NOT A NEW LINE, AND SAYING "Added" HIDES WHAT HAPPENED.
         * The server merges a repeat add of the same variant by variant_id and reports it:
         *     POST /lines -> { ok:true, lineId, merged:true, quantity:N }
         * The PDP reads that flag (lfy-trade-project.js:295); this file did not read it at all.
         * Measured the hard way: three test runs added the same product at quantity 3 and the
         * project went 3 -> 6 -> 9 while the page said "Added to your project." every time, and
         * a line-count check saw no change and reported the adds as FAILURES. A trader doing the
         * same thing would believe they had three lines and have one at triple the quantity. */
        if (r.status === 200 && r.data.merged) {
          say(typeof r.data.quantity === "number"
            ? "Already on your project — quantity updated to " + r.data.quantity + "."
            : "Already on your project — quantity updated.", "ok");
        } else {
          say(m.text, m.tone);
        }
        if (r.status === 200) {
          /* ⛔ THE DIALOG STAYED OPEN AFTER EVERY ADD, AND NOTHING CLOSED IT.
           * closeAddModal() is called from exactly three places — leaving the project view, the
           * close button, and the scrim/Escape handler. Never from here. So a trader who added a
           * product was left looking at the search dialog over their own project, with no
           * indication the add had worked beneath it.
           *
           * The founder asked for exactly this: "we can remove the popup after adding and trader
           * can click add button again if they want to?" Reopening is one click on the same
           * masthead button, which showAdd() keeps visible.
           *
           * ⚠ I TOLD HIM THE EARLIER FIX ALREADY HANDLED THIS. It did not. I inferred it from the
           *   success branch running again after the ReferenceError was fixed, without reading
           *   what that branch actually does — it clears the results and the input, and stops.
           *
           * closeAddModal() clears the search box and the results itself, so the two lines that
           * used to do that by hand are gone rather than duplicated. */
          closeAddModal();
          afterWrite();
        }
      })
      /* ⛔ THIS CATCH DISCARDED THE ERROR, AND THAT IS WHY THE FOUNDER'S BUG TOOK ALL DAY.
       *
       * It took no argument, so every failure here — transport, or a throw anywhere in the chain —
       * produced one sentence with no trace of the cause. The founder reported "That couldn't be
       * added" three times and I proposed five different explanations, each ruled out by a later
       * measurement, because the one fact that would have settled it was being thrown away here.
       *
       * REPRODUCED 2026-09-15 on Q-260908-005: POST returned 200 with a real lineId, the server
       * HELD the line, and this catch still fired — so the rejection came from AFTER the response,
       * inside the promise chain, not from the request. window.fetch on this storefront is not
       * native: something wraps it and does document.createElement work in the response path. A
       * throw in that wrapper rejects the promise we are awaiting even though the write succeeded.
       *
       * The trader is then told the add failed, invited to retry, and the success branch never
       * runs — so clearResults(), afterWrite() and the repaint are all skipped. One throw, three
       * symptoms, and the stale "1 line" heading he also reported is the same root cause.
       *
       * The error is now logged. It does not change what the trader sees, but the next person to
       * meet this has the exception instead of a sentence. */
      .catch(function (err) {
        try { console.error("[lfy-portal] add failed after the request:", err); } catch (e) {}
        say("That couldn't be added. Please try again.", "err");
      });
  }

  /* Nothing was written when this arrives — the refusal says so and the line counts confirmed it. */
  function offerCandidates(data, payload) {
    var box = root.querySelector("[data-portal-results]");
    var list = Array.isArray(data.candidates) ? data.candidates : [];
    if (!box || !list.length) {
      return say("You have more than one project open, so we didn't want to guess. Open the project you want and add it there.", "warn");
    }
    say("Which project is this for? Nothing has been added yet.", "warn");
    box.textContent = "";
    box.hidden = false;
    list.forEach(function (pj) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "lfy-portal__result lfy-portal__candidate";
      /* Same rule as the rows above: the reference leads when the wire carries one, and the name
       * stands alone until it does. A chooser is exactly where a trader needs the Q-number. */
      b.textContent = pj.reference
        ? pj.reference + " \u2014 " + (pj.name || "Untitled project")
        : (pj.name || "Untitled project");
      b.addEventListener("click", function () {
        var again = {};
        for (var k in payload) if (Object.prototype.hasOwnProperty.call(payload, k)) again[k] = payload[k];
        again.projectId = pj.id;
        addLine(again);
      });
      box.appendChild(b);
    });
    /* ⛔ THE CAP IS THE SERVER'S AND THE CHOOSER MUST ADMIT IT. A short list that looks complete
     *    invites a trader to conclude the project they want no longer exists. */
    if (data.candidatesTruncated === true) {
      var note = document.createElement("p");
      note.className = "lfy-portal__resultNone";
      note.textContent = "Not all of your open projects fit here. If the one you want is missing, open it first and add the product there.";
      box.appendChild(note);
    }
  }

  function clearResults() {
    var box = root.querySelector("[data-portal-results]");
    if (!box) return;
    box.textContent = "";
    box.hidden = true;
  }

  function renderResults(products) {
    var box = root.querySelector("[data-portal-results]");
    if (!box) return;
    box.textContent = "";
    if (!products.length) {
      var none = document.createElement("p");
      none.className = "lfy-portal__resultNone";
      none.textContent = "No products matched.";
      box.appendChild(none);
      box.hidden = false;
      return;
    }
    products.forEach(function (p) {
      var row = document.createElement("div");
      row.className = "lfy-portal__result";
      if (p.image) {
        var img = document.createElement("img");
        img.className = "lfy-portal__resultImg";
        img.src = p.image;
        img.alt = "";
        img.loading = "lazy";
        row.appendChild(img);
      }
      var t = document.createElement("span");
      t.className = "lfy-portal__resultTitle";
      // ⛔ TITLE ONLY. p.price exists in this payload and must never be read (D9).
      t.textContent = p.title;
      row.appendChild(t);

      var pick = document.createElement("div");
      pick.className = "lfy-portal__resultPick";
      row.appendChild(pick);

      // Same reason as the line input: a trader who needs 100 should say 100 once, not add one and
      // then press + ninety-nine times on the row below.
      var qtyIn = document.createElement("input");
      qtyIn.type = "text";   // same reason as the line input: no native spinner to fight
      qtyIn.className = "lfy-portal__resultQty";
      qtyIn.value = "1";
      qtyIn.inputMode = "numeric";
      qtyIn.autocomplete = "off";
      qtyIn.setAttribute("pattern", "[0-9]*");
      qtyIn.setAttribute("aria-label", "Quantity of " + p.title);
      row.appendChild(qtyIn);

      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "lfy-portal__resultAdd";
      btn.textContent = "Add";
      btn.addEventListener("click", function () {
        btn.disabled = true;
        fetch("/products/" + p.handle + ".js", { credentials: "same-origin" })
          .then(function (r) { return r.json(); })
          .then(function (prod) {
            var vs = prod.variants || [];
            if (vs.length > 1 && !pick.querySelector("select")) {
              // More than one variant: ASK. Adding "whichever came first" is the same silent
              // choice between valid targets that D46 exists to forbid.
              var sel = document.createElement("select");
              sel.className = "lfy-portal__resultVariant";
              sel.setAttribute("aria-label", "Choose an option for " + prod.title);
              vs.forEach(function (v) {
                var o = document.createElement("option");
                o.value = String(v.id);
                o.textContent = v.title;
                sel.appendChild(o);
              });
              pick.appendChild(sel);
              btn.disabled = false;
              btn.textContent = "Add this option";
              return;
            }
            /* ⛔ THIS DEREFERENCED A SELECT THAT MAY NOT BE THERE, AND THE THROW WAS INVISIBLE.
             *    `pick.querySelector("select").value` has no null guard. On a multi-variant
             *    product the FIRST click appends the select and returns; the SECOND click reads
             *    it. Anything that removes the results list between those two clicks leaves
             *    querySelector returning null, and `.value` throws a TypeError.
             *
             *    clearResults() empties the whole list and is called from three places, one of
             *    which is wireSearch's input handler when the query drops below two characters —
             *    so a trader who backspaces their search between clicks detaches the row, the
             *    select goes with it, and the next click throws.
             *
             *    THE THROW IS WHY THE MESSAGE WAS WRONG. It propagates to addLine's outer .catch,
             *    which prints "That couldn't be added. Please try again." — the sentence reserved
             *    for a transport failure. Nothing was sent, nothing was refused, and the trader is
             *    told to retry an action that will throw again in the same way.
             *
             * ⚠ NOT YET CONFIRMED AS THE FOUNDER'S CASE. He reports the error while a product is
             *   adding, which sounds like one click rather than two. This is a real latent fault
             *   on its own merits and is fixed here regardless; whether it is HIS fault is a
             *   separate question that needs the runtime error captured. */
            var selEl = pick.querySelector("select");
            if (vs.length > 1 && !selEl) {
              btn.disabled = false;
              say("Choose an option first, then press Add.", "warn");
              return;
            }
            var chosen = vs.length > 1 ? vs.filter(function (v) { return String(v.id) === selEl.value; })[0] : vs[0];
            if (!chosen) { btn.disabled = false; say("That product has no options available.", "warn"); return; }
            var want = /^\d+$/.test(qtyIn.value.trim()) ? parseInt(qtyIn.value, 10) : 0;
            if (!want || want < 1) { btn.disabled = false; say("Enter a quantity of at least 1.", "warn"); return; }
            return addLine({
              productId: String(prod.id),
              variantId: String(chosen.id),
              sku: chosen.sku || null,
              title: prod.title || null,
              quantity: want,
            }).then(function () { btn.disabled = false; });
          })
          .catch(function () { btn.disabled = false; say("Couldn't load that product's options.", "err"); });
      });
      row.appendChild(btn);
      box.appendChild(row);
    });
    box.hidden = false;
  }

  /* Submit. The name is offered again here because this is the LAST point at which it can be
   * corrected: projectName is applied at lock time and there is no rename AFTER LOCK. Pre-filled
   * with the current name so a trader who is happy simply presses the button.
   *
   * ⚠️ WORDING CORRECTED 2026-09-13, because the previous phrasing ("there is no rename
   *    afterwards") read as "this codebase has no rename mechanism at all" and sent a peer lane
   *    hunting a contradiction against `wireRename` below. There is no contradiction:
   *      · rename IS offered on an open draft — `wireRename` (:2392) PATCHes /trade/project
   *      · it is gated on the SERVER declaring it: `renameDeclared` (:2388) requires
   *        projectOps to contain "rename", the button ships `hidden` in the markup, and
   *        :3201 hides it again on every read that does not declare it
   *      · the control withdraws ITSELF at lock, with no theme deploy and no status reasoning
   *        here — because "rename" leaves projectOps, NOT because the array empties.
   *        ⛔ MEASURED AT THE WIRE 2026-09-13, correcting my own first draft of this note:
   *             Q-260913-002  draft   projectOps ["submit","rename","comment","attach"]
   *             Q-260913-001  quoted  projectOps ["comment","attach"]
   *           A locked project does NOT return []. `tradeProjectOperations.ts:260` filters out
   *           only the operations carrying `requiresEditableProject: true` — submit and rename
   *           withdraw; comment and attach SURVIVE, because a trader can still talk to us and
   *           attach a schedule against a quoted job.
   *        ⇒ Do not predict an empty array here. The gating works per-OPERATION, and a reader
   *           expecting [] would misread a perfectly healthy two-entry payload as a bug.
   *        ✅ MEASURED 2026-09-13, a submitted project too — identical to quoted:
   *             submitted  ["comment","attach"]   ·   quoted  ["comment","attach"]
   *           So a trader whose project is WITH US FOR PRICING can still comment and attach.
   *           Both carry `requiresEditableProject: false` by design; that is the capability, not
   *           a leak. (It also disproves a comment in `tradeProjectOperations.ts` claiming a
   *           submitted project returns [] — same half-stale shape, the app lane's to fix.)
   *        ⚠️ BUT `[]` IS STILL A REAL STATE, and this note must not over-correct into implying
   *           it never happens: the HUB with NO OPEN PROJECT returns projectOps [] with
   *           lineOps ["add"] — the `null` branch, which is correct and documented. ⇒ "Locked
   *           does not empty it" and "it is never empty" are different claims; only the first
   *           is true.
   *    ⇒ Both sentences are true of different moments, which is precisely why the old one had
   *    to say WHICH moment. A comment that is true only under a qualifier it omits is the same
   *    defect class as a figure quoted without its population.
   *
   * ✅ CONFIRMED ON THE ROUTE by the app lane, so this is measured rather than inferred:
   *      app/api/proxy/trade/project/route.ts:111  calls renameProject() — the endpoint is REAL
   *                                          :37   409 reason "project_locked" for
   *                                                submitted / quoted / won / lost / archived
   *                                          :122  maps that reason to the 409
   *    ⇒ The SERVER enforces the lock; the theme's projectOps gating merely stops us offering a
   *    control that would be refused. Two independent guards, deliberately.
   *
   * 🔑 WHY THIS SURVIVED SO LONG, and it is the transferable part: the old comment was HALF true.
   *    "there is no rename afterwards" is CORRECT post-lock. A reader who checks it against the
   *    locked case finds it accurate and stops. ⇒ A half-stale comment is harder to catch than a
   *    wholly wrong one, because the first thing you test confirms it. Sibling of "an accurate
   *    record of a FIXED bug is indistinguishable from a report of a LIVE one": an accurate
   *    record of ONE branch, read as a claim about ALL branches. */
  function wireSubmit() {
    var btn = root.querySelector("[data-portal-submit]");
    if (!btn) return;
    btn.addEventListener("click", function () {
      var current = (root.querySelector("[data-project-name]") || {}).textContent || "";
      if (current === "Untitled project") current = "";
      var name = window.prompt(
        "Send this project for pricing?\n\nName it so you can find it later — this is the last chance to change it.",
        current
      );
      if (name === null) return;   // cancelled: nothing is sent, nothing is locked
      /* ⛔ DISABLED IS NOT FEEDBACK. During an in-flight submit the ONLY thing that changed was
       *    the disabled attribute — the label still read "Send for pricing" and the status line
       *    was empty, so on a slow connection a trader has pressed the most consequential button
       *    on the page and been shown nothing at all. They press again, or they leave. */
      var restore = btn.textContent;
      btn.textContent = "Sending\u2026";
      btn.disabled = true;
      var body = {};
      var trimmed = String(name).trim().slice(0, 200);
      if (trimmed) body.projectName = trimmed;
      /* ⛔ NAME THE PROJECT, THE WAY addLine ALREADY DOES (see its note above). Without this the
       *    server falls to the single-open-project rule, and a trader with more than one open
       *    draft got 409 ambiguous_project — writing nothing, and returning candidates this
       *    handler then threw away. The page KNOWS which project it is showing; leaving the
       *    server to guess was choosing on the trader's behalf. */
      if (openProjectId) body.projectId = openProjectId;
      sendSubmit(btn, restore, body);
    });
  }

  /* ⛔ THE SUBMIT POST, EXTRACTED SO IT CAN BE CALLED TWICE — once by the button, once by a
   *    candidate in the chooser below. A second copy of this fetch is how the two would drift.
   *
   * ⛔ AND 409 ambiguous_project IS NOW HANDLED HERE. It was not, and that was a live defect: any
   *    trader holding two or more open drafts could not submit ANY of them. The server refuses
   *    safely, writes nothing, and hands back every candidate with its id and reference —
   *    everything needed to ask the question — and this handler dropped the lot, leaving the
   *    trader a sentence telling them to choose with nothing to choose from.
   *
   *    Measured 2026-09-14 on the QA account with three open drafts. `projectId` is the documented
   *    idempotency key: re-POSTing with the chosen candidate's id resolves that owned project
   *    directly, and answers `unknown_project` if it is not the caller's. No new route. */
  function sendSubmit(btn, restore, body) {
    var base = String(root.getAttribute("data-endpoint")).replace(/\/$/, "");
    fetch(base + "/submit", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify(body),
    })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) { return { status: res.status, data: data || {} }; });
      })
      .then(function (r) {
        if (btn) { btn.textContent = restore; btn.disabled = false; }
        if (r.status === 409 && r.data.reason === "ambiguous_project") {
          return offerSubmitCandidates(r.data, body);
        }
        var m = (window.LFY_TRADE && window.LFY_TRADE.messageFor)
          ? window.LFY_TRADE.messageFor(r.status, r.data.reason, "submit")
          : { tone: r.status === 200 ? "ok" : "err", text: r.status === 200 ? "Sent for pricing." : "That couldn't be sent." };
        say(m.text, m.tone, r.status === 200 ? null : btn);
        if (r.status === 200) afterWrite();
      })
      .catch(function () {
        if (btn) { btn.textContent = restore; btn.disabled = false; }
        say("That couldn't be sent. Please try again.", "err", btn);
      });
  }

  /* ⛔ NOT [data-portal-results], WHICH IS WHERE addLine's CHOOSER GOES. That element now lives
   *    INSIDE the add dialog, and the dialog is closed when Send for pricing is pressed — so a
   *    submit chooser rendered there would be invisible, and the trader would be told to choose
   *    while nothing appeared. The defect one layer along from the one being fixed.
   *
   *    This renders next to the submit button itself, which is always on screen when it matters. */
  function offerSubmitCandidates(data, body) {
    var host = root.querySelector("[data-submit-choose]");
    var list = Array.isArray(data.candidates) ? data.candidates : [];
    if (!host || !list.length) {
      return say("You have more than one project open, so we didn't want to guess which to send. Open the one you want and send it from there.", "warn");
    }
    say("Which project should we price? Nothing has been sent yet.", "warn");
    host.textContent = "";
    host.hidden = false;
    list.forEach(function (pj) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "lfy-portal__result lfy-portal__candidate";
      b.textContent = pj.reference
        ? pj.reference + " — " + (pj.name || "Untitled project")
        : (pj.name || "Untitled project");
      b.addEventListener("click", function () {
        var again = {};
        for (var k in body) if (Object.prototype.hasOwnProperty.call(body, k)) again[k] = body[k];
        again.projectId = pj.id;
        host.hidden = true;
        host.textContent = "";
        say("Sending…", "");
        sendSubmit(null, null, again);
      });
      host.appendChild(b);
    });
    /* The server's cap, admitted rather than hidden — a short list that looks complete invites a
       trader to conclude the project they want is gone. */
    if (data.candidatesTruncated === true) {
      var note = document.createElement("p");
      note.className = "lfy-portal__resultNone";
      note.textContent = "Not all of your open projects fit here. If the one you want is missing, open it and send it from there.";
      host.appendChild(note);
    }
  }

  /* The button cannot create anything — a project begins with its first product — so it does the
   * one thing that helps: brings the search into view and puts the cursor in it. Anything more
   * would be a control that appears to do something the server has no endpoint for. */
  /* ── Views ────────────────────────────────────────────────────────────────────────────────
   * The rail switches between four views on one page rather than four pages. Project is the
   * default; the others are built to completion with their wiring points stated. */
  var VIEWS = ["project", "history", "account", "attach", "quote"];

  /* ── ADDRESSING A PROJECT ───────────────────────────────────────────────────────────────────
   *
   * The open project had no address at all: every sent quote was #quote/<uuid> and the one the
   * trader is actually building sat at the bare page. The founder asked for it, and he asked in
   * the same breath why the URL was not dynamic — which is the same question.
   *
   * ⛔ THE ADDRESS IS THE REFERENCE, NOT THE UUID. Measured before choosing: the route resolves
   *    Q-260908-003 to exactly the same project as its uuid, and REFUSES a fabricated reference
   *    and a plausible one belonging to somebody else — 404 unknown_project on both. So it is a
   *    real address and a DISCRIMINATING one, not a route that answers 200 to anything.
   *
   * ⚠ AND IT IS CASE-SENSITIVE: q-260908-003 in lower case 404s. A fragment is never case-folded
   *   by the browser, but a trader retyping one is, so a reference-shaped token is normalised to
   *   upper case before it is used. A uuid is NOT — uuids are lower case and folding one breaks it.
   *
   * ⚠ SIDE EFFECT THE FOUNDER CHOSE DELIBERATELY: the uuids were what reached analytics.google.com
   *   through location.href. References carry no such identifier, so this retires the parked GA
   *   question rather than adding a second uuid to it.
   *
   * ⛔ THE UUID FORM IS STILL ACCEPTED, FOREVER. #quote/<uuid> links are sitting in quote emails
   *    already sent. The server takes either, so both are routed and only the DISPLAYED url changes. */
  /* ⛔ THE AUTHORITATIVE GRAMMAR, read from the single parser rather than inferred from rows.
   *    I have had this wrong twice in opposite directions in one day, which is what guessing a
   *    format from the examples in front of you produces:
   *      1st  /^q-\d{6}-\d{3}$/       too NARROW — three literal defects, see below
   *      2nd  /^q-[a-z0-9-]+$/i        too WIDE — accepted a row the server itself cannot address
   *
   *    ① THE PREFIX IS A MANIFEST KNOB, 1-8 alphanumerics — not the literal "Q". Correct for LFY
   *      today and broken for the first merchant whose owner sets their own.
   *    ② THE SEQUENCE IS \d+, NOT \d{3}. The padding is a knob and the formatter deliberately
   *      does not truncate past it: under padding 3, quote 1000 is -1000. A \d{3} client breaks
   *      on the 1000th quote of a single day — on the busiest day a merchant ever has.
   *    ③ THE MIDDLE SIX ARE A DATE, YYMMDD. Displayable; never assume it increments.
   *
   * ⛔ AND IT IS DELIBERATELY NOT WIDENED FOR Q-ZZTEST-391. That row fails the SERVER's own
   *    resolver — ZZTEST is not six digits — so it is unaddressable by reference from any
   *    surface including ours, and it reached the founder's live account by a direct write that
   *    bypassed the only writer. A row our own server cannot address must not be addressable
   *    here either; matching it would hide their defect behind my leniency. Being cleaned up by
   *    the app lane.
   *
   * ⚠ THE PARSER ACCEPTS LOWER CASE AND THE ROUTE STILL 404s ON IT — measured, q-260908-003
   *   returns unknown_project. Parsing is not resolving, so the upper-casing stays.
   * ⚠ RESIDUAL RISK, ACCEPTED AND NAMED: upper-casing a merchant-defined MIXED-case prefix would
   *   corrupt it. LFY's prefix is "Q" and this theme serves one merchant, so it cannot bite here;
   *   the moment a second merchant runs this file, normalise by retrying the read instead. */
  var REF_SHAPE = /^[a-z0-9]{1,8}-\d{6}-\d+$/i;
  function normaliseToken(t) {
    var s = String(t || "").trim();
    return REF_SHAPE.test(s) ? s.toUpperCase() : s;
  }
  /* The reference when the wire has given us one, the id when it has not — a project without a
   * reference yet is still addressable, just not readably. Never invents one. */
  function addressOf(pr) {
    if (!pr) return null;
    return pr.reference || pr.id || null;
  }
  var openProjectRef = null;
  /* ⛔ FALSE ONLY FOR THE FIRST PROJECT READ OF A PAGE LOAD, so that read cannot stamp the URL.
   * ⚠️ SEEDED TRUE WHEN THE PAGE WAS OPENED WITH A HASH: a trader who ARRIVED at
   * #project/Q-… or #quote/Q-… asked for that thing by name, so the address is already theirs and
   * must survive the read that confirms it. Only a BARE /pages/my-project starts false.
   * ⇒ The flag is about "did the trader name something", not about timing. */
  var urlStampedOnLoad = (location.hash || "").length > 1;
  function setUrl(hash) {
    try { history.replaceState(null, "", hash || location.pathname); } catch (e) {}
  }
  /* ⛔ replaceState DOES NOT FIRE hashchange, which is exactly why it is used here — writing the
   *    address must not re-route the page it is describing. */
  function syncProjectUrl() {
    if (currentView !== "project") return;
    var a = openProjectRef || openProjectId;
    setUrl(a ? "#project/" + a : null);
  }
  var quoteId = null;

  /* ⛔ THE COMMENT AND ATTACH PANELS ARE NOT THE QUOTE'S — THEY ARE THE PROJECT'S. They were
   * built on the quote view and keyed off `quoteId`, so a trader on their own OPEN PROJECT had
   * neither, while the wire declared projectOps ["submit","rename","comment","attach"] on it.
   * The founder created a project to add a note and a schedule and reported the page as locked:
   * the capability was declared and the client did not offer it. Built-and-unreachable, mine.
   *
   * So the panels follow the surface. `activeId()` is the project they act on — the quote being
   * read, or the open project. Nothing else changes; every POST target already went through it. */
  var openProjectId = null;
  /* Which project the QUOTE VIEW is reading. Separate from openProjectId (the open DRAFT project)
     because both can be true at once and they mark different rows in the rail. */
  var openQuoteProjectId = null;
  function activeId() { return currentView === "quote" ? quoteId : openProjectId; }

  /* ⛔ MOVED HERE FROM THE TOP OF THE FILE, AND THE MOVE IS THE FIX.
   *
   * Founder, three times: "That couldn't be added. Please try again." — while the line was being
   * saved every time. Reproduced on Q-260908-005: POST /lines returned 200 with a real lineId,
   * the server held the line (0 -> 1), and the page still printed the failure message and left
   * the heading at "0 lines".
   *
   * The cause was invisible until the .catch was made to log its error:
   *     ReferenceError: openProjectRef is not defined   at afterWrite
   * In the DEPLOYED bundle, afterWrite referenced `openProjectRef`, `openProjectId` and
   * `loadProjectInto` — three identifiers that are declared NOWHERE in that file. The minifier
   * had renamed the real bindings to openProjectRef2 / openProjectId2 / loadProjectInto2 and left
   * afterWrite pointing at names that do not exist. Measured across the bundle: every other
   * function that touches them (addLine, resolvePendingProject, syncProjectUrl, activeId,
   * renderOtherDrafts) reads the suffixed binding correctly. afterWrite was the only one broken.
   *
   * ONE THROW, ALL THREE SYMPTOMS: the error message (the exception fell into addLine's .catch,
   * which prints the transport-failure sentence), the stale heading (the success branch never ran,
   * so no repaint), and the dialog staying open (same skipped branch — which is why the founder
   * asked whether the popup should close after adding; it already should, and now will).
   *
   * ⚠️ I DO NOT HAVE A CONFIRMED EXPLANATION FOR THE RENAME, and I stopped inventing ones after
   *    six wrong theories. What is MEASURED is the pattern: every working function is declared
   *    AFTER these vars; the one function declared before them was the one that threw. This moves
   *    it to match the shape that demonstrably works, and the fix is verified by re-running the
   *    reproduction rather than by the story I would tell about it. Function declarations hoist,
   *    so all three call sites keep working from their current positions.
   *
   * ⛔ The header count refresh stays paired with the reload: they came apart once before, and the
   *    detached one ended up after a brace-less if where the indentation lied about it. */
  function afterWrite() {
    /* ⛔ THE OPEN READ REPOINTS THE SURFACE OUT FROM UNDER A LINKED DRAFT.
     *
     * reload() fetches GET /trade, which always describes the SERVER's current project, and two
     * lines in it run unconditionally:
     *     openProjectId  = d.project ? d.project.id : null;
     *     openProjectRef = d.project ? addressOf(d.project) : null;
     * So on a draft opened by link, every write flips the page's identity back to the current
     * project and paintProject(d) paints that project's name, reference and line count over the
     * draft on screen; syncProjectUrl() then rewrites the address from the same flipped ref.
     *
     * Precondition measured, not assumed: this account's current project is Q-260909-001 while
     * Q-260908-005 is a separate draft, so the two ids genuinely differ (whichcurrent.mjs).
     *
     * ⇒ THE FLIP IS ITSELF THE SIGNAL. Capture the surface's address BEFORE the read lands; if the
     *   read moved it, the screen belongs to a project this read does not describe, so re-open it.
     *
     * ⚠ SUBMIT NEEDS NO SPECIAL CASE. loadProjectInto() re-asks the server for lineOps every call,
     *   so a just-submitted project returns non-editable and routes to the reader by itself.
     *
     * ⚠ AND IT ONLY FIRES ON A FLIP, so a write to the current project costs no second fetch. */
    var owned = openProjectRef || openProjectId;
    var done = reload();
    if (done && typeof done.then === "function") {
      done.then(function () {
        var now = openProjectRef || openProjectId;
        if (owned && String(now) !== String(owned)) loadProjectInto(owned);
      });
    }
    if (window.LFY_TRADE && window.LFY_TRADE.refreshCount) window.LFY_TRADE.refreshCount();
  }
  /* ⛔ MOVED, NEVER RE-RENDERED — the same discipline as the selector rail. A fresh render would
   * orphan every listener bound to the compose box and the file input. A comment marks each
   * panel's original position so the move is reversible in both directions. */
  var openProjectData = null;

  /* ⛔ REMEMBERED BECAUSE THE DETAIL ROUTE DOES NOT CARRY IT. GET /projects/:id answers with 17
   *    top-level keys — measured — and otherDrafts is not among them; it belongs to the OPEN read
   *    (GET /trade), which is the only place that knows which project is current and which are the
   *    rest. So when a trader opens an editable draft from a link, the panel has to be repainted
   *    from what the open read already told us, or it keeps the previous project's rows under the
   *    new one's heading — which is exactly what the founder screenshotted.
   *
   * ⚠️ THIS IS REMEMBERED, NOT RE-READ, AND THAT HAS ITS OWN STALENESS. If a draft is created in
   *    another tab after this page loaded, the list here will not know. That is strictly better
   *    than a sentence naming the wrong project, and cheaper than a second fetch on every open —
   *    but it is a trade, not a fix, and the next person should know which one it is. */
  var lastOtherDrafts = [];
  var lastOtherDraftsTruncated = false;

  /* ⛔ THE STATUS PILL HAS TO BE LOOKED UP, BECAUSE otherDrafts DOES NOT CARRY ONE. Measured on the
   *    live wire, signed in: an otherDrafts row is exactly
   *        ["id", "name", "createdAt", "reference"]      — no status
   *    while a /projects row carries thirteen fields including status. So a pill written straight
   *    from pj.status is skipped by its own guard and renders NOTHING — which is what shipped in my
   *    first attempt at the founder's "show quote number with status pill", and what the panel
   *    probe then caught.
   *
   *    /projects is already fetched on every load by loadHistory(), and its list was being handed
   *    to two renderers and then dropped. Kept here instead: no new request, one source, and the
   *    pill cannot disagree with the one Quote history draws from the same rows. */
  var lastProjects = [];
  function statusOf(id) {
    for (var i = 0; i < lastProjects.length; i++) {
      if (String(lastProjects[i].id) === String(id)) return lastProjects[i].status || null;
    }
    return null;
  }

  /* ⛔ MOVING A PANEL MOVES ITS PROSE AND ITS ROWS. Founder screenshot: heading Q-260908-003,
   *    attach panel "Files you add here join Q-260908-002", after the ordinary journey of
   *    project -> a sent quote -> back to the project. Reproduced in three steps.
   *
   *    The upload TARGET was right the whole time — activeId() follows the view — so the file
   *    would have gone to the correct project. That is worse, not better: the label and the file
   *    list described one quote while the action used another, and the trader has no way to see
   *    which one is lying.
   *
   * ⛔ THE COMMENT THREAD HAD THE SAME EXPOSURE and is repainted here too. My earlier stale-guard
   *    stops a LATE RESPONSE painting the wrong thread; it does nothing about a thread that is
   *    already on screen and simply moved house. Two different faults with one appearance.
   *
   * Nothing is fetched or painted until a read has landed — before that both sources are null and
   * this does nothing, which is correct: there is no truth to repaint yet. */
  function repaintPanels(view) {
    if (view === "project") {
      if (!openProjectData) return;
      paintAttachPanel(openProjectData);
      if (openProjectId) loadComments(openProjectId, null);
      return;
    }
    if (view === "quote" && lastQuote) {
      paintAttachPanel(lastQuote);
      if (quoteId) loadComments(quoteId, lastQuote);
    }
  }

  /* ⛔ TWO INDEPENDENT GATES, AND THEY MUST NOT BE COLLAPSED INTO ONE. This one asks "is this
   *    the project screen, and is there a project" — a question about the SURFACE. The submit
   *    button inside keeps its own gate, which asks whether the server DECLARED submit and
   *    whether there is anything to price. Showing the container never shows the button. */
  /* ⛔ THE READ RETURNS ONE PROJECT AND A LIST OF THE REST. Before the founder's ruling there was
   *    only ever one, so `otherDrafts` had nothing in it and I never rendered it. The moment a
   *    second project exists the page shows one job and silently omits the other — and the one it
   *    omits may be the one with the products on it. A trader cannot act on what they cannot see.
   *
   * ⚠ WHAT THIS CANNOT DO YET, AND SAYS SO RATHER THAN PRETENDING: the detail read for an open
   *   draft declares projectOps ["comment","attach"] and lineOps [] — so another draft can be
   *   READ but not edited, and this page will not fake a capability the server did not declare.
   *   Raised with the app lane. Until it lands, the honest sentence is that products go to the
   *   project shown above, and here are your others.
   *
   * ⛔ ROWS CARRY id, name, createdAt AND NO REFERENCE — measured, not assumed. So the row is
   *    named by its name and dated by its date, and nothing invents a Q-number for it. */
  /* One control, both empty screens. It goes to the project view rather than inventing a second
   * way to start a project — the start form already lives there and is the only writer. */
  function startHereLink() {
    var a = document.createElement("a");
    a.className = "button button--primary lfy-portal__submit lfy-portal__startHere";
    a.setAttribute("href", location.pathname);
    a.setAttribute("data-open-project", "");
    a.textContent = "Start your first project";
    return a;
  }

  function renderOtherDrafts(d) {
    var box = root.querySelector("[data-other-drafts]");
    if (!box) return;
    var list = Array.isArray(d && d.otherDrafts) ? d.otherDrafts : [];
    box.textContent = "";
    box.hidden = !list.length;
    if (!list.length) return;

    var lead = document.createElement("p");
    lead.className = "lfy-portal__muted";
    /* ⛔ "THE PROJECT ABOVE" WAS A POSITIONAL CLAIM ABOUT A TARGET THAT IS NOT POSITIONAL.
     *    Products go to openProjectId, which is now repointed whenever a trader opens an editable
     *    draft from a link — so the sentence could name the wrong job while being literally true
     *    about layout. The founder hit exactly that: on Q-260908-004 the panel sat at the top
     *    saying "the project above" and listing Q-260908-003.
     *
     *    Naming the project cannot drift: it is read from the same variable the write path uses.
     *    Falls back to the old wording only when there is no reference to name, rather than
     *    inventing a Q-number the wire has not given us. */
    var target = openProjectRef || (openProjectData && openProjectData.project && openProjectData.project.name) || null;
    var goesTo = target ? "Products you add go to " + target + "." : "Products you add go to the project shown above.";
    lead.textContent = (list.length === 1
      ? "You have one other project open. "
      : "You have " + list.length + " other projects open. ") + goesTo;
    box.appendChild(lead);

    list.forEach(function (pj) {
      var a = document.createElement("a");
      a.className = "lfy-portal__qhRow is-openable";
      a.setAttribute("href", "#project/" + pj.id);
      /* ⛔ THE REFERENCE IS SHOWN WHEN THERE IS ONE AND NEVER INVENTED WHEN THERE IS NOT. These
       *    rows carry id, name and createdAt today — measured — and the app lane is adding
       *    `reference` to them. Absent behaves exactly as it does now, so this needs no second
       *    deploy and cannot claim a Q-number before the wire carries one. */
      if (pj.reference) {
        var rf = document.createElement("span");
        rf.className = "lfy-portal__qhRef";
        rf.textContent = pj.reference;
        a.appendChild(rf);
      }
      var nm = document.createElement("span");
      nm.className = pj.reference ? "" : "lfy-portal__qhRef";
      nm.textContent = pj.name || "Untitled project";
      var meta = document.createElement("span");
      meta.className = "lfy-portal__qhMeta";
      var started = fmtDate(pj.createdAt);
      meta.textContent = started ? "started " + started : "";
      a.appendChild(nm); a.appendChild(meta);
      /* The status pill these rows never had, built exactly as the history rows build theirs
       * (renderHistory, same class and the same enum-to-class rule) so the two surfaces cannot
       * describe the same project differently. Absent when the wire sends no status — the pill
       * reports, it does not infer. */
      /* pj.status first for the day the wire carries one, then the looked-up list. Absent from
       * both means no pill at all — it reports, it never infers. */
      var pjStatus = pj.status || statusOf(pj.id);
      if (pjStatus) {
        var st = document.createElement("span");
        st.className = "lfy-portal__chip is-" + String(pjStatus).toLowerCase().replace(/[^a-z]+/g, "-");
        st.textContent = pjStatus;
        a.appendChild(st);
      }
      box.appendChild(a);
    });

    /* ⛔ A TRUNCATED LIST THAT LOOKS COMPLETE IS THE FALSE-COMPLETENESS SHAPE. The cap is the
     *    server's, so the page says the list is short rather than implying it is all of them. */
    if (d.otherDraftsTruncated === true) {
      var more = document.createElement("p");
      more.className = "lfy-portal__muted";
      more.textContent = "You have more open projects than are shown here \u2014 Quote history lists them all.";
      box.appendChild(more);
    }
  }

  /* ⛔ THE BOX NO LONGER REQUIRES AN OPEN PROJECT, BECAUSE "New project" LIVES IN IT.
   *    The old gate was `currentView === "project" && openProjectId` — correct while the box held
   *    only Print and Send for pricing, both of which act ON a project. But the founder asked for
   *    the New project button up here, and the states where that button matters most are `empty`
   *    and `submitted`: precisely the two with NO open project, where this gate hid the whole box.
   *
   *    So the box shows on the project view, and each control inside keeps its own gate — Print
   *    and Send are painted elsewhere from projectOps, and New project from showAdd(). A container
   *    that hides its contents' gating is how a control becomes unreachable without anyone
   *    editing the control. */
  function paintMastheadActions() {
    var box = root.querySelector("[data-masthead-actions]");
    if (!box) return;
    box.hidden = currentView !== "project";
  }

  function placePanels(view) {
    var host = view === "project" ? root.querySelector('[data-state="project"]') : null;
    ["[data-q-attach-panel]", "[data-q-comments-panel]"].forEach(function (sel) {
      var el = root.querySelector(sel);
      if (!el) return;
      if (!el.__lfyHome && el.parentNode) {
        el.__lfyHome = document.createComment("lfy-panel-home");
        el.parentNode.insertBefore(el.__lfyHome, el);
      }
      if (host) { if (el.parentElement !== host) host.appendChild(el); }
      else if (el.__lfyHome && el.parentElement !== el.__lfyHome.parentNode) {
        el.__lfyHome.parentNode.insertBefore(el, el.__lfyHome);
      }
    });
    /* ⛔ AND THE OTHER-DRAFTS PANEL GOES LAST, BECAUSE APPENDING PUT IT SECOND.
     *
     * The founder asked for it "at the bottom", and moving it in the Liquid was not enough: the
     * two panels above are authored inside the QUOTE view and appended into [data-state="project"]
     * at runtime, so they land AFTER anything already in that container. The markup move put
     * other-drafts below the product lines; append then put attach and comments below IT.
     * Rendered order was lines -> other-drafts -> others -> attach -> comments.
     *
     * Re-appending here, in the same pass that moves the others, keeps ONE owner of this ordering.
     * Doing it in the Liquid instead would leave two places deciding where these panels sit, and
     * this file already records what two writers on one element costs. */
    if (host) {
      var od = root.querySelector("[data-other-drafts]");
      if (od && od.parentElement === host) host.appendChild(od);
    }
    /* ⛔ AFTER THE MOVE, NOT BEFORE — the panel must be on its new surface before it is told what
     *    that surface is about. */
    repaintPanels(view);
  }

  function showView(name) {
    var v = VIEWS.indexOf(name) === -1 ? "project" : name;
    currentView = v;
    root.querySelectorAll("[data-view]").forEach(function (el) {
      el.hidden = el.getAttribute("data-view") !== v;
    });
    // The project view is the states + the add panel, so it is toggled as a group.
    var isProject = v === "project";
    if (isProject) {
      show(currentState);
    } else {
      root.querySelectorAll("[data-state]").forEach(function (el) { el.hidden = true; });
    }
    /* ⛔ THE PROJECT MASTHEAD DOES NOT BELONG ON A QUOTE. "My project / Every product you are
     * pricing, in one place" describes the BUILDER — but a quote view is a read-only record of a
     * quote that has already been sent, and an accepted one is not being priced by anybody. The
     * founder, looking at an accepted quote: "why you are showing ... status on the top??"
     *
     * It cost ~120px above the fold and said the wrong thing while it did. The quote's own header —
     * name, status chip, reference, dates, Print, and the payment status — is the header for this
     * view, and it sits directly below. Hiding the masthead promotes it to the top of the page,
     * which is what he asked for.
     *
     * ⚠️ The masthead TEXT goes; its ACTIONS do not, because paintMastheadActions() governs those
     * separately and they are not all project-only. Hiding the text block alone keeps that split
     * intact rather than reaching across two owners. */
    /* ⛔ AND IT IS WRONG ON EVERY VIEW EXCEPT THE PROJECT, NOT ONLY ON A QUOTE. I hid it for
     * `quote` and stopped there; the founder then found #account and #attach showing the same
     * "My project / Every product you are pricing, in one place" above a Trade account page and an
     * upload form. Fixing the reported surface and not the rule is the half-sweep this lane has
     * recorded twice (D9's price leak, and vendor across three builders).
     *
     * Every other view already titles itself — "Trade account" (h2), "Attach a schedule",
     * "Quote history" — so the masthead is not merely wrong there, it is a SECOND heading
     * disagreeing with the first. The project view keeps it: that IS the project. */
    var mastheadText = root.querySelector(".lfy-portal__mastheadText");
    if (mastheadText) mastheadText.hidden = !isProject;

    placePanels(v);
    paintMastheadActions();
    /* ⛔ A FIXED-POSITION DIALOG DOES NOT LEAVE WITH ITS VIEW. Open the add dialog, then click a
     * rail item: the view behind it changes and the dialog — position:fixed, full-viewport scrim —
     * stays on top of a page it no longer belongs to. Hidden states cannot take it with them,
     * because it is not inside one. */
    var addPanel = root.querySelector("[data-add-panel]");
    /* ⛔ AND HIDE IT ON `submitted`, WHICH IS A PROJECT VIEW AND SO SURVIVED THE LINE ABOVE.
     * The founder's screenshot showed the page saying "Sent for pricing · Q-260914-002" and, two
     * inches below, "Add Your First Product" — two calls to action contradicting each other, one of
     * them describing a project that had just been sent. The panel is a SIBLING of the states
     * (deliberately, so a trader with no open project can still start one), which is why a
     * state-level hidden attribute never reached it.
     *
     * It comes straight back when they press Start a new project: that sets the state to `empty`,
     * which is a project view and not `submitted`, so this condition stops applying. Nothing is
     * taken away — the sent confirmation just gets to be the only thing on screen. */
    /* ⛔ AND NOTHING HERE TOUCHES addPanel.hidden ANY MORE. The panel lives inside the dialog now,
       and showAdd() holds it open unconditionally — so a line here saying `hidden = !addAllowed`
       would re-hide the panel INSIDE an open dialog and produce an empty card. That is the same
       two-writers-one-element failure recorded at length in showAdd(), and it would have been my
       fourth instance of it on this one flag. What this view router gates is the OPENER, which
       showAdd() owns, and the dialog itself, which is closed below. */
    if (addPanel && !isProject) closeAddModal();
    /* ⛔ A QUOTE IS NOT A RAIL DESTINATION, so nothing was marked current while one was open and
     * the rail read as though the trader were nowhere. A quote is always reached FROM the history
     * — the back link on the page says exactly that — so history is its parent and stays lit.
     * Losing your place in a navigation is a small thing that makes a page feel broken. */
    var railFor = v === "quote" ? "history" : v;
    /* ⛔ THE RAIL ONLY. data-view-link is also on the quote's "← Quote history" back link, which
     * routes exactly like a rail item and must not be PAINTED like one — marking it current made
     * the back link inside the quote light up as though it were where you are, which is the
     * opposite of what a back link says. Scoped to the nav; the back link keeps its behaviour and
     * loses the styling. */
    root.querySelectorAll(".lfy-portal__rail [data-view-link]").forEach(function (a) {
      var on = a.getAttribute("data-view-link") === railFor;
      a.classList.toggle("is-current", on);
      if (on) a.setAttribute("aria-current", "page"); else a.removeAttribute("aria-current");
    });
    var home = root.querySelector('[data-view-link="project"]');
    if (home) { home.classList.toggle("is-current", isProject); }
  }
  var addAllowed = false;
  var signedOutNow = false;   /* the session, remembered, so every view can answer honestly */

  /* #quote/<id> carries a parameter, which none of the other views do — so the hash is parsed
   * rather than compared. An id that turns out to be unknown is handled by the fetch, not here:
   * guessing at validity in the router would just move the failure somewhere less informative. */
  /* ⛔ ANY IDENTIFIER PUT IN A HASH IS PUBLISHED TO GOOGLE. A fragment is never sent to a server by
   * the browser — but gtag reads location.href in JS, so GA4's `dl` carries it. Measured on this
   * page: analytics.google.com/g/collect (G-H8DHX6M9G8) and merchant-center-analytics.goog
   * (MC-HR5YKMQSDJ) both receive the full URL including "#quote/<uuid>", on page_view AND on
   * scroll. The Google Ads tag does NOT — it sends dl without the fragment — so it is 2 of the 5
   * Google endpoints, not all of them.
   *
   * Swept every hash this portal can produce: #history, #account and #attach carry no identifier;
   * #quote/<uuid> is the only one that does, 1 of 4. Before adding another — #attach/<id>, a line
   * route, anything — know that its ids leave the building. A reference (Q-260903-001) would be
   * WORSE than a uuid here: human-meaningful and sequential, so the series also discloses roughly
   * how many quotes the business issues per day.
   *
   * Not fixed here: the GA4 property and its tags are app-owned, not the theme's, and changing
   * page_location would alter analytics store-wide. Reported to the founder as their decision. */
  /* Set when the page was opened at #project/<token>, and cleared the moment the open read has
   * confirmed or denied it. A draft becomes a sent quote the first time it is submitted, so a
   * bookmark of #project/<ref> WILL stop pointing at the open project — and it is the founder's
   * own bookmark that breaks first. Handed to the reader rather than 404ing in place. */
  var pendingProjectToken = null;

  function routeFromHash() {
    var h = (location.hash || "").replace("#", "");
    if (h.indexOf("quote/") === 0) {
      quoteId = normaliseToken(h.slice(6));
      pendingProjectToken = null;
      showView("quote");
      loadQuote(quoteId);
      return;
    }
    if (h.indexOf("project/") === 0) {
      pendingProjectToken = normaliseToken(h.slice(8));
      showView("project");
      resolvePendingProject();
      return;
    }
    pendingProjectToken = null;
    showView(h || "project");
  }

  /* ⛔ MATCHED ON BOTH SPELLINGS. The token in the address may be the reference or the uuid, and
   *    a link written before this change is the uuid. Comparing against only one of them would
   *    send a trader with a working link to the wrong surface. */
  function resolvePendingProject() {
    if (!pendingProjectToken) return;
    if (!openProjectId && !openProjectRef) return;   /* the read has not landed; decide later */
    var t = pendingProjectToken;
    var mine = (openProjectRef && t === openProjectRef) || (openProjectId && t === openProjectId);
    pendingProjectToken = null;
    if (mine) { syncProjectUrl(); return true; }
    /* ⛔ NOT THE OPEN PROJECT IS NOT THE SAME AS NOT EDITABLE, AND THIS USED TO CONFLATE THEM.
     *    Every token that was not the current project went straight to the read-only quote reader.
     *    The founder asked three times how to add a product to one of these; the answer was that
     *    the page could not, by construction, and that was a client-side limit rather than a rule.
     *
     *    Measured on a draft this account owns but which is NOT its open project:
     *        GET /projects/Q-260908-005 -> 200, lineOps ["add","update","delete"],
     *                                      projectOps ["submit","rename","comment","attach"]
     *    The server already permits editing it. So ask, and let the ANSWER decide the surface. */
    loadProjectInto(t);
    /* ⛔ TELLS THE CALLER IT HAS TAKEN OVER, AND THAT MATTERS BECAUSE THE CALLER CARRIES ON.
     *    The open read calls this and then continues for ~70 more lines to paintProject(d) — with
     *    the SERVER'S current project. loadProjectInto() is an async fetch, so that synchronous
     *    paint wins the race and the trader sees the wrong reference until the second read lands.
     *
     *    Measured by the regression sweep on #project/Q-260908-005:
     *        2410ms  005 on screen
     *        3705ms  001 on screen   <- the open read's paint, ~1s of the wrong project
     *        4765ms  005 again       <- loadProjectInto's answer arrives
     *    It self-corrects, which is why it reads as a flicker rather than a break — and it is the
     *    same class of defect the loading mask exists to prevent: a claim made too early. */
    return false;
  }

  /* ⛔ THE ANSWER CHOOSES THE SCREEN — never the address, and never the status.
   *
   * A sent quote answers with lineOps [] and belongs in the reader; a draft answers with add/update
   * and belongs in the project view. Reading `status` instead would be inferring a capability the
   * server states outright, and this file already records what that costs.
   *
   * ⚠ WHY NOT REUSE loadQuote(): its branches write quote-view elements — [data-q-name],
   *   hideQuoteChrome(), showSignedOutQuote(), [data-q-actions]. Sharing it would drag the reader's
   *   side effects into a project paint. Same fetch, different consequences, so it is a sibling
   *   rather than a parameter.
   *
   * ⚠ openProjectId IS REPOINTED, DELIBERATELY. activeId() is what every write targets — add,
   *   update, delete, comment, attach. Painting draft B while openProjectId still said A would put
   *   the controls on one project and the words on another: the exact words-vs-action failure this
   *   file records three times. Opening B makes B the project this page acts on, which is what a
   *   trader means by opening it. The PDP button is a separate surface and is untouched: it still
   *   posts without a target and lets the server resolve or ask. */
  function loadProjectInto(token) {
    var base = String(root.getAttribute("data-endpoint")).replace(/\/$/, "");
    fetch(base + "/projects/" + encodeURIComponent(token), { headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then(function (res) { return res.json().catch(function () { return {}; }).then(function (d) { return { status: res.status, d: d || {} }; }); })
      .then(function (r) {
        var d = r.d;
        var editable = r.status === 200 && d.project && Array.isArray(d.lineOps) && d.lineOps.indexOf("add") !== -1;
        if (!editable) {
          /* Sent, gone, or not ours — the reader is right for all three and says so in its own
           * words. Unchanged behaviour, now reached by a decision rather than by default. */
          quoteId = token;
          setUrl("#quote/" + token);
          showView("quote");
          loadQuote(token);
          return;
        }
        /* ⛔ THE PAINTER READS d.truncated; THIS ROUTE SENDS linesTruncated. Measured on the live
         *    detail payload: top-level keys carry `linesTruncated`, and `truncated` is absent. The
         *    painter gates the line count on `d.truncated === false` and the cut-list warning on
         *    `d.truncated`, so handing this payload over unmapped would silently drop "N lines"
         *    from the meta and never warn on a truncated project. Not a crash — a quietly poorer
         *    surface, which is how this sort of thing ships unnoticed. Normalised here, once. */
        if (typeof d.truncated === "undefined") d.truncated = d.linesTruncated === true;

        openProjectId = d.project.id || token;
        openProjectRef = addressOf(d.project);
        openProjectData = { project: d.project, projectOps: d.projectOps };
        addAllowed = opsOf(d).indexOf("add") !== -1;

        /* ⛔ showView BEFORE paintProject. paintProject ends in show("project"), and show() returns
         *    early unless currentView is already "project" — so painting first would compute the
         *    whole surface and then refuse to reveal it. */
        showView("project");
        paintProject(d);
        /* ⛔ THE STALE PANEL THE FOUNDER CAUGHT. renderOtherDrafts() is called by the OPEN read and
         *    by nothing else, so opening a draft from a link left the previous read's panel sitting
         *    under a project it did not describe — the founder saw Q-260908-003 listed beneath
         *    Q-260908-004 with a sentence about "the project above".
         *
         *    This route's payload has no otherDrafts (it is a single-project read), so the list is
         *    recomputed from what we already hold: every other draft EXCEPT the one now open.
         *    Passing d.otherDrafts here would silently blank the panel, which hides the problem
         *    rather than fixing it. */
        renderOtherDrafts({
          /* Every other draft EXCEPT the one now open — the project you are looking at is not one
           * of your "other" projects. Filtered on id because that is what both routes agree on. */
          otherDrafts: lastOtherDrafts.filter(function (pj) { return String(pj.id) !== String(openProjectId); }),
          otherDraftsTruncated: lastOtherDraftsTruncated === true,
        });
        showAdd(addAllowed, true, false);
        syncProjectUrl();
        paintMastheadActions();
        loadComments(openProjectId, null);
        paintAttachPanel({ project: d.project, projectOps: d.projectOps });
      })
      .catch(function () {
        /* A transport failure must not strand them on a blank project view. */
        quoteId = token;
        setUrl("#quote/" + token);
        showView("quote");
        loadQuote(token);
      });
  }

  /* Sending a comment. Probed rather than guessed: POST with an over-length value in each candidate
   * key, so the server named the right one by refusing it as too long while every wrong key came
   * back as empty. Both are 400s, so no comment was written to find out.
   *
   *   POST /trade/projects/:id/comments   { body }   2000 max, REFUSED not truncated
   *   PATCH / DELETE                      405        the thread is append-only
   */
  var COMMENT_MAX = 2000;
  function wireCompose() {
    var input = root.querySelector("[data-q-input]");
    var send = root.querySelector("[data-q-send]");
    var out = root.querySelector("[data-q-count]");
    var msg = root.querySelector("[data-q-status-msg]");
    if (!input || !send) return;

    function tell(t, tone) {
      if (!msg) return;
      msg.textContent = t || "";
      msg.className = "lfy-portal__addStatus" + (tone ? " is-" + tone : "");
    }

    /* The cap is visible before it bites, for the same reason as the application form: the server
     * refuses over-length rather than clipping it, and a refusal discovered on submit is worse than
     * a countdown that stops someone reaching it. */
    function count() {
      if (!out) return;
      var n = (input.value || "").length;
      if (n >= COMMENT_MAX) {
        out.textContent = "You have reached the " + COMMENT_MAX + "-character limit. Please shorten it, or email us the rest.";
        out.className = "lfy-apply__count is-full";
        out.hidden = false;
      } else if (n > COMMENT_MAX * 0.8) {
        out.textContent = (COMMENT_MAX - n) + " characters left";
        out.className = "lfy-apply__count";
        out.hidden = false;
      } else { out.hidden = true; }
    }
    input.addEventListener("input", count);
    input.addEventListener("paste", function () { setTimeout(count, 0); });

    send.addEventListener("click", function () {
      var body = String(input.value || "").trim();
      if (!body) { tell("Write something first — an empty comment isn't sent.", "warn"); input.focus(); return; }
      if (!activeId()) return;
      send.disabled = true;
      tell("Sending…", "");
      var base = String(root.getAttribute("data-endpoint")).replace(/\/$/, "");
      fetch(base + "/projects/" + encodeURIComponent(activeId()) + "/comments", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ body: body }),
      })
        .then(function (res) { return res.json().catch(function () { return {}; }).then(function (d) { return { status: res.status, d: d || {} }; }); })
        .then(function (r) {
          send.disabled = false;
          if (r.status === 200 || r.status === 201) {
            input.value = "";
            count();
            if (r.d.notified === false) {
              tell("Saved — but we couldn't get word to the trade team automatically. Please ring us on the number above so we know it's there.", "warn");
            } else {
              tell("Comment sent. We'll come back to you on it.", "ok");
            }
            loadComments(activeId(), null);
            return;
          }
          /* Reason first, as everywhere on this surface. */
          if (r.d.reason === "empty_comment") return tell("Write something first — an empty comment isn't sent.", "warn");
          if (r.d.reason === "comment_too_long") return tell("That comment is longer than we can accept. Please shorten it, or email the detail to ashfield@lightsforyou.com.au.", "warn");
          if (r.d.reason === "project_locked") return tell("This quote is closed to comments. Please email us instead.", "warn");
          if (r.d.reason === "unknown_project") return tell("That quote isn't available any more. Go back to your quote history.", "warn");
          tell("That couldn't be sent. Please try again, or email ashfield@lightsforyou.com.au.", "err");
        })
        .catch(function () {
          send.disabled = false;
          /* Their text stays in the box — a transport failure must not also lose what they wrote. */
          tell("We couldn't send that — your comment is still here. Please try again.", "err");
        });
    });
  }

  /* ── STARTING A PROJECT WITH NO PRODUCT ─────────────────────────────────────────────────────
   *
   *   POST /apps/cipzo/trade/project   { projectName, comment? }
   *   201  { ok, projectId, reference, comment: <result|null> }
   *
   * ⛔ KEY ON 201, NOT ON ok OR ON 2xx. 200 is the RENAME's success on this same route, so a
   *    client keying on status alone cannot tell "renamed" from "created a second project".
   *
   * ⛔ AND THE COMMENT IS NOT IN THE STATUS. A created project whose first note failed returns
   *    201 with comment.ok false — the project genuinely exists and the trader must not be told
   *    it does not. That is a PARTIAL SUCCESS: say the project was made, say the note was not
   *    saved, and keep their words on screen so they can re-enter them.
   *
   * ⚠ THE CAPABILITY IS DELIBERATELY ABSENT FROM projectOps. `create` would advertise, on an
   *   existing project, a button that does not act on it — so the ops list is the wrong place
   *   and this control is gated on THERE BEING NO OPEN PROJECT instead. I concluded the feature
   *   did not exist by reading the ops list; it did. A capability kept out of the capability
   *   list is invisible to a client that only reads the capability list.
   *
   * Route verified by REFUSAL before anything was built: four malformed bodies all returned
   * 400 invalid_name and the project count was 7 before and 7 after. */
  function wireStart() {
    var name = root.querySelector("[data-start-name]");
    var note = root.querySelector("[data-start-note]");
    var go = root.querySelector("[data-start-go]");
    var msg = root.querySelector("[data-start-status]");
    if (!name || !go) return;
    var tell = function (t, tone) {
      if (!msg) return;
      msg.textContent = t || "";
      msg.className = "lfy-portal__addStatus" + (tone ? " is-" + tone : "");
    };

    go.addEventListener("click", function () {
      var n = String(name.value || "").trim();
      if (!n) { tell("Give the project a name first — it is how you will find it later.", "warn"); name.focus(); return; }
      var body = { projectName: n };
      var c = String((note && note.value) || "").trim();
      if (c) body.comment = c;
      go.disabled = true;
      tell("Starting\u2026", "");
      var base = String(root.getAttribute("data-endpoint") || "").replace(/\/$/, "");
      fetch(base.replace(/\/trade$/, "/trade") + "/project", {
        method: "POST", credentials: "same-origin",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(body),
      })
        .then(function (res) { return res.json().catch(function () { return {}; }).then(function (d) { return { status: res.status, d: d || {} }; }); })
        .then(function (r) {
          go.disabled = false;
          if (r.status === 201) {
            /* ⛔ The note's failure does not unmake the project. */
            var noteFailed = r.d.comment && r.d.comment.ok === false;
            if (noteFailed) {
              tell("Project " + (r.d.reference || "") + " started \u2014 but your note wasn't saved. It is still in the box below; add it again once the page reloads.", "warn");
            } else {
              if (note) note.value = "";
              tell("Project " + (r.d.reference || "") + " started. Add products, or attach a schedule.", "ok");
            }
            name.value = "";
            reload();
            if (window.LFY_TRADE && window.LFY_TRADE.refreshCount) window.LFY_TRADE.refreshCount();
            return;
          }
          /* Reason first, and every one of these already has a handler on this surface. */
          var reason = r.d.reason;
          if (reason === "invalid_name") return tell("That name can't be used. Give it a few words you'll recognise later.", "warn");
          if (reason === "invalid_body") return tell("Something went wrong sending that. Please try again.", "warn");
          if (reason === "project_locked") return tell("That project is closed. Start a new one instead.", "warn");
          if (reason === "reference_unavailable" || reason === "invalid_limits" || reason === "write_error") {
            /* ⛔ OUR MISCONFIGURATION, NOT THEIR REQUEST. Do not tell a trader to change what they
             * typed when nothing they type would help. */
            return tell("We couldn't start a project just now — that one is on us. Please ring us on the number above and we'll set it up.", "err");
          }
          tell("We couldn't start that project. Please try again, or ring us on the number above.", "err");
        })
        .catch(function () {
          go.disabled = false;
          tell("We couldn't reach us just then \u2014 your name and note are still here. Please try again.", "err");
        });
    });
  }

  function wireViews() {
    root.addEventListener("click", function (e) {
      var a = e.target.closest ? e.target.closest("[data-view-link]") : null;
      if (!a) return;
      e.preventDefault();
      var name = a.getAttribute("data-view-link");
      showView(name);
      /* ⛔ AFTER showView, NOT BEFORE — syncProjectUrl reads currentView, which showView sets. */
      /* ⛔ THE NAV ITEM IS A SECTION, NOT A RECORD. Clicking "My project" used to rewrite the
       * address to #project/<reference> — so a link that reads as a section quietly mutated into a
       * specific project, and the founder asked why "My project" pointed at Q-260908-005.
       *
       * Deep links still work and are still written: opening a project from the history list
       * (`[data-open-project]`, :2298), resolving a pasted #project/<ref> (:2010) and the project
       * read itself (:4704) all still call syncProjectUrl, so a URL you can share is produced
       * whenever you deliberately open something. It is only this nav click — the one that means
       * "take me to my project area" — that now leaves a clean address.
       * ⇒ Founder's choice of three options, 2026-09-17. */
      if (name === "project") setUrl(null); else setUrl("#" + name);
    });
    /* Both the escape button in the reader and the history row for the open project. A plain
     * link would leave "#quote/<id>" in the address bar for a view that is not the quote. */
    root.addEventListener("click", function (e) {
      var b = e.target.closest ? e.target.closest("[data-open-project]") : null;
      if (!b) return;
      e.preventDefault();
      showView("project");
      syncProjectUrl();
      if (root.scrollIntoView) root.scrollIntoView({ block: "start" });
    });
    routeFromHash();

    /* ⛔ A HASH CHANGE DOES NOT RELOAD THE PAGE. Reading location.hash once at init handles a fresh
     * load and nothing else — the browser Back button, a link elsewhere on the page, and anyone
     * pasting a second #view into the address bar all change the hash without re-running any of
     * this. Without the listener the URL says one view and the page shows another. */
    window.addEventListener("hashchange", routeFromHash);

    /* ⛔ AN ALREADY-OPEN PORTAL TAB NEVER RE-READS. Founder, 2026-09-15: "after adding globe page
     * not refresehd", and when asked, "portal is open on same page".
     *
     * This page read on exactly two triggers — DOMContentLoaded and hashchange — and NOTHING else.
     * Measured before writing this: 0 `visibilitychange` and 0 `pageshow` listeners in this file,
     * against 30 addEventListener calls overall, so the absence was the design, not an oversight I
     * was inventing. Add a globe from a selector in another tab, switch back, and the portal shows
     * the state it had when it loaded — indefinitely.
     *
     * ⛔ ON BECOMING VISIBLE, NOT ON A TIMER. A poll would fire forever on a page that usually has
     *    no news; this fires only when a trader actually looks at the tab, which is the only
     *    moment a stale view can mislead anyone.
     * ⛔ GUARDED ON A VIEW BEING OPEN. routeFromHash() re-derives from the URL and repaints, so
     *    calling it while the page is mid-write, or before init settled, would fight work already
     *    in flight. `document.hidden === false` plus an existing hash is the narrow case.
     * ⛔ NOT bfcache-only. pageshow would cover Back/Forward restores but not tab switching, which
     *    is what was actually reported. visibilitychange covers both: a bfcache restore fires it
     *    too, because the page transitions to visible.
     *
     * ⛔ IT CALLS reload(), NOT routeFromHash(), AND THE DIFFERENCE IS THE WHOLE FIX.
     *    routeFromHash() on "#project/<the open one>" reaches resolvePendingProject(), which does
     *    `if (mine) { syncProjectUrl(); return true; }` — it syncs the URL and FETCHES NOTHING.
     *    So on the exact case reported (own project, tab already showing it) the listener would
     *    have fired, repainted nothing, and looked like a fix while changing nothing. reload()
     *    (assigned at :3957) is the real read: it re-fetches data-endpoint and repaints through
     *    settle(). Caught by reading it rather than by testing, which is luck I should not repeat. */
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) return;
      reload();
    });
  }

  /* Real rows only. The open project and the last submitted one are things this page already
   * knows; anything older needs the list endpoint, and is described rather than invented. */
  /* ⛔ THE VOCABULARIES COME FROM THE WIRE. Hardcoding the seven statuses is exactly what
   * statusVocabulary exists to prevent, and it already caught two I had invented. The key is named
   * per route — commentStateVocabulary on a project payload, stateVocabulary on a comments one —
   * so both spellings are read and neither is guessed. */
  function vocab(d, kind) {
    if (!d) return [];
    var v = kind === "state" ? (d.commentStateVocabulary || d.stateVocabulary)
          : kind === "author" ? (d.commentAuthorVocabulary || d.authorVocabulary)
          : d.statusVocabulary;
    return Array.isArray(v) ? v : [];
  }

  /* ⛔ author IS A ROLE, NOT A PERSON — exactly "trade_customer" or "merchant". It answers "was this
   * me or them" and nothing else, so it is rendered as a relationship rather than a name. The
   * merchant's business name is only ever the outcomeAuthor field, and only when the server sends
   * one; inventing one here would be the same substitution that must never put the shop's internal
   * domain in front of a customer. */
  function authorLabel(role) {
    if (role === "trade_customer") return "You";
    if (role === "merchant") return "Trade team";
    return null;
  }

  function loadQuote(id) {
    var base = String(root.getAttribute("data-endpoint")).replace(/\/$/, "");
    text(root.querySelector("[data-q-name]"), "Loading…");
    /* ⛔ THE PREVIOUS QUOTE STAYED ON SCREEN WHILE THE NEXT ONE LOADED. Only the NAME was set to
     * "Loading…" — the lines, their photographs, the totals, the timeline and the status panel all
     * kept showing the quote you had just navigated AWAY from, for as long as the read took. The
     * founder, switching between Q-260914-003 and Q-260915-001: "takes time to change the products
     * images and timeline..can we add loader??"
     *
     * ⚠️ THIS IS WORSE THAN A SLOW PAGE, IT IS A WRONG ONE. For that window the page showed one
     * quote's REFERENCE loading while another quote's PRODUCTS AND PRICES were on screen beneath
     * it. On a money surface a trader could read a figure that belongs to a different quote.
     *
     * So: clear what is about to be replaced, and mark the view busy so the spinner has something
     * to attach to. Everything cleared here is rewritten by renderQuote() on success, and hidden by
     * hideQuoteChrome() on failure — no path leaves these empty and visible. */
    var view = root.querySelector('[data-view="quote"]');
    if (view) view.classList.add("is-busy");
    var lines = root.querySelector("[data-q-lines]");
    if (lines) lines.textContent = "";
    ["[data-q-meta]", "[data-q-accept-status]"].forEach(function (sel) {
      var el = root.querySelector(sel);
      if (el) el.textContent = "";
    });
    ["[data-q-totals]", "[data-q-steps]", "[data-q-pay]", "[data-q-status]"].forEach(function (sel) {
      var el = root.querySelector(sel);
      if (el) el.hidden = true;
    });
    fetch(base + "/projects/" + encodeURIComponent(id), { headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then(function (res) { return res.json().catch(function () { return {}; }).then(function (d) { return { status: res.status, d: d || {} }; }); })
      /* ⛔ CLEAR THE BUSY FLAG ON EVERY EXIT, NOT ONLY ON SUCCESS. There are four ways out of this
       * read — signed out, non-200, rendered, and a network throw — and a spinner left running on
       * any of them is a page that never stops loading. Clearing it HERE, before the branches fan
       * out, means a branch added later cannot forget to. */
      .then(function (r) {
        var v0 = root.querySelector('[data-view="quote"]');
        if (v0) v0.classList.remove("is-busy");
        return r;
      }, function (e) {
        var v1 = root.querySelector('[data-view="quote"]');
        if (v1) v1.classList.remove("is-busy");
        throw e;
      })
      .then(function (r) {
        /* ⛔ THE SESSION ANSWER COMES FIRST, BECAUSE IT IS A DIFFERENT QUESTION. signedIn:false
         *    arrives as a 200 with project:null — indistinguishable from a deleted quote unless
         *    you read the field the server sent precisely so you could tell them apart. Three
         *    states were collapsed into one sentence, and the commonest of the three is the one a
         *    paying customer hits: our own emailed link, opened on a device with no session.
         *    Same defect as the empty history below — the session is known and discarded. */
        if (r.d && r.d.signedIn === false) return showSignedOutQuote();
        if (r.status !== 200 || !r.d.project) {
          text(root.querySelector("[data-q-name]"), "That quote isn't available.");
          hideQuoteChrome();
          return;
        }
        var acts = root.querySelector("[data-q-actions]");
        if (acts) acts.hidden = false;
        /* ⛔ THE ADDRESS IS NOT THE IDENTIFIER. `id` here may be a REFERENCE, because that is what
         *    the address bar now carries. So the canonical id is taken from the answer and
         *    everything downstream keeps using it.
         *
         * ✅ UPDATE, MEASURED SINCE: the comment and attachment routes DO accept a reference —
         *    asked both ways in one run on a project the account owns, with the uuid call as the
         *    positive control for the reference call, and all three routes answered 200 to both.
         *    So the fear this guards against turned out not to exist on the storefront. It stays
         *    anyway: canonicalising costs nothing, and it means a route added later cannot inherit
         *    an assumption nobody rechecked. What is NO LONGER true is the claim that once stood
         *    here — that those routes were proven for the uuid and for nothing else.
         *
         * ⚠ The merchant side does have this split: /api/merchant/trade/quote 404s on a reference
         *   while a sibling route accepts one. Storefront and desk do not behave the same way, and
         *   a reader of this file should not carry one lane's finding across to the other.
         *
         *    A readable URL must not quietly widen the set of routes
         *    a reference is assumed to work on; the way to find out is to ask the server, not to
         *    let a comment box be the experiment.
         * ⚠ r.d.project.id is the SERVER's spelling of this project, so this also repairs a link
         *   typed in the wrong case. */
        quoteId = r.d.project.id || id;
        renderQuote(r.d);
        loadComments(quoteId, r.d);
      })
      .catch(function () { text(root.querySelector("[data-q-name]"), "That quote isn't available."); });
  }

  /* The sign-in link returns them to the exact quote. The fragment never reaches the server, but
   * the browser reapplies it after the redirect, so the emailed link still lands where it meant to. */
  function showSignedOutQuote() {
    var box = root.querySelector("[data-q-signin]");
    var link = root.querySelector("[data-q-signin-link]");
    if (link) {
      var back = location.pathname + (location.hash || "");
      link.setAttribute("href", "/customer_authentication/login?return_to=" + encodeURIComponent(back));
    }
    if (box) box.hidden = false;
    text(root.querySelector("[data-q-name]"), "");
    hideQuoteChrome();
  }

  /* Everything that describes a quote we are not showing. A Print button on an error card prints
   * a sheet saying the quote is unavailable. */
  /* ⛔ [data-q-steps] IS ON THIS LIST FOR THE REASON THE LIST EXISTS. The spine is revealed by
   *    paintQuoteSpine and, without this, nothing would ever take it away: a trader who opened a
   *    live quote and then hit an unavailable one would read the FIRST quote's progress above the
   *    second one's error card. That is the stale-panel shape this file has recorded three times
   *    already — a comment thread, a sign-in link's return_url, and the add panel — and each time
   *    it was a control that was revealed on success and never hidden on failure. */
  function hideQuoteChrome() {
    ["[data-q-actions]", "[data-q-comments-panel]", "[data-q-compose]", "[data-q-attach-panel]", "[data-q-totals]", "[data-q-steps]"]
      .forEach(function (sel) { var e = root.querySelector(sel); if (e) e.hidden = true; });
  }

  function renderQuote(d) {
    var si = root.querySelector("[data-q-signin]");
    if (si) si.hidden = true;   /* a later successful read must clear an earlier refusal */
    /* ⛔ AND THE LINK'S DESTINATION GOES WITH IT. Hidden is not harmless: the anchor kept the
     * return_url of the LAST quote that refused, so while reading quote B a hidden control pointed
     * at quote A. Inert today because it is hidden — and a wrong-destination bug the first day any
     * branch un-hides it, which is exactly how this page's built-and-unreachable defects have
     * behaved all week. Found by the QA lane counting anchors rather than looking at the screen. */
    var siLink = root.querySelector("[data-q-signin-link]");
    if (siLink) siLink.setAttribute("href", "/customer_authentication/login");
    var pr = d.project || {};
    text(root.querySelector("[data-q-name]"), pr.name || "Untitled project");
    var chip = root.querySelector("[data-q-status]");
    if (chip) {
      /* Rendered verbatim, and only when the server's own vocabulary contains it.
       *
       * ⛔ THERE IS NO "expired" STATUS AND THERE WILL NOT BE ONE. Founder ruling, 2026-09-07: a
       * quote past its expiry still reads `quoted` in this field, permanently and correctly.
       * Expiry is DERIVED from quote_expires_at, and the CHECK constraint is deliberately not
       * being widened — for the same reason commentStateOf derives from actioned_at rather than
       * storing a second source: two columns that can disagree eventually do.
       *
       * I invented an `expired` status once from a guess and it was rejected. Writing it here
       * because it is now DECIDED rather than merely absent, and the difference matters: someone
       * seeing a lapsed quote still labelled "quoted" will otherwise read it as a missing writer
       * and go looking for the bug. It is not a bug. Do not add the status, and do not gate
       * anything on one.
       *
       * ⛔ AND EXPIRY IS NEVER DERIVED FROM THIS BROWSER'S CLOCK. When the pricing payload lands it
       * carries quoteExpiresAt AND the server's own verdict. The verdict gates behaviour; the
       * timestamp only supplies the words "expires in 3 days". A device with a wrong clock, or a
       * customer in Perth two hours behind the store, must not see a different quote state from
       * the same data. A countdown is information. It is never authority. */
      var known = vocab(d, "status").indexOf(pr.status) !== -1;
      chip.textContent = pr.status || "";
      chip.className = "lfy-portal__chip" + (known ? " is-" + String(pr.status).toLowerCase().replace(/[^a-z]+/g, "-") : "");
      chip.hidden = !pr.status;
    }
    var bits = [];
    if (pr.reference) bits.push(pr.reference);

    /* Plate J's meta reads "Q-260903-001 · sent 3 Sep 2026 · 3 products · #D4802". The date sat out
     * until there was a field that actually means SENT, because the two that existed were both wrong
     * and both would have looked right:
     *
     *   createdAt   when the project was STARTED  — lands on the correct day for the QA project,
     *                                               so it would have shipped undetected
     *   updatedAt   moves for reasons nobody has pinned down — see below
     *
     * ⚠ A CLAIM I MADE HERE WAS REFUTED, and the correction matters more than the fix did. I wrote
     * that updatedAt "moved when a comment was actioned". The app lane reproduced all three
     * candidate writes on a fresh project — a trader comment (201), a rename (409, the submit lock
     * working), and a merchant ACTIONING a comment (200) — and updated_at moved for NONE of them.
     * There are no triggers on the table. So the mechanism I gave is simply wrong, and what moved
     * Q-260903-001's updatedAt on 09-04 is still UNKNOWN.
     *
     * My conclusion survived: createdAt is definitively not the sent date, and on the fresh project
     * the two are 13 seconds apart, so they are measurably different concepts. But the conclusion
     * was resting on a cause nobody had measured, and a right answer resting on a wrong mechanism
     * is one somebody later rebuilds on. The observable facts are that submittedAt is present,
     * parses and renders; that submittedAt and createdAt are different instants; and nothing about
     * updatedAt is asserted at all.
     *
     * The app lane has since applied trade_projects.submitted_at (timestamptz, nullable, NO backfill
     * — backfilling from created_at would have manufactured exactly that confident-wrong date).
     *
     * ✅ THE WRITE PATH HAS SINCE LANDED, AND THIS PARAGRAPH USED TO SAY IT HAD NOT. Measured on
     *    the live wire 2026-09-14 (docs/qa-harness/metafields.mjs): submittedAt =
     *    "2026-09-14T06:10:07.159+00:00" on BOTH lastSubmitted and projects[0], against a createdAt
     *    of 06:07:16 — three minutes apart, so it is genuinely the send instant and not a
     *    coalesced created_at.
     *
     * ⚠️ AND I NEARLY REPORTED THE OPPOSITE FROM READING THIS COMMENT. Asked which of three
     *    founder-specified meta states could render, I was about to answer "none of the dates,
     *    submitted_at is still NULL everywhere" — sourced from this paragraph rather than from the
     *    wire. A stale comment is not a neutral inconvenience: it is a confident claim that
     *    outlives its subject and gets quoted as evidence. The probe is what caught it.
     *
     * ⛔ SO THIS RENDERS ON THE VALUE PARSING, NOT ON THE KEY EXISTING. Absent, null, and unparseable
     *    all mean the same thing here — we do not know when it was sent — and all three print nothing
     *    rather than a guess. When the write path ships, the date appears with no theme deploy.
     *    ⛔ It is NEVER coalesced to createdAt. That is the whole point of having waited. */
    var sent = pr.submittedAt ? new Date(pr.submittedAt) : null;
    if (sent && !isNaN(sent)) {
      bits.push("sent " + fmtDate(pr.submittedAt));
    }

    if (typeof pr.lineCount === "number") bits.push(lineCountText(pr.lineCount));
    if (pr.draftOrderName) bits.push(pr.draftOrderName);
    text(root.querySelector("[data-q-meta]"), bits.join(" · "));

    /* Gated on THIS quote's own projectOps, so viewing quote A can never be gated by project B. */
    paintAttachPanel(d);
    /* ⛔ FROM `d`, THE FRESH READ — NEVER FROM lastQuote. repaintPanels() paints the attach panel
     *    from the remembered payload (:1451), which is right for a panel and WRONG for this button:
     *    quoteVersion is an ETag, and a remembered one is a stale ETag. version_moved would catch
     *    it, but relying on the server to catch my own staleness is the wrong instinct. So the
     *    accept button is painted here and nowhere else. */
    paintAcceptButton(d);
    /* Paint the payment state from the READ as well as from the accept response, so a trader who
       reloads a won quote is told where their order is instead of meeting a silent page. */
    paintPayStateFromRead(d);

    var box = root.querySelector("[data-q-lines]");
    if (box) {
      box.textContent = "";
      (d.lines || []).forEach(function (l) {
        var row = document.createElement("div");
        row.className = "lfy-portal__line";
        /* ⛔ THE QUOTE VIEW NEEDS THIS TOO. I changed both containers from role="table" to
         * role="list" and then marked the rows in ONE of the two render paths — which would have
         * left the quote reader declaring a list containing nothing, the exact defect I was
         * removing, moved one view across. Caught by grepping for the class rather than trusting
         * that "the rows" meant one place. */
        row.setAttribute("role", "listitem");
        row.setAttribute("data-line-row", String(l.id));
        var thumb = document.createElement("div");
        thumb.className = "lfy-portal__lineThumb";
        thumb.setAttribute("data-line-thumb", "");
        row.appendChild(thumb);
        var main = document.createElement("div");
        main.className = "lfy-portal__lineMain";
        var t = document.createElement("span");
        t.setAttribute("data-line-title", "");
        var lbl1 = lineLabel(l);
        t.textContent = lbl1 || "This line has no product on it";
        if (!lbl1) t.className += " is-nameless";
        main.appendChild(t);
        // enriched is top-level and governs whether variantTitle means anything.
        if (d.enriched === true && l.variantTitle) {
          var v = document.createElement("span");
          v.className = "lfy-portal__lineVariant";
          v.textContent = l.variantTitle;
          main.appendChild(v);
        }
        var vd1 = document.createElement("span");
        vd1.className = "lfy-portal__vendor";
        vd1.setAttribute("data-line-vendor", "");
        vd1.hidden = true;
        main.appendChild(vd1);
        if (l.sku) main.appendChild(skuGroup(l.sku));
        row.appendChild(main);
        /* ⛔ A LOCKED QUOTE IS STILL A SHOPPING SURFACE. The lock is on quantities, not on looking
         * the product up — a trader reading a sent quote on site is exactly the person who needs to
         * open the product page. Same painter as the draft project, scoped to this box. */
        // ⛔ TEXT, NOT A FIELD. lineOps is [] here, so there is nothing to offer.
        var q = document.createElement("div");
        q.className = "lfy-portal__qty";
        q.textContent = "× " + l.quantity;
        row.appendChild(q);
        paintLineMoney(row, l, pricingOf(d));
        /* ⛔ THE NOTE WAS ON THE WIRE AND RENDERED IN THE DRAFT VIEW ONLY. A note a trader put on a
         * line vanished the moment the quote was issued — the one moment it matters, because that
         * is the sheet they hand a client. Appended AFTER the money so it takes its own line at the
         * foot of the row, matching the draft view's order.
         * ⚠ Its box model was broken in BOTH views until this same change: .lfy-portal__line is
         * flex, so the note's `grid-column: 1 / -1` was inert and it never spanned above 900px.
         * Copying the draft pattern verbatim would have copied that bug into the quote. */
        if (l.note) {
          var qn = document.createElement("div");
          qn.className = "lfy-portal__note";
          qn.textContent = l.note;
          row.appendChild(qn);
        }
        box.appendChild(row);
        /* ⛔ AFTER THE ROW IS IN THE DOM, NOT BEFORE. paintLine finds its row by querying the
         * scope, so painting a detached row silently does nothing. It failed asymmetrically and
         * that is what made it worth catching: the image still appeared, because its fetch
         * resolves long after the append, while the title link — set synchronously — never did.
         * Three images and no links looked like a link bug rather than an ordering one. */
        paintFromPayload(l, box);
      });
    }
    renderTotals(d);
    renderVersions(d);

    var trunc = root.querySelector("[data-q-truncated]");
    if (trunc) {
      if (d.linesTruncated) { text(trunc, "This quote has more lines than are shown here."); trunc.hidden = false; }
      else trunc.hidden = true;
    }
    /* ⛔ THE SENTENCE MUST MATCH THE STATUS. This notice said "This quote has been sent, so its
     * products and quantities are fixed" at EVERY status — including `quoted`, which means the
     * price has arrived. The chip changed colour and the sentence underneath said nothing had
     * happened, and a trader skims the sentence, not the chip. Found by forcing all seven statuses;
     * it went live the moment the first project reached quoted.
     *
     * ⚠ WHAT THE WIRE DOES NOT CARRY, MEASURED ON THE FIRST REAL QUOTED PROJECT (Q-260907-001):
     *   releasedAt, quoteExpiresAt, pricing, unitPrice, lineTotal — ALL ABSENT from the trader read.
     *   The columns are stamped in the database and the ledger shows the trader was told, but none
     *   of it is published here yet.
     * ⇒ SO THE QUOTED COPY MUST NOT PROMISE A PRICE THIS PAGE CANNOT SHOW. "Your price is ready"
     *   above a list with no prices on it is worse than the wrong-but-vague sentence it replaces.
     *   It says what is true: we have priced it, the figures are not on this screen yet, here is
     *   how to get them. When `pricing` lands the copy changes and this comment goes with it. */
    lastQuote = d;
    /* ⛔ THE RAIL COULD NOT MARK THE QUOTE YOU ARE READING. renderRailHistory() marks its current
     * row from `openProjectId`, which is set by the PROJECT read (:2064) and by the open-project
     * path (:4602) — never here. So opening #quote/Q-260915-001 left every row in the rail
     * unmarked: the nav said "Quote history" was the section but not which quote was selected.
     * The founder: "siderail not showing which quote number its pointed and selected like menu
     * selected?"
     *
     * The quote read carries the same project id, so the rail can be told from here. Repaint after
     * setting it, because the rail may already have been drawn by the list fetch that preceded
     * this read — setting the variable alone would mark nothing until the next unrelated repaint. */
    /* ⛔ DO NOT OVERLOAD openProjectId FOR THIS — IT MARKED THE WRONG ROW. That variable means "the
     * draft project the portal has open", and the draft read (:4655) sets it on page load. Writing
     * the quote's project id into it put two owners on one variable and whichever fetch landed last
     * won: the founder saw Q-260908-005 (DRAFT) highlighted while reading Q-260915-001.
     * A separate variable has one owner and cannot race. */
    if (d && d.project && d.project.id) {
      openQuoteProjectId = d.project.id;
      renderRailHistory();
    }
    paintDraftEscape();
    paintQuoteSpine(d);
    var locked = root.querySelector("[data-q-locked]");
    if (locked) {
      var open = Array.isArray(d.lineOps) && d.lineOps.length > 0;
      locked.hidden = open;
      if (!open) text(locked, lockCopy(d));
    }

    var panel = root.querySelector("[data-q-comments-panel]");
    var compose = root.querySelector("[data-q-compose]");
    var mayComment = Array.isArray(d.projectOps) && d.projectOps.indexOf("comment") !== -1;
    if (panel) panel.hidden = !mayComment;
    if (compose) compose.hidden = !mayComment;
  }

  function loadComments(id, detail) {
    var base = String(root.getAttribute("data-endpoint")).replace(/\/$/, "");
    fetch(base + "/projects/" + encodeURIComponent(id) + "/comments", { headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then(function (res) { return res.json().catch(function () { return {}; }); })
      .then(function (d) {
        /* ⛔ A LATE FETCH MUST NOT PAINT ANOTHER PROJECT'S THREAD. Third instance of this shape in
         * this file — after show() and showAdd() — and the first where the wrong content is a
         * CUSTOMER'S OWN WORDS. Now the panels serve both the open project and a quote, two reads
         * are in flight whenever the view changes, and whichever resolved last won: opening a quote
         * from the project showed the PROJECT's comments under the quote's heading.
         *
         * ⚠ AND MY CHECK PASSED IT. It compared COUNTS — 3 on the wire, 3 on the page — and never
         *   looked at a single body. CARDINALITY IS NOT IDENTITY. Caught only by printing the text.
         *
         * The guard is the id: an answer is rendered only if the surface still wants that project. */
        if (String(activeId()) !== String(id)) return;
        renderComments(d, detail);
      })
      .catch(function () {});
  }

  /* ⛔ openCount: NULL MEANS THE COUNT FAILED, NEVER 0 — the same rule as `count` on the
   * attachment POST and `notified` on the comment POST. Three fields, one rule, because the cheap
   * reading of each is the same mistake: treating a missing answer as a zero answer.
   *
   * ⛔ AND 0 IS A REAL STATE THAT MUST NOT LOOK LIKE AN ABSENT BADGE. "Every comment has been
   * actioned" is something a trader wants to know, and it is the opposite of "we could not tell
   * you". So three cases render as three different things:
   *
   *     n > 0        "2 open"        amber — something is outstanding
   *     n === 0      "all actioned"  green — said out loud, not shown by absence
   *     null/absent  nothing         we do not know, so we claim nothing
   *
   * "0 open" for null would invent a fact; nothing for 0 would hide one. */
  /* ⛔ EXPIRY: THE VERDICT GATES, THE TIMESTAMP ONLY SUPPLIES WORDS. Founder ruling — there is no
   * `expired` status and there never will be; a lapsed quote reads `quoted` for ever. So the server
   * sends quoteExpiresAt AND its own verdict, and this page NEVER decides "lapsed" by comparing the
   * timestamp to this browser's clock: a wrong device clock, or a customer in Perth two hours
   * behind the store, must not see a different quote state from the same data.
   *
   * ⚠ NEITHER KEY IS ON THE WIRE TODAY — measured, not assumed. So both branches below are inert,
   *   and the LAPSED story in particular is FIXTURE-BACKED ONLY: no quote has lapsed, and I am not
   *   back-dating a row to test a renderer. This renders on the value parsing, so it turns itself
   *   on the day the keys ship, with no theme deploy — the same way submittedAt and attach did. */
  /* ⛔ THE VERDICT AND THE TIMESTAMP LIVE ON DIFFERENT OBJECTS. Measured on the deployed wire,
   * not taken from the brief -- which described both as fields on the project:
   *
   *     d.project.quoteExpiresAt   "2026-09-21T09:25:37.047+00:00"   <- the date IS here
   *     d.project.quoteExpired     KEY ABSENT
   *     d.quote.quoteExpired       null                              <- the verdict is HERE
   *     d.quote.pricing            null
   *     d.quote.quoteRecorded      false
   *
   * I was reading pr.quoteExpired, which is ALWAYS undefined, so the lapsed branch could never
   * fire. Invisible today because the verdict is null on every subject and null must not say
   * "lapsed" anyway -- and wrong the first day a quote actually lapses, when the page would go
   * on saying "valid until" a date already past. Third instance of this class in this
   * workstream after `enriched` and `unverifiableTypes`: the right field read at the wrong
   * level, masked by whichever value happened to be live.
   *
   * Reads the quote object first and falls back to the project, so a later move in either
   * direction keeps working rather than silently reverting to never-lapsed. */
  /* ⛔ THREE STATES, AND null IS NOT false. This returned "lapsed" on true and otherwise PRINTED
   *    THE DATE — so an UNANSWERABLE verdict rendered as a confident promise. Measured on the
   *    running page, not reasoned about: Q-260907-001 is quoted, carries quoteExpiresAt
   *    2026-09-21 and quoteExpired: null, and my page said "valid until 21 Sept 2026". It was
   *    quoted two hours before the quote-artefact module existed, so there is no recorded quote
   *    to have expired, and it was deliberately NOT backfilled — synthesising one would forge a
   *    record of a commercial offer.
   *
   * ⛔ ABSENT IS TREATED AS UNANSWERABLE, NOT AS VALID. If the key ever stops being sent, the
   *    page must fall silent about the date rather than start promising it again. The unsafe
   *    direction is the one that makes a promise.
   *
   * ⚠ THE DATE IS FOR THE WORDS; THE VERDICT IS FOR THE BEHAVIOUR. The theme still never compares
   *   quoteExpiresAt to the browser clock — a wrong device clock or another timezone would show a
   *   live price as expired, or an expired one as live. */
  function expiryPhrase(pr, d) {
    if (!pr) return null;
    var q = (d && d.quote) || {};
    var verdict = (q.quoteExpired !== undefined) ? q.quoteExpired : pr.quoteExpired;
    if (verdict === true) return "lapsed";                  // the SERVER's verdict, never ours
    var t = pr.quoteExpiresAt ? new Date(pr.quoteExpiresAt) : null;
    var dated = !!(t && !isNaN(t));
    if (verdict === false) {
      return dated ? "valid until " + fmtDate(pr.quoteExpiresAt) : null;
    }
    /* null, undefined, or any value this page has not been taught — three causes on the server
     * (no quote, no recorded expiry, or the artefact read failed) which are deliberately NOT
     * split on the wire, because "we could not look" is not a distinction a customer can act on.
     *
     * ⛔ BRANCHED ON status AND releasedAt, NOT ON WHETHER A DATE IS PRESENT. My date-presence
     *    test gave the right answer on every live row for the wrong reason: quoteExpiresAt comes
     *    off the PROJECT row and quoteExpired off the ARTEFACT, so "there is a date" means "the
     *    project row carries a window", not "a quote exists" — and on Q-260907-001 that window
     *    has nothing behind it, which is the whole defect. It also folded a real third state into
     *    silence, and quoteExpiresAt is an unpinned key, so a date-presence branch would
     *    reclassify every row at once if it ever went quiet. status and releasedAt are
     *    load-bearing elsewhere on this page and cannot go quiet without me noticing.
     *
     * ⚠ releasedAt is PRESENT on the detail read — measured. An older note of mine said it was
     *   absent; that note is withdrawn. Branching on a key I had not re-checked would have told
     *   every quoted trader their quote was never sent. */
    if (pr.status !== "quoted") return null;   // draft or submitted: no quote, so no question
    if (!pr.releasedAt) return "notsent";      // priced but never released: the window never began
    return "unconfirmed";
  }

  /* ⛔ SAYING IT IS EDITABLE IS NOT THE SAME AS LETTING THEM EDIT IT. The reader is reached from
   * quote history, and history lists the OPEN project alongside the sent ones, so a trader lands
   * on their own draft in a surface that offers no add panel and no submit. Correct copy on a
   * dead end is still a dead end.
   *
   * ⛔ GATED ON IDENTITY, NOT ON STATUS. "draft" tells the copy what to say; only a match against
   *    the id the OPEN read returned proves this is the project the add panel would act on. Two
   *    reads land in either order, so both call this and it paints from whichever facts exist —
   *    absent open id means no button, never a button that goes somewhere wrong. */
  var lastQuote = null;
  function paintDraftEscape() {
    var btn = root.querySelector("[data-q-open-project]");
    if (!btn) return;
    var pr = (lastQuote && lastQuote.project) || null;
    var mine = !!(pr && openProjectId && String(pr.id) === String(openProjectId));
    btn.hidden = !(currentView === "quote" && mine);
  }

  /* ── WHERE THIS QUOTE SITS ───────────────────────────────────────────────────────────────────
   *
   * Founder's choice (2026-09-14): the pending-approval card's progress spine, on the quote.
   *
   * ⛔ FOUR STEPS, BECAUSE FOUR STATUSES HAVE WRITERS. statusVocabulary publishes seven. This lane
   *    swept the Cipzo tree and the app lane swept it independently; both found writers for
   *    exactly draft · submitted · quoted · won. `active` has been in the day-one CHECK constraint
   *    with no writer ever. `lost`/`archived` have none either — the app lane told me they were
   *    merchant status changes and then withdrew it, having said it from the vocabulary rather
   *    than from a grep. I made the same mistake about `active`'s position in the order.
   *    ⇒ THE VOCABULARY IS A LIST OF VALUES THE COLUMN MAY HOLD, NOT A LIST OF STATES THE SYSTEM
   *      CAN PRODUCE. Rendering a step nothing can reach shows every trader a stage that does not
   *      exist.
   *
   * ⛔ AND `quoted` WITH NO releasedAt IS NOT A COMPLETED STEP. That is priced-but-never-released:
   *    the quote is sitting with us and the trader has received nothing. Marking "Priced" done for
   *    that person is the same lie I refused to ship in the meta line — telling somebody we are
   *    awaiting their acceptance of something they were never sent. It reads as CURRENT, and
   *    lockCopy() already says whose fault it is.
   *
   * ⛔ NO DATE IS EVER INVENTED. Each step's date comes off the wire through fmtDate() in the
   *    shop's timezone; absent, null and unparseable all print nothing. `acceptedAt` is not on the
   *    trader read at all yet (the app lane is publishing it on the list rows and the detail
   *    project, deliberately NOT on lastSubmitted — that object is the project just submitted,
   *    which cannot be accepted), so step 4 shows its label bare until then. */
  var Q_STEPS = ["draft", "submitted", "quoted", "won"];

  function paintQuoteSpine(d) {
    var ol = root.querySelector("[data-q-steps]");
    if (!ol) return;
    var pr = (d && d.project) || null;
    /* No project, or a status this page has not been taught, means no honest spine to draw.
       An unknown status must not be silently placed somewhere on a four-step line. */
    var at = pr ? Q_STEPS.indexOf(String(pr.status || "")) : -1;
    if (at === -1) { ol.hidden = true; return; }

    /* The reached-but-not-delivered case. Everything up to Sent is genuinely done; Priced is in
       progress, not complete, and nothing after it has begun. */
    var pricedIncomplete = pr.status === "quoted" && !pr.releasedAt;

    var when = {
      draft: pr.createdAt,
      submitted: pr.submittedAt,
      /* releasedAt is when the quote actually reached them, which is what "Priced" means to a
         trader — not when we stamped a price internally. */
      quoted: pr.releasedAt,
      /* not on the wire yet; fmtDate returns null and the span stays empty */
      won: pr.acceptedAt
    };

    var items = ol.querySelectorAll("li");
    for (var i = 0; i < items.length; i++) {
      var key = items[i].getAttribute("data-q-step");
      var idx = Q_STEPS.indexOf(key);
      var done = idx < at;
      var current = idx === at;
      if (pricedIncomplete && key === "quoted") { done = false; current = true; }
      items[i].className = done ? "is-done" : (current ? "is-current" : "");
      var span = items[i].querySelector("[data-q-step-when]");
      if (span) text(span, fmtDate(when[key]) || "");
    }
    ol.hidden = false;
  }

  function lockCopy(d) {
    var pr = (d && d.project) || {};
    var when = expiryPhrase(pr, d);

    if (pr.status === "quoted") {
      /* ⛔ THE COPY MUST KNOW WHETHER THE PRICES ARE ON THE SCREEN. This sentence used to say
       * "the figures aren't shown on this page yet" at EVERY quoted status -- which was true and
       * necessary while no artefact existed, and became a flat contradiction the moment the
       * totals panel started rendering. Caught on the running page: A$1,694.48 displayed, with a
       * sentence directly beneath it saying the figures were not displayed.
       *
       * That is the same defect as the submitted story told to a priced quote, which I fixed
       * earlier and then reintroduced one layer down by adding the money and not revisiting the
       * words. Copy that describes the page has to be derived from the page, not from what was
       * true when it was written. */
      var priced = !!pricingOf(d);
      /* ⛔ THE UNANSWERABLE STATE IS RENDERED, NOT SKIPPED. Silence reads as "fine", and "fine" is
       *    the one thing we cannot say here. Neither branch names a date, because the date is
       *    exactly what is unsupported. */
      /* ⛔ A REAL STATE, NOT AN EDGE CASE. A quoted project whose release never landed has no
       *    window and never had one. Silence would file it with the drafts, and the trader is
       *    waiting on a quote that exists. No live subject, so this is exercised by forcing it. */
      if (when === "notsent") {
        return "We've priced this quote, but it hasn't reached you yet \u2014 that one is on us. "
             + "Ring us on the number above, or leave a comment, and we'll get it straight to you.";
      }
      if (when === "unconfirmed") {
        return priced
          ? "Here are your prices. We can't confirm from here whether they are still current \u2014 "
            + "leave a comment or ring us and we'll check before you order."
          : "We've priced this quote and sent it to you. We can't confirm from here whether it is "
            + "still current \u2014 check your email, or leave a comment and we'll go through it.";
      }
      if (when === "lapsed") {
        return priced
          ? "These prices have lapsed. They are still here to read, but we can't hold them \u2014 leave a "
            + "comment or ring us and we'll re-quote at today's prices."
          : "We priced this quote, and that price has now lapsed. Everything below is still here to "
            + "read \u2014 leave a comment or ring us and we'll re-quote it at today's prices.";
      }
      if (priced) {
        return "Here are your prices" + (when ? ", " + when : "") + ". Quantities are fixed now \u2014 if "
             + "anything needs to change, leave a comment below and we'll re-quote it.";
      }
      /* No figures on this screen, so none are promised. Still live: a quote issued before
       * artefacts existed carries no pricing and never will. */
      return "We've priced this quote" + (when ? " (" + when + ")" : "") + " and sent it to you. The figures "
           + "aren't shown on this page yet \u2014 check your email, or leave a comment below and we'll go through it.";
    }
    if (pr.status === "won") {
      return "This quote has been accepted. Its products and quantities are fixed \u2014 leave a comment below if anything needs to change.";
    }
    if (pr.status === "lost" || pr.status === "archived") {
      return "This quote is closed. It stays here to read, and you can comment on it or ask us to quote it again.";
    }
    /* ⛔ A DRAFT IS NOT A SENT QUOTE. Measured on the founder's own screen: the chip read "draft"
     * and the sentence directly beneath it read "This quote has been sent, so its products and
     * quantities are fixed" — because this function had no draft branch and every unknown status
     * fell through to the submitted sentence. His project was open, editable, and being described
     * to him as closed, which is why he asked why he could no longer add products.
     *
     * The fall-through default is right for a status this page has not been taught — it is the
     * SAFE thing to say about a quote that has left. It is the wrong thing to say about the one
     * status that means the opposite, and draft is not an unknown status: it is the first one. */
    if (pr.status === "draft") {
      return "This project hasn't been sent yet \u2014 it is still yours to change. Open it to add "
           + "products, change quantities or send it to us.";
    }
    /* submitted, active, and anything the vocabulary grows that this page has not been taught. */
    return "This quote has been sent, so its products and quantities are fixed. Leave a comment below and we'll pick it up.";
  }

  /* ── MONEY ──────────────────────────────────────────────────────────────────────────────────
   *
   * ⛔ THE THEME NEVER COMPUTES A FIGURE. Not the total, not the tax, not a line total from a
   *    unit price. Every number rendered here came off the wire as integer cents from a STORED
   *    quote artefact. A theme that rounds differently from the invoice is invisible until a
   *    customer adds it up, and then it is a dispute about money rather than a rendering bug.
   *
   * Measured on the artefact for Q-260907-003:
   *   pricing {currencyCode:"AUD", taxIncluded:true, subtotal:169448, tax:null, total:169448,
   *            pricedLineCount:2, unpricedLineCount:1}
   *   lines   64969/129938 · 39510/39510 · null/null
   */
  /* ⛔ ONE DATE FORMATTER, IN THE SHOP'S TIMEZONE. Five call sites each carried their own
   *    toLocaleDateString(undefined, ...) — "undefined" meaning the VIEWER's locale AND clock.
   *    Measured across four timezones on one quote: 22 Sept in Sydney and Perth, 21 Sept in UTC
   *    and New York. A quote does not expire on a different day because the trader is in a van
   *    with a device set to UTC, and "expires today" versus "expires tomorrow" is the difference
   *    between ringing us and letting a price lapse.
   *
   * ⚠ HOW IT WAS FOUND, because the method matters more than the bug: the QA lane asked for a
   *   two-subject differential straddling the Sydney date boundary, and it PASSED — 22 and 21,
   *   exactly as a correct renderer should read. It passed because my browser sits in Sydney.
   *   The pass was a fact about where I was standing. Re-running the same subject in four
   *   timezones is what turned a green result into a defect.
   *
   * ⛔ THE LOCALE STAYS THE VIEWER'S — only the CLOCK is pinned. How a date is spelled is a
   *    property of the reader; which day it is, is a property of the shop.
   * ⛔ AND IT NEVER INVENTS A DATE: an unparseable value returns null and every caller already
   *    renders nothing rather than a guess. */
  function shopTz() {
    var t = String(root.getAttribute("data-shop-tz") || "").trim();
    return t || null;
  }
  function fmtDate(value) {
    var d = value ? new Date(value) : null;
    if (!d || isNaN(d)) return null;
    var opts = { day: "numeric", month: "short", year: "numeric" };
    var tz = shopTz();
    if (tz) {
      try { return d.toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric", timeZone: tz }); }
      catch (e) { /* an unknown zone must not blank the date */ }
    }
    return d.toLocaleDateString(undefined, opts);
  }

  function lineCountText(n) {
    return n === 1 ? "1 line" : n + " lines";
  }

  function money(cents, currency) {
    if (typeof cents !== "number" || !isFinite(cents)) return null;   // null is not zero
    try {
      return new Intl.NumberFormat(undefined, { style: "currency", currency: currency || "AUD" })
        .format(cents / 100);
    } catch (e) {
      return "$" + (cents / 100).toFixed(2);
    }
  }

  function pricingOf(d) {
    var q = (d && d.quote) || {};
    var p = q.pricing;
    return (p && typeof p === "object") ? p : null;
  }

  /* ⛔ A LINE WITH NO PRICE ON A PRICED QUOTE IS A REAL, PERMANENT STATE -- not a loading
   * spinner and not an error. One line of Q-260907-003 is blocked with no cost, so it will
   * never carry a figure, and a blank space there reads as our page failing to load rather
   * than as a thing we have to come back to them about. It says so. */
  function paintLineMoney(line, l, p) {
    if (!p) return;                                   // no artefact: no money anywhere, silently
    var box = document.createElement("div");
    box.className = "lfy-portal__money";
    var total = money(l.lineTotal, p.currencyCode);
    if (total === null) {
      box.className += " is-unpriced";
      box.textContent = "Not yet priced";
    } else {
      var t = document.createElement("b");
      t.textContent = total;
      box.appendChild(t);
      /* The unit price only earns its place when the quantity makes it a different number. */
      var unit = money(l.unitPrice, p.currencyCode);
      if (unit && typeof l.quantity === "number" && l.quantity > 1) {
        var u = document.createElement("span");
        u.textContent = unit + " each";
        box.appendChild(u);
      }
      /* ⛔ WAS/NOW — THREE STATES, AND ONLY THE THIRD RENDERS ANYTHING.
       *     listUnitPriceCents absent or null  -> no list price was recorded   -> NOTHING
       *     listUnitPriceCents === unitPrice   -> no discount was given        -> NOTHING
       *     listUnitPriceCents >   unitPrice   -> a real discount              -> was/now
       * ⛔ NEVER "was $50 now $50". And a quote written before the column existed must look EXACTLY
       * as it does today — every line on Q-260913-001/-002 and Q-260915-001 has a null list price,
       * so they are the live subject for that regression, not a fixture.
       *
       * ⚠️ BUILT BEFORE THE FIELD ARRIVES, DELIBERATELY. It is absent from the wire today (measured).
       * The contact rows proved the pattern: shipping the consumer first made that a zero-work
       * arrival instead of another round trip. The guard is the value being a NUMBER strictly
       * greater than the unit price, so an absent field, a null, a string or an equal value all
       * fall through to rendering nothing.
       * ⚠️ typeof === "number" is deliberate: its siblings arrive as numbers (13716, 4982). If this
       * one arrives as a STRING it will silently render nothing rather than misprice a line — and
       * that is the safe direction. The probe reports the type so the mismatch is caught upstream. */
      /* ⛔ THE WIRE KEY IS `listUnitPrice` — NO `Cents` SUFFIX, DESPITE BEING INTEGER CENTS.
       * `listUnitPriceCents` is real but it is the INTERNAL artefact/column name and never crosses
       * the boundary: tradeQuoteArtefact.ts:629 projects it as `listUnitPrice`, and :788 fills it
       * from `centsFrom(l.list_unit_price_cents)`, which returns the integer unchanged.
       * ⇒ So the value is cents (2929), directly comparable to `l.unitPrice` (also cents), and the
       * name is the one thing that does NOT say so. I built against the internal name first; it
       * would have read `undefined` forever and looked exactly like "the key arrived and the
       * storefront ignores it" — a false finding against working backend code.
       * ⚠️ A key that is always undefined renders nothing and throws nothing. Nothing would have
       * told us. */
      var listCents = l.listUnitPrice;
      if (typeof listCents === "number" && typeof l.unitPrice === "number" && listCents > l.unitPrice) {
        var wasText = money(listCents, p.currencyCode);
        if (wasText) {
          var w = document.createElement("span");
          w.className = "lfy-portal__was";
          /* The struck price is announced as what it WAS, so a screen reader does not read two
             prices with no relationship between them. */
          w.innerHTML = '<s aria-hidden="true">' + wasText + '</s>'
            + '<span class="lfy-portal__wasSr">Was ' + wasText + '</span>';
          box.appendChild(w);
        }
      }
    }
    line.appendChild(box);
  }

  /* ⛔ PRICE HISTORY — WHAT A REPRICE LOOKED LIKE, WHICH THE TRADER CANNOT CURRENTLY SEE AT ALL.
   * The wire carries a single `quoteVersion` number used purely as an ETag; the app lane measured
   * Q-260913-001 going v1 $498.20 -> v2 $473.29 -> v3 $498.20 and NONE of that reaches the reader.
   * A trader whose acceptance is refused with "these figures have changed" has no way to see what
   * changed, which makes a correct refusal feel arbitrary.
   *
   * ⛔ THE LIST IS RENDERED FROM `isCurrent`, NEVER FROM ARRAY POSITION. I asked for the flag
   * explicitly for this reason: an assumption about ordering is the kind of thing that silently
   * inverts, and a wrong "current" marker on a price is worse than no marker.
   * ⛔ AND `quoteVersionsTruncated` IS HONOURED. The read caps at 8. A capped list rendered as a
   * complete one is a lie with a number on it — a trader on version 11 would reasonably read
   * "v4…v11" as the whole story.
   * ⚠️ Totals are cents and arrive as NUMBERS on this wire (measured: 13716, 4982). A string would
   * fail the typeof and that row renders without money rather than with a wrong figure — the safe
   * direction, and the probe reports the type so a mismatch is caught at the producer. */
  function renderVersions(d) {
    var wrap = root.querySelector("[data-q-versions]");
    var listEl = root.querySelector("[data-q-version-list]");
    var capped = root.querySelector("[data-q-versions-capped]");
    if (!wrap || !listEl) return;
    listEl.textContent = "";
    wrap.hidden = true;
    if (capped) capped.hidden = true;

    var all = d && Array.isArray(d.quoteVersions) ? d.quoteVersions : null;

    /* ⛔ RELEASED VERSIONS ONLY — founder's ruling, 2026-09-17.
     *
     * The panel answers ONE question: "has the price I was given changed?" An internal draft is
     * not a price change; it is our workflow. Showing it would be a true row about our process
     * and a FALSE statement about the trader's commercial history — it invites "why did you price
     * it lower and not tell me?", which has no good answer and cannot be taken back.
     *
     * ⇒ The failure modes are not symmetric, which is what decided it: filtering can only ever
     * OMIT a row, while showing everything leaks pricing workflow to a customer permanently.
     *
     * ⛔ STRICT === true. `isReleased` is present-when-null on this wire, and an absent or null
     * flag must NOT read as released — a truthiness test would leak every draft on any quote
     * written before the column existed. Absent is not a third state here; it is "not released". */
    var rows = all ? all.filter(function (v) { return v && v.isReleased === true; }) : null;

    /* One version is not a history. Nothing to show, and a heading over a single row would be
       chrome pretending to be information.
       ⚠️ COUNTED AFTER THE FILTER, DELIBERATELY. A quote with three versions of which one is
       released has a one-row history, not a three-row one. Counting before would open a panel
       the filter then empties — the "renders empty and reads as broken" case. */
    if (!rows || rows.length < 2) return;

    /* ⛔ THE FILTER CAN HIDE THE ROW CARRYING `isCurrent`, AND I AM NOT REDEFINING THE WORD.
     *
     * `isCurrent` means LATEST on the wire, not latest-RELEASED, and the app lane kept that
     * meaning on purpose: changing what a field means behind an unchanged name silently moves
     * every consumer. ⇒ But on a quote whose newest version is unreleased, the true `isCurrent`
     * row is one we just filtered out, so nothing here would be marked current at all.
     *
     * ⛔ I do NOT compute a replacement "current" client-side. Two layers holding two definitions
     * of the same word is exactly how a wrong "current" marker ends up on a price — and a wrong
     * marker is worse than no marker, because the trader acts on it.
     *
     * ⇒ So: mark nothing, and SAY nothing is marked. `markedCurrent` is read from the surviving
     * rows only. When it is false the panel still renders (the history is real and the prices are
     * real) and the note below tells the reader the newest figure is not on this list, rather than
     * leaving them to assume the top row is live.
     * ⚠️ Live subject today: Q-260908-005, whose v1 and v2 are BOTH issued-only. */
    var markedCurrent = rows.some(function (v) { return v.isCurrent === true; });

    var p = pricingOf(d);
    rows.forEach(function (v) {
      var li = document.createElement("li");
      li.className = "lfy-portal__versionRow" + (v && v.isCurrent === true ? " is-current" : "");

      var label = document.createElement("span");
      label.className = "lfy-portal__versionNo";
      label.textContent = "v" + (v && typeof v.version === "number" ? v.version : "?");
      li.appendChild(label);

      var amount = document.createElement("b");
      var cents = v ? v.totalCents : null;
      var txt = (typeof cents === "number" && p) ? money(cents, p.currencyCode) : null;
      amount.textContent = txt || "—";
      li.appendChild(amount);

      var when = fmtDate(v && v.issuedAt);
      if (when) {
        var t = document.createElement("span");
        t.className = "lfy-portal__versionWhen";
        t.textContent = when;
        li.appendChild(t);
      }
      /* The current version is named, not merely styled — colour alone is not a label. */
      if (v && v.isCurrent === true) {
        var cur = document.createElement("span");
        cur.className = "lfy-portal__versionCur";
        cur.textContent = "current";
        li.appendChild(cur);
      }
      listEl.appendChild(li);
    });

    /* ⛔ THE TRUNCATION NOTE MUST COUNT WHAT IS ON SCREEN, NOT WHAT ARRIVED.
     * `rows` is now the FILTERED list, so this says "the most recent 2" when two released rows
     * survived — which is what the reader can see. Using the unfiltered length here would state
     * a number that appears nowhere on the page. */
    if (capped && d.quoteVersionsTruncated === true) {
      capped.textContent = "Showing the most recent " + rows.length + " versions of this quote.";
      capped.hidden = false;
    }

    /* Nothing on this list is the live price, and the reader cannot tell that by looking —
       the top row would otherwise read as current by position. Reuses the truncation slot only
       when truncation is not already using it, so the two notes can never overwrite each other. */
    if (capped && capped.hidden && !markedCurrent) {
      capped.textContent = "Your latest figures aren't in this list yet.";
      capped.hidden = false;
    }

    wrap.hidden = false;
  }

  function renderTotals(d) {
    var wrap = root.querySelector("[data-q-totals]");
    if (!wrap) return;
    var p = pricingOf(d);
    wrap.hidden = !p;
    if (!p) return;

    var cur = p.currencyCode;
    var sub = money(p.subtotal, cur), tot = money(p.total, cur), tax = money(p.tax, cur);

    var subRow = root.querySelector("[data-q-subtotal-row]");
    /* Subtotal is only worth a row when it differs from the total -- otherwise it is the same
     * number twice and the eye has to work out why. */
    if (subRow) subRow.hidden = !(sub && tot && sub !== tot);
    text(root.querySelector("[data-q-subtotal]"), sub || "");

    /* ⛔ tax NULL MEANS NOT BROKEN OUT, NEVER ZERO. Rendering "$0.00" would assert that an
     * inc-GST price contains no GST -- a claim about someone's invoice that is simply false.
     * The row is absent, and the note below says where the GST is instead. */
    var taxRow = root.querySelector("[data-q-tax-row]");
    if (taxRow) taxRow.hidden = (tax === null);
    text(root.querySelector("[data-q-tax]"), tax || "");

    var totRow = root.querySelector("[data-q-total-row]");
    if (totRow) totRow.hidden = !tot;
    text(root.querySelector("[data-q-total]"), tot || "");

    /* taxIncluded is STATED by the server and never inferred. If it does not say, we do not say. */
    var note = root.querySelector("[data-q-tax-note]");
    if (note) {
      /* No figures on screen means no prices to be inclusive OF — the note would be answering a
       * question the panel has not raised. */
      if (!tot) { note.hidden = true; }
      else if (p.taxIncluded === true) { text(note, "All prices include GST."); note.hidden = false; }
      else if (p.taxIncluded === false) { text(note, "Prices exclude GST."); note.hidden = false; }
      else { note.hidden = true; }
    }

    /* A total that covers only part of the quote must say so, or it reads as the whole job. */
    var un = root.querySelector("[data-q-unpriced]");
    if (un) {
      var n = p.unpricedLineCount;
      if (typeof n === "number" && n > 0) {
        /* ⛔ THE SENTENCE MUST NOT REFERENCE A TOTAL THAT IS NOT ON SCREEN. Once the rows
         * actually hide, an all-blocked quote shows NO figures at all — and "they aren't in
         * this total" then points at something the panel is not displaying. Mode 7 from the
         * other direction: prose true of a state the surface is no longer in. */
        var haveTotal = !!tot;
        text(un, !haveTotal
          ? (n === 1 ? "That line isn't priced yet. We'll come back to you with a figure."
                     : "None of these lines is priced yet. We'll come back to you with figures.")
          : n === 1
            ? "One line isn't priced yet, so it isn't in this total. We'll come back to you on it."
            : n + " lines aren't priced yet, so they aren't in this total. We'll come back to you on them.");
        un.hidden = false;
      } else { un.hidden = true; }
    }
  }

  /* ⛔ THE SUMMARY IS CHECKED AGAINST THE THREAD IT SUMMARISES. The founder photographed
   *    "ALL ACTIONED" sitting directly above a comment badged OPEN. Measured on the wire and it
   *    is not my arithmetic: the server sends openCount 0 beside a comment whose own state is
   *    "open" with actionedAt null. The two disagree at source.
   *
   *    ⚠ THE COMMENT IS MERCHANT-AUTHORED, and until today no such row had ever existed, so
   *      openCount had never met one. Reported to the app lane; the count is theirs to fix.
   *
   * ⛔ WHAT THIS PAGE DOES ABOUT IT: it does not repair the number and it does not repeat it.
   *    "All actioned" is a promise the thread visibly contradicts, and of the two the thread is
   *    the one the trader can read for themselves. So the claim is WITHDRAWN and nothing is put
   *    in its place — the same branch as a count we never received, because a count we cannot
   *    trust and a count we do not have are worth exactly the same to a trader.
   *    ⛔ It is NOT rewritten to "1 open": that would be me computing the number, which is the
   *      one thing this page never does with a figure the server owns. */
  function renderOpenCount(d) {
    var chip = root.querySelector("[data-q-open]");
    if (!chip) return;
    var n = d && d.openCount;
    if (typeof n !== "number" || !isFinite(n)) { chip.hidden = true; chip.textContent = ""; return; }
    if (n === 0) {
      var rows = (d && Array.isArray(d.comments)) ? d.comments : [];
      var contradicted = rows.some(function (c) { return c && c.state === "open"; });
      if (contradicted) { chip.hidden = true; chip.textContent = ""; return; }
    }
    chip.hidden = false;
    if (n > 0) {
      chip.className = "lfy-portal__cst is-open";
      chip.textContent = n === 1 ? "1 open" : n + " open";
    } else {
      chip.className = "lfy-portal__cst is-actioned";
      chip.textContent = "all actioned";
    }
  }

  function renderComments(d, detail) {
    var thread = root.querySelector("[data-q-thread]");
    if (!thread) return;
    thread.textContent = "";
    /* ⛔ THE SERVER RETURNS THESE NEWEST-FIRST, and a thread is a conversation — read in that order
     * it answers before it asks. Measured, not assumed: 04:26 came back ahead of 04:05 on the QA
     * project, and I had been rendering wire order straight down the page.
     *
     * The sort is HERE rather than requested of the app lane, because the order a thread reads in
     * is a property of this surface, not of the data — the merchant desk may well want newest-first,
     * and neither of us should be depending on the other's preferred ordering.
     *
     * A row with no createdAt keeps its wire position rather than being flung to one end. */
    renderOpenCount(d);
    var rows = (Array.isArray(d.comments) ? d.comments.slice() : []).sort(function (a, b) {
      var x = Date.parse(a && a.createdAt), y = Date.parse(b && b.createdAt);
      if (isNaN(x) || isNaN(y)) return 0;
      return x - y;
    });
    var none = root.querySelector("[data-q-nocomments]");
    if (none) none.hidden = rows.length > 0;

    var states = vocab(d, "state");
    rows.forEach(function (c) {
      var el = document.createElement("div");
      el.className = "lfy-portal__cmt";

      var hd = document.createElement("div");
      hd.className = "lfy-portal__cmtHd";
      var who = authorLabel(c.author);
      if (who) { var b = document.createElement("b"); b.textContent = who; hd.appendChild(b); }
      if (c.createdAt) {
        var dt = new Date(c.createdAt);
        if (!isNaN(dt)) {
          var s = document.createElement("span");
          s.textContent = dt.toLocaleString(undefined, { day: "numeric", month: "short", hour: "numeric", minute: "2-digit" });
          /* the full stamp on hover, so "which of these two came first" is always answerable */
          s.title = dt.toLocaleString();
          hd.appendChild(s);
        }
      }
      /* ⛔ THE BADGE PRINTS COPY I OWN, NOT THE TOKEN THE SERVER SENT. It used to echo c.state
       *    verbatim whenever the value was truthy. Measured by forcing four values through the
       *    running page: the layout survives anything — the comment renders, the badge keeps its
       *    26px, no errors — but "zz_internal_flag" printed itself to a customer, 109px wide.
       *    So it failed closed on LAYOUT and wide open on VOCABULARY, and the second is the one
       *    that reaches a trader.
       *
       * ⛔ AN UNRECOGNISED STATE NOW RENDERS NO BADGE AT ALL. The vocabulary tells me a value
       *    EXISTS; it does not tell me what to call it in front of a customer, and those are
       *    different questions. Silence about a state I cannot name is the safe direction — the
       *    same asymmetry as the expiry verdict, where the unsafe direction was the one that made
       *    a claim.
       *
       * ⚠ "sent" IS PRE-COPIED, before the app lane ships it, so the deploy can go either way
       *   round with no window in which a merchant comment shows a blank or a raw token. It means
       *   the merchant wrote it and nothing is pending from us. Deliberately NOT "delivered" and
       *   NOT "seen": nothing in this system records a trader looking, and a badge saying seen
       *   would make a claim no row supports. */
      var CST_COPY = { open: "open", actioned: "actioned", sent: "sent" };
      if (c.state && CST_COPY[c.state]) {
        var st = document.createElement("em");
        /* ⛔ THE VOCABULARY GATES THE STYLING, NOT THE BADGE — measured, and I had written the
         * opposite here a minute earlier. Having copy is what decides whether a trader sees the
         * word; the declaration only decides whether it gets its colour. That is deliberate: it
         * means the wire and the theme can deploy in either order, and a merchant comment arriving
         * before the vocabulary does shows a correct word in neutral grey rather than nothing. */
        var known = states.indexOf(c.state) !== -1;
        st.className = "lfy-portal__cst" + (known ? " is-" + c.state : "");
        st.textContent = CST_COPY[c.state];
        hd.appendChild(st);
      }
      el.appendChild(hd);

      var body = document.createElement("p");
      body.className = "lfy-portal__cmtBody";
      body.textContent = c.body || "";
      el.appendChild(body);

      /* ⛔ BRANCH ON state, NEVER ON outcome TRUTHINESS. outcome is non-null if and only if state is
       * "actioned", guaranteed by a CHECK constraint — so if(outcome) and
       * if(state==="actioned") look equivalent and are not. Reading the state is what makes an
       * actioned comment with a missing outcome visible as a fault instead of silently rendering
       * as an unanswered one. */
      if (c.state === "actioned") {
        var out = document.createElement("div");
        out.className = "lfy-portal__cmtOut";
        if (c.outcome) {
          /* ⛔ outcomeAuthor IS NULLABLE AND NULL IS A REAL STATE — the shop has no name on record.
           * The outcome is then shown UNATTRIBUTED. No fallback, ever: the store's internal domain
           * must never reach a customer, and an operator's email must never appear here at all. */
          if (c.outcomeAuthor) {
            var who2 = document.createElement("b");
            who2.textContent = c.outcomeAuthor;
            out.appendChild(who2);
            out.appendChild(document.createTextNode(" — " + c.outcome));
          } else {
            out.appendChild(document.createTextNode(c.outcome));
          }
        } else {
          out.className += " is-missing";
          out.textContent = "Marked as actioned. We'll confirm what was done.";
        }
        el.appendChild(out);
      }
      thread.appendChild(el);
    });
  }

  /* ── Quote history, from the endpoint rather than from what the page happened to know ────────
   *
   * This view used to render from the portal envelope — the open project plus lastSubmitted — and
   * carried a note saying the full list "needs GET /trade/projects". It does not: that route has
   * been returning 200 with the full list, and instrumenting window.fetch across a clean #history
   * render showed ZERO calls to it. The visible symptom was a row reading "Untitled project" while
   * the wire had name: "Testcizpo1", because lastSubmitted carries no name and the envelope was
   * all this view ever looked at.
   *
   * ⛔ THREE OUTCOMES, AND TWO OF THEM MUST NOT LOOK ALIKE. A trader with no quotes and a trader
   *    whose history failed to load are in completely different situations, and collapsing them
   *    into one empty state is the same defect as a check that passes over an empty set:
   *
   *      rows       -> the list
   *      []         -> "you haven't sent a quote yet"   (PRESENT AND EMPTY — the server said so)
   *      no answer  -> say we could not load it, and fall back to the envelope so the view is
   *                    never worse than it was before this existed
   *
   *    The endpoint returns [] rather than 404 precisely so these stay distinguishable; throwing
   *    that away on the client would waste the distinction the app lane built in. */
  var historyLoaded = false;
  /* ── The rail's expandable quote list ────────────────────────────────────────────────────────
   *
   * Founder: "if you want quote history in left side menu we can show the plus and open expand
   * that?? and show quotes number with status pill?"
   *
   * ⛔ NO NEW REQUEST. /projects is already fetched once per load by loadHistory(), and its rows
   *    are already kept in lastProjects for the other-drafts pill. This reads that same array, so
   *    the rail cannot disagree with Quote history or with the panel — one fetch, one source,
   *    three surfaces.
   *
   * ⛔ SAME ADDRESS RULE AS EVERYWHERE ELSE: reference when the wire carries one, id when it does
   *    not, never an invented Q-number. The href goes through routeFromHash() ->
   *    resolvePendingProject() -> loadProjectInto(), which asks the server whether the project is
   *    editable and picks the surface from the ANSWER — so a draft opens editable and a sent quote
   *    opens in the reader, without this function knowing anything about status.
   *
   * ⚠️ THE PILL IS REPORTED, NEVER INFERRED. No status on the row means no pill, not a guess.
   */
  function renderRailHistory() {
    var box = root.querySelector("[data-rail-history]");
    var toggle = root.querySelector("[data-rail-history-toggle]");
    if (!box || !toggle) return;
    var rows = Array.isArray(lastProjects) ? lastProjects : [];
    if (!rows.length) {
      /* Nothing to expand into: the toggle does not exist for the reader, and the row stays a
       * plain link. Hiding the control is honest; showing an empty drawer is not. */
      toggle.hidden = true;
      box.hidden = true;
      box.textContent = "";
      return;
    }
    /* Newest first, the same order Quote history uses — a ledger is read from the most recent. */
    var sorted = rows.slice().sort(function (a, b) {
      var x = Date.parse(a && a.createdAt), y = Date.parse(b && b.createdAt);
      if (isNaN(x) || isNaN(y)) return 0;
      return y - x;
    });
    box.textContent = "";
    sorted.forEach(function (pj) {
      var li = document.createElement("li");
      var a = document.createElement("a");
      a.className = "lfy-portal__railQuote";
      var addr = addressOf(pj);
      /* ⛔ THE RAIL SENT EVERY ROW TO #project/, INCLUDING QUOTES THAT CANNOT OPEN AS A PROJECT.
       * The founder: reaching Q-260908-005 from Quote history works, but the same quote from the
       * left menu landed on #project/… and errored. A project that has been sent is READ through
       * the quote view — the project view is the editable draft — so a `quoted`/`won`/`lost`
       * project addressed as #project/ resolves to nothing the reader can see.
       *
       * Quote history already had this right (the row is only `is-openable` into #quote/ when the
       * project has left draft). The rail is a second list of the same projects and was built with
       * one hardcoded prefix — the same two-renderers-one-rule shape as the vendor field and the
       * SKU copy button: fix it in both places or it is not fixed. */
      var draftish = String(pj && pj.status || "").toLowerCase() === "draft";
      if (addr) a.setAttribute("href", (draftish ? "#project/" : "#quote/") + addr);
      /* The open project is marked, so the rail says where you are rather than only where you
       * could go. Compared on id, which both routes agree on. */
      /* The quote view's project wins while a quote is open — that is what the reader is looking
         at. Falls back to the open draft project on every other view. */
      var markId = (currentView === "quote" && openQuoteProjectId) ? openQuoteProjectId : openProjectId;
      if (markId && String(pj.id) === String(markId)) {
        a.classList.add("is-current");
        a.setAttribute("aria-current", "true");
      }
      var ref = document.createElement("span");
      ref.className = "lfy-portal__railQuoteRef";
      ref.textContent = pj.reference || pj.name || "Untitled project";
      a.appendChild(ref);
      if (pj.status) {
        var st = document.createElement("span");
        st.className = "lfy-portal__chip is-" + String(pj.status).toLowerCase().replace(/[^a-z]+/g, "-");
        st.textContent = pj.status;
        a.appendChild(st);
      }
      li.appendChild(a);
      box.appendChild(li);
    });
    toggle.hidden = false;
    toggle.setAttribute("aria-label", rows.length === 1 ? "Show your 1 quote" : "Show your " + rows.length + " quotes");
    /* ⛔ OPEN THE LIST WHEN THE READER IS IN IT. The founder had to expand Quote history by hand
     * every time, on a view whose whole subject is one of the quotes inside it — the rail showed a
     * collapsed section while the page beneath it displayed a member of that section.
     * Only forced OPEN, never forced closed: a reader who collapses it deliberately while staying
     * on a quote keeps their choice until they navigate again. */
    if (currentView === "quote" && openQuoteProjectId && toggle.getAttribute("aria-expanded") !== "true") {
      toggle.setAttribute("aria-expanded", "true");
      box.hidden = false;
      var grp = root.querySelector("[data-rail-history-group]");
      if (grp) grp.classList.add("is-open");
    }
  }

  function wireRailHistory() {
    var toggle = root.querySelector("[data-rail-history-toggle]");
    var box = root.querySelector("[data-rail-history]");
    if (!toggle || !box) return;
    toggle.addEventListener("click", function () {
      var open = toggle.getAttribute("aria-expanded") === "true";
      toggle.setAttribute("aria-expanded", open ? "false" : "true");
      box.hidden = open;
      var group = root.querySelector("[data-rail-history-group]");
      if (group) group.classList.toggle("is-open", !open);
    });
  }

  function loadHistory(d) {
    var base = String(root.getAttribute("data-endpoint") || "").replace(/\/$/, "");
    if (!base) return renderHistory(d, null);
    fetch(base + "/projects", { headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then(function (r) {
        if (!r.ok) throw new Error(String(r.status));
        return r.json();
      })
      .then(function (list) {
        if (!list || !Array.isArray(list.projects)) throw new Error("shape");
        historyLoaded = true;
        lastProjects = list.projects;
        renderHistory(d, list);
        renderAttachRouter(list);
        /* The rail's list arrives with this fetch, not at init — so it is painted here, where the
         * data lands, rather than left empty until something else happens to repaint. */
        renderRailHistory();
        /* ⛔ AND REPAINT THE PANEL, BECAUSE THIS FETCH LANDS AFTER IT. renderOtherDrafts() runs
         *    inside the open read; this list arrives a moment later. Without re-running it, the
         *    status pill would be missing on first paint and appear only if something else
         *    happened to repaint — the "correct when I test it slowly, wrong for the customer"
         *    shape this file has been bitten by repeatedly.
         *
         * ⛔ GUARDED, BECAUSE THIS PAYLOAD BELONGS TO THE OPEN PROJECT AND THE SCREEN MAY HAVE
         *    MOVED ON. `d` here is the OPEN read's answer, so d.otherDrafts is the set relative to
         *    the SERVER's current project. loadProjectInto() can repoint openProjectId to a
         *    different draft and paint a filtered panel — and this fetch takes ~1s, while a
         *    #project/<ref> deep link routes at init, so the two genuinely race. Landing second
         *    without this guard would overwrite the filtered panel with the unfiltered one and put
         *    a project back underneath its own heading: the precise defect the founder
         *    screenshotted, reintroduced by the fix for the pill.
         *
         *    Same rule as loadComments(): a read paints the surface it belongs to, never the one
         *    that happens to be showing when it lands. */
        if (d.project && String(d.project.id) === String(openProjectId)) renderOtherDrafts(d);
      })
      /* ⛔ THE RAIL LIST IS PAINTED ON FAILURE TOO, AND NOT BECAUSE IT HAS ANYTHING TO SHOW.
       *    lastProjects stays empty, so renderRailHistory() hides the toggle and the drawer and
       *    leaves Quote history as the plain link it is without this feature — which is the right
       *    degradation. It already behaved that way, but only because the button ships `hidden` in
       *    the Liquid: the correct outcome was resting on an initial attribute nobody had written
       *    down, and the next person to change that default would have shipped an expander that
       *    opens onto nothing. Stated here instead of implied there. */
      .catch(function () { renderHistory(d, null); renderAttachRouter(null); renderRailHistory(); });
  }

  function renderHistory(d, list) {
    var box = root.querySelector("[data-history]");
    if (!box) return;
    box.textContent = "";
    var rows = [];
    var openId = d && d.project ? d.project.id : null;   /* same payload, so no read to race */
    var fromWire = !!(list && Array.isArray(list.projects));

    if (fromWire) {
      /* ⛔ A LEDGER READS NEWEST FIRST — the opposite of the comment thread, and deliberately so.
       * A thread is a conversation and must read forwards; a history is a list of things that
       * happened and the most recent is the one being looked for. Sorted here rather than trusted
       * from the wire for the same reason as the thread: the order is a property of this surface.
       * A row with no date keeps its position rather than being flung to one end. */
      rows = list.projects.slice().sort(function (a, b) {
        var x = Date.parse(a && a.createdAt), y = Date.parse(b && b.createdAt);
        if (isNaN(x) || isNaN(y)) return 0;
        return y - x;
      }).map(function (pj) {
        return { id: pj.id, ref: pj.reference, name: pj.name, status: pj.status, n: pj.lineCount, order: pj.draftOrderName };
      });
    } else {
      if (d.project) rows.push({ id: d.project.id, ref: d.project.reference, name: d.project.name, status: d.project.status, n: d.lineCount });
      var last = lastSubmitted(d);
      if (last && (!d.project || last.reference !== d.project.reference)) {
        rows.push({ id: last.id, ref: last.reference, name: last.name, status: last.status, n: last.lineCount, order: last.draftOrderName });
      }
    }

    if (!rows.length) {
      var none = document.createElement("p");
      none.className = "lfy-portal__muted";
      /* Present-and-empty says one thing; a failed read says another. */
      /* ⛔ THREE DIFFERENT NOTHINGS. A signed-out visitor, a trader with no quotes, and a failed
       *    read are three different facts and used to be two sentences. A trader with six quotes
       *    opening this on a new phone was shown "you haven't sent a quote yet" — my own
       *    null-is-not-zero rule, broken on the storefront, where it tells a customer their work
       *    does not exist. */
      /* ⛔ 72 OF 74 APPROVED TRADERS HAVE NEVER CREATED A PROJECT, so this is the screen almost
       *    every one of them meets — and it contained correct copy and NOTHING TO PRESS. "Start a
       *    project first" with no way to start one is a dead end wearing an explanation. */
      none.textContent = (d && d.signedIn === false)
        ? "Sign in to see your quote history."
        : fromWire
          ? "You haven't sent a quote yet. Your sent quotes will be listed here."
          : "We couldn't load your quote history just now. Please refresh, or ring us on the number above.";
      if (d && d.signedIn === false) {
        var sa = document.createElement("a");
        sa.className = "button button--primary lfy-portal__submit";
        sa.setAttribute("href", "/customer_authentication/login?return_to=" + encodeURIComponent(location.pathname + (location.hash || "")));
        sa.textContent = "Sign in";
        box.appendChild(none);
        box.appendChild(sa);
        return;
      }
      box.appendChild(none);
      if (!(d && d.signedIn === false)) box.appendChild(startHereLink());
      return;
    }
    rows.forEach(function (r) {
      // The row is the link. A separate "View" control would put a second target on a line whose
      // whole purpose is to open one thing.
      var row = document.createElement(r.id ? "a" : "div");
      row.className = "lfy-portal__qhRow" + (r.id ? " is-openable" : "");
      /* ⛔ THE OPEN PROJECT IS NOT A QUOTE TO READ. Every row linked into the read-only reader,
       * including the one row that is still being built — so the shortest path to the founder's
       * dead end was the ordinary one: open history, click your own project. */
      var isOpen = !!(r.id && openId && String(r.id) === String(openId));
      var addr = r.ref || r.id;   /* readable when the wire gave us a reference, never invented */
      if (isOpen) { row.setAttribute("href", "#project/" + addr); row.setAttribute("data-open-project", ""); }
      else if (r.id) row.setAttribute("href", "#quote/" + addr);
      var ref = document.createElement("span");
      ref.className = "lfy-portal__qhRef";
      ref.textContent = r.ref || "Not yet referenced";
      var nm = document.createElement("span");
      nm.textContent = r.name || "Untitled project";
      var meta = document.createElement("span");
      meta.className = "lfy-portal__qhMeta";
      var bits = [];
      if (typeof r.n === "number") bits.push(lineCountText(r.n));
      if (r.order) bits.push(r.order);
      meta.textContent = bits.join(" · ");
      var st = document.createElement("span");
      if (r.status) { st.className = "lfy-portal__chip is-" + String(r.status).toLowerCase().replace(/[^a-z]+/g, "-"); st.textContent = r.status; }
      row.appendChild(ref); row.appendChild(nm); row.appendChild(meta); row.appendChild(st);
      box.appendChild(row);
    });

    /* Both of these are the page telling the truth about what it is showing, rather than letting a
     * short list read as a complete one. */
    if (fromWire && list.truncated) {
      var t = document.createElement("p");
      t.className = "lfy-portal__muted";
      t.textContent = "Showing your most recent " + rows.length + " quotes.";
      box.appendChild(t);
    } else if (!fromWire) {
      var f = document.createElement("p");
      f.className = "lfy-portal__muted";
      f.textContent = "We couldn't reach your full history, so this is only what this page already knew.";
      box.appendChild(f);
    }
  }

  function renderAccount(d) {
    var t = (d && d.trade) || {};
    text(root.querySelector("[data-acct-company]"), t.companyName || "Your trade account");
    var chip = root.querySelector("[data-acct-status]");
    /* ⛔ THE CLASS MUST FOLLOW THE TEXT. The markup carried a fixed is-active, so an account
     * that was not approved would have read "pending" in the green reserved for active — the
     * colour saying one thing while the word said another, which is worse than no colour. */
    if (chip) {
      chip.textContent = t.approved ? "active" : "pending";
      chip.className = "lfy-portal__chip is-" + (t.approved ? "active" : "pending");
      chip.hidden = false;
    }
    // ⛔ Only what the server actually sends. ABN and trade type are not on the wire, and a blank
    // that looks like a value the customer forgot to give is worse than saying so.
    if (t.abn) text(root.querySelector("[data-acct-abn]"), t.abn);
    if (t.tradeType) text(root.querySelector("[data-acct-type]"), t.tradeType);
    if (t.contactEmail) text(root.querySelector("[data-acct-email]"), t.contactEmail);
    /* The same guard as every other row: fill ONLY when the server sends a value, so a dash keeps
       meaning "we do not hold this" rather than becoming a blank that reads as the trader's own
       omission. These two are not on the trader wire yet (measured 2026-09-17 — the account object
       carries approved/companyName/abn/tradeType only); the rows are rendered anyway on the
       founder's instruction so a trader can see what is held and what is missing. */
    if (t.contactName) text(root.querySelector("[data-acct-contact-name]"), t.contactName);
    if (t.contactPhone) text(root.querySelector("[data-acct-contact-phone]"), t.contactPhone);
  }

  /* ⛔ THE SIGNED-OUT ACCOUNT VIEW. renderAccount() above fills in what the server sent; this one
   * exists because there IS no server answer for a visitor with no session, and the markup's own
   * defaults are not a safe fallback — "Not connected yet" against ABN and Trade type describes a
   * half-configured record, so a stranger was shown an account that does not exist.
   *
   * ⛔ THE LITERALS ARE OVERWRITTEN, NOT LEFT ALONE. The dd elements carry their copy in Liquid, so
   *    doing nothing here is what produced the defect. Every field this view can show is written.
   *
   * The company slot carries the prompt because it is the first line of the panel; the dl rows go
   * to an em dash, which reads as "nothing to show" rather than as a value. */
  /* The rail is hidden by CSS until the root says signed-in, so that one attribute is the whole
   * navigation. It is written in exactly two places — here and the signed-out branch — so there is
   * one way to show it and one way to hide it, rather than four call sites to keep in agreement. */
  function revealRail() {
    root.setAttribute("data-signed-in", "");
    root.removeAttribute("data-signed-out");
  }

  /* ⛔ THE MASK MUST NOT OUTLIVE ITS USEFULNESS, AND 15s IS NOT A PLAN.
   *
   * The mask (lfy-trade.css, .lfy-portal__mask) hides the views and masthead while the root
   * carries neither data-signed-in nor data-signed-out, so it clears automatically on every
   * settle path — including startDeadline()'s 15s timeout, which calls revealRail(). That is the
   * FLOOR, not the intent: fifteen seconds behind a blank rectangle is a worse page than the
   * early-literals problem the mask was added to fix.
   *
   * So it gives up on its own and hands the page back exactly as it behaves today. Failing OPEN is
   * the same rule the rail follows: "we could not tell" must never mean "you get nothing".
   *
   * ⚠️ THIS CLOCK STARTS WHEN THE SCRIPT RUNS, NOT WHEN THE PAGE DOES, AND MY FIRST COMMENT HERE
   *    GOT THAT WRONG. It claimed "4000ms clears the real case" against a window measured from
   *    navigation (account view 3624ms, project 3583ms). Measured after shipping, the attribute
   *    actually landed at 6258ms and 5756ms on the page clock — ~2s later, because that is how long
   *    it takes this script to execute. So the escape is LATER than the answer in every case
   *    observed, and on a slow connection it stretches further still.
   *
   *    That is safe — it fails open, and a mask that clears late is a mask that never stranded
   *    anyone — but it is NOT the tight bound the old comment implied. If this ever needs to be a
   *    real deadline, it has to start from a navigation-relative origin
   *    (performance.timing / performance.now() at registration), not from here. */
  var MASK_GIVE_UP_MS = 4000;
  setTimeout(function () {
    if (root) root.setAttribute("data-mask-timeout", "");
  }, MASK_GIVE_UP_MS);

  function renderAccountSignedOut() {
    text(root.querySelector("[data-acct-company]"), "Sign in to see your trade account.");
    var chip = root.querySelector("[data-acct-status]");
    if (chip) { chip.hidden = true; chip.textContent = ""; }
    text(root.querySelector("[data-acct-abn]"), "—");
    text(root.querySelector("[data-acct-type]"), "—");
    /* ⛔ THE SIGNED-OUT RESET MUST COVER EVERY ROW. A row added to the panel and not added here
       would keep the PREVIOUS account's value on screen after sign-out — a real leak, not a
       cosmetic one, on a shared machine. */
    text(root.querySelector("[data-acct-contact-name]"), "—");
    text(root.querySelector("[data-acct-contact-phone]"), "—");
    text(root.querySelector("[data-acct-email]"), "—");
    /* ⛔ AND THE NOTE UNDERNEATH, which says "To change any of these, email us and we'll update
     * your account" — a sentence that presumes an account exists. Blanking the fields above while
     * leaving it would have swapped one fabrication for a quieter one. */
    text(root.querySelector("[data-acct-note]"),
      "Sign in to see your trade account details. Not a trade customer yet? Apply for an account and we'll be in touch.");
  }

  /* ── Rename ───────────────────────────────────────────────────────────────────────────────
   * Only offered when the server declares it, so this disappears on submit without the theme
   * inspecting project.status — the same reason every other control here is declaration-driven
   * rather than state-inferred.
   *
   * ⛔ CORRECTED 2026-09-13: this line used to say "a locked project returns projectOps []".
   *    IT DOES NOT, and that shorthand was the source of the error — I read it, believed it, and
   *    propagated it into the wireSubmit note at :894 before a peer measured the wire:
   *      draft   ["submit","rename","comment","attach"]
   *      quoted  ["comment","attach"]
   *    `tradeProjectOperations.ts:260` drops only the operations carrying
   *    `requiresEditableProject: true` — submit and rename withdraw; comment and attach SURVIVE,
   *    because a trader can still talk to us and attach a schedule against a quoted job.
   *    ⇒ The hiding works per-OPERATION. It is not an accident of an empty array, and a reader
   *      expecting [] would misread a healthy two-entry payload as a bug. */
  var canRename = false;
  function renameDeclared(d) {
    return Array.isArray(d && d.projectOps) && d.projectOps.indexOf("rename") !== -1;
  }

  function wireRename() {
    var btn = root.querySelector("[data-rename]");
    if (!btn) return;
    btn.addEventListener("click", function () {
      var nameEl = root.querySelector("[data-project-name]");
      if (!nameEl) return;
      var current = (nameEl.textContent || "").trim();
      var next = window.prompt("Name this project", current === "Untitled project" ? "" : current);
      if (next === null) return;                       // cancelled: nothing is sent
      var trimmed = String(next).trim().slice(0, 200);  // matches the server's cap, so it never truncates silently
      if (!trimmed || trimmed === current) return;      // nothing to say to the server
      btn.disabled = true;
      var base = String(root.getAttribute("data-endpoint")).replace(/\/$/, "");
      fetch(base + "/project", {
        method: "PATCH",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ projectName: trimmed }),
      })
        .then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (data) { return { status: res.status, data: data || {} }; });
        })
        .then(function (r) {
          btn.disabled = false;
          var m = (window.LFY_TRADE && window.LFY_TRADE.messageFor)
            ? window.LFY_TRADE.messageFor(r.status, r.data.reason, "update")
            : { tone: r.status === 200 ? "ok" : "err", text: r.status === 200 ? "Renamed." : "That couldn't be saved." };
          say(r.status === 200 ? "Project renamed." : m.text, r.status === 200 ? "ok" : m.tone);
          if (r.status === 200) reload();
        })
        .catch(function () { btn.disabled = false; say("That couldn't be saved. Please try again.", "err"); });
    });
  }

  /* ── THE ADD DIALOG ─────────────────────────────────────────────────────────────────────────
   *
   * ⛔ THIS USED TO SCROLL, NOT OPEN. Every [data-start-project] button — the big one on the empty
   *    screen and the one on the sent screen — called scrollIntoView and focused a search box 300px
   *    further down the page. The page's most prominent control was a POINTER TO ANOTHER CONTROL,
   *    which is a large part of why the founder read this page as unfinished. The stale Liquid
   *    comment justifying it ("a project cannot be created empty") is corrected in the section.
   *
   * ⛔ NO trapFocus, BECAUSE THERE IS NONE TO CALL. Neither global.js nor modal.js is loaded on
   *    this page — measured, not assumed: the section loads exactly two assets, its own CSS and
   *    JS. So focus is handled here, minimally and honestly: move into the dialog on open, return
   *    to the opener on close. A full focus trap would be more than this needs and would be a
   *    second, worse copy of something the theme already ships elsewhere.
   */
  var modalOpener = null;

  function addModal() { return root.querySelector("[data-add-modal]"); }

  function openAddModal(opener) {
    var m = addModal();
    if (!m) return;
    modalOpener = opener || null;
    m.hidden = false;
    /* The dialog's title says which job this is, matching the panel's own label — a trader with
       no project is starting one, a trader with a project is adding to it.
     *
     * ⛔ AND THE PANEL'S OWN LABEL IS HIDDEN ONCE THE TITLE CARRIES IT. Copying the text up into
     *    the title bar left "Add a product to this project" printed TWICE, four lines apart, in
     *    two different sizes — and I could not see it in the assertions, because "the title reads
     *    correctly" was true. It read correctly and said the same thing as the line beneath it.
     *    That is the founder's original complaint about this page — two controls saying one
     *    thing — reintroduced by me in a new place, one screenshot after fixing it elsewhere.
     *
     *    The label stays in the markup as the <label for> of the search input, so the field keeps
     *    its accessible name; it is visually hidden rather than removed. */
    var t = root.querySelector("[data-add-modal-title]");
    var label = root.querySelector("[data-add-label]");
    if (t && label) {
      t.textContent = label.textContent || "Add to your project";
      label.classList.add("visually-hidden");
    }
    var input = root.querySelector("[data-portal-search]");
    /* preventScroll: the dialog is fixed and already in view; letting the browser scroll to the
       field drags the page behind the scrim. */
    if (input) { try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); } }
  }

  function closeAddModal() {
    var m = addModal();
    if (!m || m.hidden) return;
    m.hidden = true;
    /* ⛔ CLEAR THE SEARCH AND ITS RESULTS. Reopening onto the previous query's result list would
     * offer to add a product the trader had already dismissed, and the list is rendered from a
     * sequence-checked fetch that will not re-run until they type. */
    var input = root.querySelector("[data-portal-search]");
    if (input) input.value = "";
    clearResults();
    if (modalOpener && modalOpener.focus) { try { modalOpener.focus(); } catch (e) {} }
    modalOpener = null;
  }

  function wireStartProject() {
    root.addEventListener("click", function (e) {
      var btn = e.target.closest ? e.target.closest("[data-start-project]") : null;
      if (!btn) return;
      e.preventDefault();
      openAddModal(btn);
    });
    /* ⛔ THE SCRIM CANNOT BE CLICKED AS AN ELEMENT, SO THE WRAPPER HANDLES IT.
     *    Measured: .lfy-portal__modalScrim resolves, is visibility:visible, opacity 1, and
     *    inset 0 — and elementFromPoint(20,450) returns .lfy-portal__modal, its PARENT. Both are
     *    position:fixed with the same inset, so the parent wins the hit test everywhere the card
     *    is not. Playwright refused the click for 30s and was right to: no human could hit it
     *    either. A scrim that swallows nothing is a scrim that closes nothing.
     *
     *    So the test is "did the click land on the wrapper itself, rather than inside the card" —
     *    which is the same delegated-with-closest shape every other click on this page uses, and
     *    needs no second fixed layer to be hittable. */
    root.addEventListener("click", function (e) {
      var x = e.target.closest ? e.target.closest("[data-add-close]") : null;
      var onWrapper = e.target && e.target.hasAttribute && e.target.hasAttribute("data-add-modal");
      if (!x && !onWrapper) return;
      e.preventDefault();
      closeAddModal();
    });
    /* ⛔ ON document, NOT root — a keydown only reaches the portal root if focus is inside it, and
     *    the scrim is not focusable. Guarded on the dialog actually being open so this cannot
     *    swallow Escape for anything else on the page (the chat widget, the selector's own modal). */
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape" && e.key !== "Esc") return;
      var m = addModal();
      if (!m || m.hidden) return;
      closeAddModal();
    });
  }

  function wireSearch() {
    var input = root.querySelector("[data-portal-search]");
    if (!input) return;
    var timer = null, seq = 0;
    input.addEventListener("input", function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) return clearResults();
      // Debounced, and every response carries the sequence it was asked for — an earlier, slower
      // reply must never overwrite a later one, or the list shows results for a query the trader
      // has already finished typing over.
      timer = setTimeout(function () {
        var mine = ++seq;
        fetch("/search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,variants.sku", { credentials: "same-origin" })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            if (mine !== seq) return;
            renderResults(((d.resources || {}).results || {}).products || []);
          })
          .catch(function () { if (mine === seq) say("Search isn't available right now.", "warn"); });
      }, 250);
    });
  }

  /* ── A line knows its SKU and variant id, but not its handle ────────────────────────────────
   * So a thumbnail and a link back to the product cannot be looked up directly: Shopify's Ajax API
   * has NO endpoint keyed by product or variant id, and /products/<handle>.js needs a handle the
   * payload does not carry. Cipzo will send a handle field (D48) and this whole path retires that day.
   *
   * ⛔ UNTIL THEN: SEARCH TO FIND, ID TO PROVE. Predictive search on the SKU proposes candidates —
   *    a fuzzy, ranked guess that must never be trusted on its own — and each candidate is then
   *    FETCHED and required to contain a variant whose id equals this line's variantId. Only then
   *    is anything rendered.
   *
   *    A near-miss is the whole risk here: SKUs share prefixes across a catalogue of 18,000
   *    variants, so "the top search result" would silently link a trader's quote to the WRONG
   *    product, and it would look completely normal. Unproven means NOTHING is rendered — no
   *    image, no link, just the line as it reads today. A missing thumbnail is a gap; a wrong one
   *    is a quoting error.
   */
  var resolveCache = {};
  /* ⛔ BUMP THIS WHENEVER THE CACHED OBJECT'S SHAPE CHANGES. sessionStorage SURVIVES A HARD
   * RELOAD, so an entry written by an older build is served in place of running the new code —
   * and the new code then looks broken while being correct.
   *
   * That is exactly what happened: I added `vendor` to what proveIn()/lookUp() return, verified it
   * in the deployed bundle, and the founder still saw no vendor on his globe lines. Those lines had
   * been resolved and cached BEFORE the field existed, so resolveLine returned the stale object and
   * never called the fixed code at all. The fittings came good because they take the lookUp path,
   * which caches separately — which is why it looked like "globes specifically" for four rounds.
   * Clearing sessionStorage by hand fixed his browser; this fixes it for every trader who already
   * has stale entries, because a changed prefix orphans them instantly rather than serving them.
   *
   * ⚠️ A CACHE IS A SILENT THIRD ANSWER. "Is the code right?" and "is it running?" were both yes;
   * the question I had not asked was "is anything answering BEFORE it runs?" */
  var CACHE_PREFIX = "lfy_line_v2_";
  function cacheGet(k) {
    if (resolveCache[k] !== undefined) return resolveCache[k];
    try { var v = sessionStorage.getItem(CACHE_PREFIX + k); if (v) return (resolveCache[k] = JSON.parse(v)); } catch (e) {}
    return undefined;
  }
  function cacheSet(k, v) {
    resolveCache[k] = v;
    try { sessionStorage.setItem(CACHE_PREFIX + k, JSON.stringify(v)); } catch (e) {}
  }

  function proveIn(handle, line) {
    return fetch("/products/" + handle + ".js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (prod) {
        var vs = prod.variants || [];
        var v = null;
        for (var i = 0; i < vs.length; i++) {
          // The variant id is the proof. Fall back to an EXACT sku match only when the line
          // carries no variant id at all — never to a partial or case-folded one.
          if (line.variantId && String(vs[i].id) === String(line.variantId)) { v = vs[i]; break; }
          if (!line.variantId && vs[i].sku === line.sku) { v = vs[i]; break; }
        }
        if (!v) return null;
        return {
          /* ⛔ THE THIRD PLACE TONIGHT THAT HAD `prod` IN HAND AND DROPPED prod.vendor — and the
           * one the founder was actually looking at. proveIn() feeds resolveLine(), which is the
           * !l.handle branch, which is the branch SELECTOR-created lines take: the globe and
           * driver Add buttons post variant-id + title with no handle, so those lines resolve
           * here and nowhere else. I fixed the lookUp twin (the handle path) an hour ago and
           * never asked whether its sibling had the same shape — so globes and drivers stayed
           * blank while PDP-added lines came good, which is exactly what he reported twice.
           * ⚠️ A peer's line data refuted my earlier "unresolvable line" theory and was right to:
           * these lines DO resolve. The vendor was never missing from the lookup — it was missing
           * from the object the lookup returns. */
          vendor: prod.vendor || null,
          url: "/products/" + prod.handle + "?variant=" + v.id,
          image: (v.featured_image && v.featured_image.src) || prod.featured_image || null,
          variantTitle: vs.length > 1 ? v.title : null,
        };
      })
      .catch(function () { return null; });
  }

  function attempt(q, line) {
    if (!q) return Promise.resolve(null);
    return fetch("/search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=5&resources[options][fields]=title,product_type,variants.title,variants.sku", { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var cands = (((d.resources || {}).results || {}).products || []).slice(0, 3);
        return cands.reduce(function (chain, c) {
          return chain.then(function (found) { return found || proveIn(c.handle, line); });
        }, Promise.resolve(null));
      })
      .catch(function () { return null; });
  }

  function resolveLine(line) {
    var key = String(line.variantId || line.sku || "");
    if (!key) return Promise.resolve(null);
    var hit = cacheGet(key);
    if (hit !== undefined) return Promise.resolve(hit);

    /* ⛔ TWO QUERIES, ONE GATE. Measured on the live project: searching the SKU proved 1 of 2
     * lines. The miss was not a near-match slipping through — it was the opposite, the gate
     * correctly REFUSING a candidate that did not contain the variant, because predictive search
     * ranked a different Havit step light first and returned nothing else.
     *
     * So the title is tried as well. It is a far better search key, and adding it costs no
     * correctness whatsoever: BOTH queries feed the same proof, which is that the fetched product
     * must contain this line's variant id. A second way to FIND a candidate is not a second way
     * to be wrong — the only thing that can render a link is still the id matching.
     *
     * All of this retires the day Cipzo sends a handle field (D48). It exists because there is no
     * Shopify endpoint keyed by variant id, not because searching is a good way to do this. */
    return attempt(line.sku, line)
      .then(function (found) { return found || attempt(line.title, line); })
      .then(function (found) { cacheSet(key, found || null); return found; });
  }

  /* Resolve a few at a time. A project of 100 lines would otherwise fire 300 requests at once,
     and the browser would queue them behind the ones that actually matter. */
  function hydrateLines(lines) {
    var queue = lines.slice(0, 40);
    var active = 0, i = 0;
    function next() {
      while (active < 4 && i < queue.length) {
        (function (line) {
          active++;
          resolveLine(line).then(function (info) {
            active--;
            if (info) paintLine(line, info);
            next();
          });
        })(queue[i++]);
      }
    }
    next();
  }

  /* ⛔ "Product" WAS BEING USED AS A NAME. The fallback chain ended in the literal string
   *    "Product", so a line carrying no title, no sku and no variant rendered as a row headed
   *    "Product" with working quantity buttons — a phantom item on the trader's job, indented
   *    and counted like the real one beside it. A fallback that looks like content is worse than
   *    an empty cell, because an empty cell is visibly missing and "Product" is not.
   *
   *    Found by a QA lane walking the several-open-projects state: one such row exists on
   *    Q-260908-004, four nulls, position 0. I created that instance with a hand-rolled probe
   *    that sent only variantId and quantity — but the app lane has since confirmed a TRADER can
   *    create one, so this is a defence, not a tidy-up after myself.
   *
   * ⛔ REMOVE STAYS OFFERED. A row nobody can identify is exactly the row a trader needs to be
   *    able to clear, and hiding the control to make the state look tidy would strand it.
   * ⚠ THREE LAYERS EACH HAD A CHANCE TO REFUSE THIS AND NONE DID — schema, API, and this page.
   *   The writer-level refusal is the app lane's; the honest rendering is mine, and it is worth
   *   having even after they land it, because a row that already exists still has to be shown. */
  function lineLabel(l) {
    return (l && (l.title || l.sku)) || null;
  }

  /* ⛔ ONE BUILDER, CALLED FROM BOTH ROW RENDERERS. The SKU was a bare value in two places —
   * "NOVIO TL-AGOP" with nothing saying what it was — and a trader ringing an order through reads
   * that code aloud or pastes it. It now carries its own label and a copy control.
   *
   * ⛔ COPIES THE WIRE SKU, NOT A RESOLVED ONE. resolveLine SEARCHES the catalogue BY l.sku, so the
   * wire value is the authority; a resolved variant's sku is the search RESULT and could differ on
   * a near-match. The string a trader pastes into an order must be the one on the quote.
   *
   * ⛔ THE BUTTON MUST NOT PRINT — it is suppressed in the print block beside .lfy-portal__print.
   * A paper quote with a dead "Copy" on every line is furniture on a sheet handed to a client. */
  function skuGroup(sku) {
    var wrap = document.createElement("span");
    wrap.className = "lfy-portal__skuGroup";

    var lbl = document.createElement("span");
    lbl.className = "lfy-portal__skuLabel";
    lbl.textContent = "SKU";
    wrap.appendChild(lbl);

    var val = document.createElement("span");
    val.className = "lfy-portal__sku";
    val.textContent = sku;
    wrap.appendChild(val);

    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "lfy-portal__skuCopy";
    btn.textContent = "Copy";
    /* The visible word is "Copy" on every line, so a screen reader hears it repeated with nothing
       distinguishing them. The accessible name carries the code the press would copy. */
    btn.setAttribute("aria-label", "Copy SKU " + sku);
    btn.addEventListener("click", function () {
      /* ⛔ SAY SOMETHING ON FAILURE. A clipboard write can reject — denied permission, or a
       * non-secure context — and a button that silently does nothing is the defect this lane keeps
       * finding. Both branches change the label, so a press always has a visible result. */
      var done = function (ok) {
        btn.textContent = ok ? "Copied" : "Press Ctrl+C";
        if (ok) {
          window.setTimeout(function () { btn.textContent = "Copy"; }, 1500);
          return;
        }
        /* The fallback is not a second clipboard API — it is putting the code where the trader's
           own copy keystroke can reach it. */
        try {
          var r = document.createRange();
          r.selectNodeContents(val);
          var s = window.getSelection();
          s.removeAllRanges();
          s.addRange(r);
        } catch (e) {}
        window.setTimeout(function () { btn.textContent = "Copy"; }, 2500);
      };
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(sku).then(function () { done(true); }, function () { done(false); });
        } else {
          done(false);
        }
      } catch (e) {
        done(false);
      }
    });
    wrap.appendChild(btn);
    return wrap;
  }

  function paintLine(line, info, scope) {
    /* Two views now render line rows — the draft project and a submitted quote — and a row is found
     * by line id. Scoping the lookup keeps them from painting into each other if both are ever in
     * the DOM at once, which they are: the views are hidden, not removed. */
    var row = (scope || root).querySelector('[data-line-row="' + String(line.id).replace(/"/g, "") + '"]');
    if (!row) return;
    var slot = row.querySelector("[data-line-thumb]");
    if (slot && info.image) {
      var img = document.createElement("img");
      img.className = "lfy-portal__lineImg";
      img.src = info.image;
      img.alt = "";
      img.loading = "lazy";
      slot.textContent = "";
      slot.appendChild(img);
    }
    var titleEl = row.querySelector("[data-line-title]");
    /* paintLine is additive and is now called twice for one row — once with the url from the
     * payload, once with the image that had to be fetched. Wrapping an already-wrapped title would
     * nest an <a> inside an <a>, which browsers silently unnest into something no longer clickable. */
    if (titleEl && info.url && !titleEl.querySelector("a")) {
      var a = document.createElement("a");
      a.href = info.url;
      a.className = "lfy-portal__lineLink";
      a.textContent = titleEl.textContent;
      titleEl.textContent = "";
      titleEl.appendChild(a);
    }
    /* A line whose product the storefront cannot serve. Said plainly, because the trader is
     * looking at their own quote and an unexplained gap reads as our page being broken.
     *
     * ⛔ IT NO LONGER SAYS "No longer listed on the site". That was a confident answer to a
     *    question I never asked the server. All I know is that a HANDLE did not resolve, and a
     *    handle stops resolving when a product is renamed just as readily as when it is delisted
     *    — so the sentence was actively false for the renamed case, told to a trade customer
     *    about their own quote. Two of three causes made it a lie.
     *
     *    The honest sentence says what happened (we could not confirm it) and what is unchanged
     *    (it is still on your quote), and it is true under all three causes. The real fix is the
     *    product's numeric id on the line so identity survives a rename — asked for, accepted by
     *    the app lane, not yet on the wire. This wording stands until it is. */
    if (info.unavailable) {
      var main = row.querySelector(".lfy-portal__lineMain");
      if (main && !main.querySelector(".lfy-portal__gone")) {
        var g = document.createElement("span");
        g.className = "lfy-portal__gone";
        g.textContent = "We couldn't confirm this one on the site \u2014 still on your quote";
        main.appendChild(g);
      }
    }
    // The variant name Cipzo does not send yet (D48) — but only when it was PROVEN, never guessed.
    if (info.variantTitle) {
      var vt = row.querySelector("[data-line-variant]");
      if (vt) { vt.textContent = info.variantTitle; vt.hidden = false; }
    }
    /* ⛔ THE SLOT MUST EXIST IN BOTH ROW BUILDERS OR THIS PAINTS INTO ONE VIEW ONLY. The variant
     * block above is the standing warning: the quote view never carried [data-line-variant], so
     * that block has only ever painted the project view — it looks right on a quote solely because
     * the wire happens to carry variantTitle there. A vendor has no such fallback, so the quote
     * builder gained the slot in the same change as this line. */
    if (info.vendor) {
      var vd = row.querySelector("[data-line-vendor]");
      if (vd) { vd.textContent = info.vendor; vd.hidden = false; }
    }
  }

  function renderLines(lines, enriched) {
    var box = root.querySelector("[data-lines]");
    box.textContent = "";
    var none = root.querySelector("[data-lines-empty]");
    if (none) none.hidden = !!(lines && lines.length);
    lines.forEach(function (l) {
      var row = document.createElement("div");
      row.className = "lfy-portal__line";
      /* ⛔ THE LINE BELOW THIS USED TO SET role="row", and it survived two greps: I searched the
       * markup for role="table" and role="row" as ATTRIBUTES and found only the containers, while
       * this one is set in JavaScript. So my first pass set "listitem" here and had it overwritten
       * on the very next line, and the page went on declaring a list full of table rows — which
       * the measurement caught and my source check did not.
       * Grep the assignment, not just the attribute. */
      row.setAttribute("role", "listitem");
      row.setAttribute("data-line-row", String(l.id));

      var thumb = document.createElement("div");
      thumb.className = "lfy-portal__lineThumb";
      thumb.setAttribute("data-line-thumb", "");
      row.appendChild(thumb);

      var main = document.createElement("div");
      main.className = "lfy-portal__lineMain";
      var titleEl = document.createElement("span");
      titleEl.setAttribute("data-line-title", "");
      // title may legitimately be null — show the SKU rather than an empty row or the word "null".
      var lbl2 = lineLabel(l);
      titleEl.textContent = lbl2 || "This line has no product on it";
      if (!lbl2) titleEl.className += " is-nameless";
      main.appendChild(titleEl);

      var vt = document.createElement("span");
      vt.className = "lfy-portal__lineVariant";
      vt.setAttribute("data-line-variant", "");
      vt.hidden = true;
      main.appendChild(vt);

      var vd2 = document.createElement("span");
      vd2.className = "lfy-portal__vendor";
      vd2.setAttribute("data-line-vendor", "");
      vd2.hidden = true;
      main.appendChild(vd2);

      /* ⛔ THE GATE DIFFERS FROM THE QUOTE VIEW'S AND THAT IS DELIBERATE, NOT DRIFT. Here a line
       * with a sku but no title shows the SKU as its NAME (lineLabel falls back to l.sku), so
       * repeating it underneath would print the same string twice. The quote view has no such
       * fallback path in practice. Preserved exactly as it was found. */
      if (l.sku && l.title) main.appendChild(skuGroup(l.sku));

      var qty = document.createElement("div");
      // Two different things wear this class: a read-only chip showing "x 5", and a group of three
      // controls. They cannot share a box model, and sharing one is what stacked the buttons.
      qty.className = "lfy-portal__qty" + (canUpdate ? " is-editable" : "");
      if (canUpdate) {
        // ⛔ MINUS IS DISABLED AT 1, so the theme can never send quantity 0. Whether 0 means
        // "delete" or "invalid" is the app lane's decision, not something this page should be
        // able to provoke an answer to by accident. Removal stays an explicit, separate act.
        qty.appendChild(stepBtn("−", l, l.quantity - 1, l.quantity <= 1));
        qty.appendChild(qtyInput(l));
        qty.appendChild(stepBtn("+", l, l.quantity + 1, false));
      } else {
        qty.textContent = "× " + l.quantity;
      }

      row.appendChild(main);
      row.appendChild(qty);

      if (canDelete) {
        var rm = document.createElement("button");
        rm.type = "button";
        rm.className = "lfy-portal__lineRemove";
        rm.textContent = "Remove";
        rm.setAttribute("aria-label", "Remove " + (lineLabel(l) || "this line") + " from your project");
        (function (line) {
          rm.addEventListener("click", function () {
            rm.disabled = true;
            writeLine("DELETE", line.id, null, "remove");
          });
        })(l);
        row.appendChild(rm);
      }

      if (l.note) {
        var note = document.createElement("div");
        note.className = "lfy-portal__note";
        note.textContent = l.note;
        row.appendChild(note);
      }
      box.appendChild(row);
    });
    /* ⛔ THREE STATES, NOT TWO — AND THE FLAG IS TOP-LEVEL, NOT PER LINE.
     *
     * Measured on the live payload: exactly ONE "enriched" exists in the whole response, at the
     * root, describing THE READ. I had it per line, so it was always undefined and every row took
     * the fallback path. The app lane read my report as "absent" and suspected the enrichment
     * lookup was failing; it is neither absent nor false, it is one level up.
     *
     *   enriched === true  -> variantTitle and handle are authoritative INCLUDING their nulls, so
     *                         a null finish means "nothing worth showing" and nothing is looked up.
     *   otherwise          -> the read did not enrich, so the local resolver may still answer.
     *
     * Shopify stamps "Default Title" on 4.8% of mirrored variants and the producer normalises it
     * away, so the resulting null is indistinguishable from "not examined" without this flag. */
    // enriched === true: variantTitle/handle are authoritative, INCLUDING their nulls, so a null
    // finish means "no finish worth showing" and nothing is looked up. enriched false or absent:
    // the read did not enrich, so the local resolver may still answer.
    if (enriched) {
      lines.forEach(function (l) { paintFromPayload(l); });
    } else {
      hydrateLines(lines);
    }
  }

  /* ⛔ ENRICHMENT CARRIES NO IMAGE, so deferring to it meant an enriched line NEVER got a
   * thumbnail — and the quote route returns enriched: true, so the submitted quote showed three
   * grey squares. The read being enriched says variantTitle and handle are authoritative; it says
   * nothing about a picture, because there is no image field on the wire at all.
   *
   * A handle is the only thing /products/<handle>.js needs, and an enriched line HAS one. So the
   * image is fetched from Shopify directly rather than asked for from the app lane — it is the
   * storefront's own data about the storefront's own product, and routing it through the proxy
   * would add a field, a migration and a lane dependency to something the theme can already see.
   *
   * Cached per handle+variant for the session: three lines on one quote, and the same products
   * across the draft project and its submitted quote, otherwise refetch on every view switch. */
  /* ⛔ A DEAD PRODUCT AND A FLAKY NETWORK MUST NOT BE TREATED ALIKE, which is why this returns a
   * verdict rather than an image. Found on Q-260907-002: three of its four lines carry handles the
   * storefront cannot serve —
   *     square-recessed-led-down-light-non-dimmable   page 404, .js 404   (gone)
   *     cantena-wb15-wall-light                       page 200 -> redirects to /, .js 404 (archived)
   * — and neither SKU is findable in search. The missing thumbnail was the visible symptom; the
   * real defect was that I was rendering a LINK from the payload's handle without ever checking it
   * resolved, so a trader clicking their own quote line got a 404 or was silently dropped on the
   * homepage. A dead link is worse than no link: it reads as a broken shop rather than a missing
   * feature, and it is the trader's own quote that appears broken.
   *
   *   resolved  the product answered           -> link it, and use its image
   *   dead      a definitive 404               -> DO NOT LINK. Fail closed; we know it is gone.
   *   unknown   transport failure, no verdict  -> keep the link. Fail OPEN; we do not know, and
   *                                              stripping every link on a dropped connection
   *                                              would be a worse failure than a rare stale one. */
  var lookupCache = {};
  function lookUp(l) {
    var key = l.handle + "|" + (l.variantId || "");
    if (Object.prototype.hasOwnProperty.call(lookupCache, key)) return Promise.resolve(lookupCache[key]);
    /* ⛔ THIS PROBE IS RELATIVE, AND IT MUST STAY RELATIVE. It resolves against the storefront
     * domain the customer is on. Moving it to the myshopify host would silently stop it working
     * -- not break it, STOP IT DISCRIMINATING, which is worse because nothing goes red.
     *
     * Measured, with a FABRICATED handle as the control:
     *
     *   lightsforyou.com.au              live .js=200   archived .js=404   fabricated .js=404
     *   lightsforyou-com-au.myshopify    live redirect  archived redirect  fabricated redirect
     *
     * On the myshopify host a product THAT HAS NEVER EXISTED answers exactly like a live one. So
     * every lookup there would resolve to `unknown`, every link would be kept by the fail-open
     * branch, and the guard would report a clean page for ever. The fabricated case is what shows
     * it: without a handle that must NOT resolve, "everything answered" and "the probe cannot
     * tell them apart" are the same observation.
     *
     * Note also that the archived PAGE is a redirect while its .js is a 404 -- which is why the
     * probe is .js and not the page. A status-code guard on the page is TRUE and useless. */
    return fetch("/products/" + l.handle + ".js", { credentials: "same-origin" })
      .then(function (r) {
        if (r.status === 404) return { state: "dead" };
        if (!r.ok) return { state: "unknown" };
        return r.json().then(function (prod) {
          var vs = prod.variants || [];
          var v = null;
          for (var i = 0; i < vs.length; i++) {
            if (l.variantId && String(vs[i].id) === String(l.variantId)) { v = vs[i]; break; }
            if (!l.variantId && vs[i].sku === l.sku) { v = vs[i]; break; }
          }
          return {
            /* The vendor is NOT on the trade wire — measured on Q-260914-003, the line keys are
               id/productId/variantId/sku/title/quantity/note/position/variantTitle/handle/unitPrice/
               lineTotal and nothing else. But this payload already has it, and this fetch already
               happens for the thumbnail, so the brand costs no wire change and no extra request.
               ⛔ prod.vendor, not v.vendor — vendor is a PRODUCT field; variants carry none. */
            vendor: prod.vendor || null,
            state: "resolved",
            /* The variant may be gone while the product lives — link to the product rather than to
             * a ?variant= that no longer exists, which lands on the default variant silently. */
            url: "/products/" + prod.handle + (v ? "?variant=" + v.id : ""),
            image: (v && v.featured_image && v.featured_image.src) || prod.featured_image || null,
            variantTitle: v && vs.length > 1 ? v.title : null,
          };
        });
      })
      .catch(function () { return { state: "unknown" }; })
      .then(function (out) { lookupCache[key] = out; return out; });
  }

  /* ── DOES THIS FITTING NEED SOMETHING ELSE TO WORK? ─────────────────────────────────────────
   *
   * The founder's requirement was ONE component, not a second opinion: whatever the product page
   * says about drivers and globes must be what My project says, and a change to it must reach
   * both. So this does not re-derive anything -- it asks the SELECTOR ITSELF, served on its own
   * at /products/<handle>?view=lfy-sel, and reads the attributes that component publishes about
   * itself: data-needs-driver and data-needs-globe.
   *
   * ⛔ THE GATE TRAVELS WITH IT. A product excluded from the selector renders nothing there, so
   *    it reports nothing here either. The portal cannot accidentally claim a driver is needed
   *    for a product the selector was never allowed to judge.
   *
   * Measured on the founder's own project:
   *     the full product page                      1220 KB
   *     ?view=lfy-sel, track light  needsDriver=false     3 KB
   *     ?view=lfy-sel, step light   needsDriver=true     76 KB
   *
   * ⚠ TRUE IS THE ONLY THING THAT SPEAKS. false, absent, a non-200 and a network failure all
   *   render nothing -- because 'we could not ask' must never look like 'nothing is needed'.
   *   Telling a trader no driver is required when we simply failed to check would put them on
   *   site with a fitting that will not light. */
  var needsCache = {};
  function needsFor(handle) {
    if (Object.prototype.hasOwnProperty.call(needsCache, handle)) return Promise.resolve(needsCache[handle]);
    return fetch('/products/' + handle + '?view=lfy-sel', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var d = html.match(/data-needs-driver="([^"]*)"/);
        var g = html.match(/data-needs-globe="([^"]*)"/);
        var out = { driver: !!(d && d[1] === 'true'), globe: !!(g && g[1] === 'true') };
        needsCache[handle] = out;
        return out;
      })
      .catch(function () { needsCache[handle] = null; return null; });
  }

  /* ── RUNNING THE PRODUCT PAGE'S OWN SELECTOR, HERE ──────────────────────────────────────────
   *
   * The founder asked why the chip could not just open the same popup. It can, and this is it:
   * the component's markup is fetched from /products/<handle>?view=lfy-sel, injected, and handed
   * to the selector's OWN init -- window.__lfySelectorInit -- so the matcher, the driver rules,
   * the globe pools and the modal are literally the same code running in a second place.
   * Nothing here re-implements any of it, which is the point: a change to the selector reaches
   * both surfaces or neither.
   *
   * ⛔ THE SCRIPT AND STYLESHEET LOAD ONCE, LAZILY, ON FIRST USE. The portal must not carry a
   *    2,500-line product-page script for every trader who never opens a selector.
   *
   * ⛔ innerHTML DOES NOT EXECUTE A <script src>. The fetched HTML carries the selector's own
   *    script tag and it is inert once injected, so the asset is added deliberately rather than
   *    trusted to run itself.
   *
   * ⚠ ON FAILURE THE LINK STILL WORKS. The chip is an anchor to the product page first and a
   *   popup trigger second: if the fetch fails, the script does not load, or the component
   *   changes shape, preventDefault is already done but the catch navigates. A degraded path
   *   that goes somewhere useful beats a clever one that goes nowhere. */
  var selAssets = null;
  function ensureSelectorAssets() {
    if (selAssets) return selAssets;
    selAssets = new Promise(function (resolve, reject) {
      if (window.__lfySelectorInit) return resolve();
      var cssHref = root.getAttribute('data-selector-css');
      if (cssHref) {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = cssHref;
        document.head.appendChild(link);
      }
      var src = root.getAttribute('data-selector-js');
      if (!src) return reject(new Error('no selector asset url'));
      var s = document.createElement('script');
      s.src = src;
      s.onload = function () { window.__lfySelectorInit ? resolve() : reject(new Error('no init hook')); };
      s.onerror = function () { reject(new Error('selector script failed')); };
      document.head.appendChild(s);
    });
    return selAssets;
  }

  var htmlCache = {};
  function selectorHtml(handle) {
    if (Object.prototype.hasOwnProperty.call(htmlCache, handle)) return Promise.resolve(htmlCache[handle]);
    return fetch('/products/' + handle + '?view=lfy-sel', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (h) { htmlCache[handle] = h; return h; });
  }

  function openSelectorPopup(handle) {
    return ensureSelectorAssets()
      .then(function () { return selectorHtml(handle); })
      .then(function (html) {
        if (!html) throw new Error('no component html');
        var host = root.querySelector('[data-sel-host]');
        if (!host) {
          host = document.createElement('div');
          host.setAttribute('data-sel-host', '');
          host.className = 'lfy-portal__selHost';
          root.appendChild(host);
        }
        var key = String(handle).replace(/[^a-z0-9-]/gi, '');
        var mount = host.querySelector('[data-sel-for="' + key + '"]');
        if (!mount) {
          mount = document.createElement('div');
          mount.setAttribute('data-sel-for', key);
          mount.innerHTML = html;
          host.appendChild(mount);
        }
        var card = mount.querySelector('[data-lfy-selector]');
        if (!card) throw new Error('component markup not found');
        window.__lfySelectorInit(card);          // THE SAME init the product page runs
        var trigger = card.querySelector('[data-lfy-open]');
        if (!trigger) throw new Error('no open trigger');
        trigger.click();
        return true;
      });
  }

  function paintNeeds(l, scope) {
    if (!l.handle) return;
    needsFor(l.handle).then(function (n) {
      if (!n || (!n.driver && !n.globe)) return;
      var row = (scope || root).querySelector('[data-line-row="' + String(l.id).replace(/"/g, '') + '"]');
      if (!row) return;
      var main = row.querySelector('.lfy-portal__lineMain');
      if (!main || main.querySelector('.lfy-portal__needs')) return;
      var a = document.createElement(l.handle ? 'a' : 'span');
      a.className = 'lfy-portal__needs';
      if (l.handle) a.href = '/products/' + l.handle + (l.variantId ? '?variant=' + l.variantId : '');
      a.textContent = n.driver && n.globe ? 'Needs a driver and a globe — see options'
                    : n.driver ? 'Needs a driver — see options'
                    : 'Needs a globe — see options';
      /* The href is the fallback, not decoration: every failure path navigates to the product
         page, where the selector definitely works. */
      a.addEventListener('click', function (ev) {
        if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.button !== 0) return;   // let people open a new tab
        ev.preventDefault();
        a.classList.add('is-loading');
        openSelectorPopup(l.handle)
          .then(function () { a.classList.remove('is-loading'); })
          .catch(function () { window.location.href = a.getAttribute('href'); });
      });
      main.appendChild(a);
    });
  }

  function paintFromPayload(l, scope) {
    /* The variant name from the payload is authoritative when the read is enriched, so it paints
     * immediately. The LINK does not: it waits for the product to answer, because a link that
     * 404s is worse than a link that appears a moment later. The row is fully readable throughout
     * — title, finish and SKU are all from the payload. */
    if (l.variantTitle) paintLine(l, { variantTitle: l.variantTitle }, scope);

    /* ⛔ A NULL HANDLE ON AN ENRICHED READ IS A GAP, NOT A VERDICT — and treating it as a verdict
     * is why the founder's globes had no photographs.
     *
     * Reproduced on his own case, 2026-09-15 (DOMUS Three Tier Bollard, SKU 10702): adding the
     * Oriel 9W A60 globe from its selector stored `handle: null`, and the row painted with no
     * photo and no link. The line above this one used to be `if (!l.handle) return;`, so the
     * whole picture-and-link path exited immediately.
     *
     * The cruel part is that the recovery ALREADY EXISTS and was one branch away. renderLines
     * does `if (enriched) { paintFromPayload } else { hydrateLines }` (:3681) — and hydrateLines
     * is what runs resolveLine(), the SKU-then-title search that proves a candidate by variant id.
     * His read comes back ENRICHED, so every line took this path and the resolver never ran.
     * Measured: /search/suggest.json on that globe's title returns oriel-9w-a60-led-e27-3000k-opal
     * first — the handle was findable the entire time.
     *
     * The comment at :3672 says enrichment makes handle authoritative "INCLUDING their nulls".
     * That holds for variantTitle, where null means "no finish worth showing". It does NOT hold
     * for handle: the enricher failing to mirror a product is a gap in our data, not a statement
     * that the product has no page. So the null falls through to the resolver instead of ending
     * the path.
     *
     * ⛔ ONLY WHEN THE HANDLE IS ACTUALLY MISSING. resolveLine costs up to two search requests
     *    per line, so it must never run for the ordinary enriched line that already has one —
     *    the guard is the same condition that used to return.
     * ⛔ STILL NO GUESSING. resolveLine renders nothing unless a fetched product contains THIS
     *    line's variant id (proveIn, :3433). An unproven line keeps today's behaviour exactly:
     *    no image, no link, no claim. A missing thumbnail is a gap; a wrong one is a quoting
     *    error, and that trade-off is unchanged. */
    if (!l.handle) {
      resolveLine(l).then(function (info) {
        if (info) paintLine(l, info, scope);
      });
      return;
    }
    paintNeeds(l, scope);

    lookUp(l).then(function (r) {
      if (r.state === "dead") {
        /* No link, no image, and the row says so rather than looking like a rendering fault. */
        paintLine(l, { unavailable: true }, scope);
        return;
      }
      if (r.state === "unknown") {
        /* We could not ask. Keep the link we would have rendered before this existed. */
        paintLine(l, { url: "/products/" + l.handle + (l.variantId ? "?variant=" + l.variantId : "") }, scope);
        return;
      }
      /* ⛔ THIS LITERAL IS WHY THE VENDOR DID NOT APPEAR, AND IT WAS MINE. lookUp() returns
       * {vendor, state, title, url, image, variantTitle} — I added `vendor` to that object and
       * then rebuilt a NEW object here with two keys, discarding it one line before it would
       * paint. The founder saw no vendor on a page whose thumbnails and links all worked, because
       * those are the two keys that survived.
       *
       * ⛔ I VERIFIED THAT paintLine WAS REACHED. I NEVER VERIFIED WHAT IT WAS REACHED WITH.
       * Six call sites, and only the two fed by resolveLine carried vendor; this one — the HANDLE
       * path, which is the normal case and the one every resolvable line takes — did not.
       * Same shape as D9: I swept both row BUILDERS and missed the paint PATHS.
       *
       * :4210 (dead) and :4215 (unknown) keep their literals deliberately — neither has product
       * data to pass, so there is nothing to forward. */
      paintLine(l, { url: r.url, image: r.image, vendor: r.vendor }, scope);
    });
  }

  /* ⛔ renderOthers() WAS HERE AND IS DELETED. It filled a SECOND panel ([data-others], headed
   *    "Your other open projects") from d.otherDrafts — the same source as renderOtherDrafts()
   *    above — and both ran in the same open read with neither hidden. A trader with another draft
   *    saw the identical list twice, stacked. The founder found it on his own page.
   *
   *    Its markup, its three CSS rules and its caller go with it. The surviving panel keeps the
   *    intent the deleted one stated ("never presents one project as though it were your only
   *    one") and now states it once. */

  /* The same failure SHAPE, closed properly rather than just this instance of it. A hung request
   * never rejects, so `.catch` never runs and the page would sit on "Loading your project…"
   * indefinitely — indistinguishable from working-but-slow, which is exactly why the script-order
   * bug went unreported. A loading state with no deadline is a silent failure waiting to happen. */
  var settled = false;
  var deadline = null;
  function startDeadline() {
    settled = false;
    clearTimeout(deadline);
    deadline = setTimeout(function () {
      /* ⛔ THE TIMEOUT PATH TOO. This fires when the proxy never answers, which tells us nothing
       * about the session — so it must not leave a trader stranded without a rail. Fails open, for
       * the same reason as the status branches. */
      if (!settled) { revealRail(); show("unavailable"); }
    }, 15000);
  }
  function settle(fn) {
    return function (arg) {
      settled = true;
      clearTimeout(deadline);
      return fn(arg);
    };
  }

  reload = function () {
    startDeadline();
    return fetch(root.getAttribute("data-endpoint"), {
    headers: { Accept: "application/json" },
    credentials: "same-origin",
  })
    .then(function (res) {
      // A gate denial 404s with NO body by design, so never assume one is parseable.
      return res
        .json()
        .catch(function () {
          return {};
        })
        .then(function (data) {
          return { status: res.status, data: data || {} };
        });
    })
    .then(settle(function (r) {
      /* ⛔ THE RAIL COMES BACK ON EVERY OUTCOME THAT IS NOT A CONFIRMED SIGNED-OUT, and this is a
       * hole I opened and nearly shipped. Hiding the rail until data-signed-in exists made three
       * paths that return BEFORE the signed-in branch into a total, silent loss of navigation:
       * a 404 gate denial, any non-200, and the deadline timeout in startDeadline(). All three are
       * reachable by an approved trader on a flaky connection — no error, no rail, no way to move.
       *
       * ⇒ Only `signedIn === false` may hide it. "We could not tell" must fail OPEN: a rail with a
       *   dead link is a smaller harm than a page with no navigation, and the founder's own D49
       *   decision was that the destinations stay visible even when unbacked.
       *
       * ⚠️ This runs before the status checks on purpose — putting it after them would recreate the
       *   same hole the next time an early return is added above it. */
      revealRail();
      if (r.status === 404) return show("unavailable");
      if (r.status !== 200) { showAdd(false, false); return show("unavailable"); }

      var d = r.data;

      // Signed-out is a legitimate 200 on this route, not a failure.
      /* ⛔ BRACES. This was a single-statement if, and inserting showAdd() before the return left
       * the return UNCONDITIONAL -- every visitor, signed in or not, got the signed-out state. It
       * is valid JavaScript, so node --check passed and the page shipped broken. */
      signedOutNow = d.signedIn === false;
      if (!d.signedIn) {
        showAdd(false, false);
        /* ⛔ THE OTHER VIEWS STILL RENDER while signed out — each used to claim emptiness rather
         *    than admit it could not see. They are no longer REACHABLE from a hidden rail, but a
         *    pasted #history link still lands on them, so they keep answering honestly. */
        renderHistory(d, null);
        renderAttachRouter(null);
        /* ⛔ #account USED TO INVENT AN ACCOUNT FOR A STRANGER. renderAccount was called only on
         *    the signed-IN path, so this view kept the Liquid literals and told a visitor with no
         *    account "ABN — Not connected yet / Trade type — Not connected yet". That wording is
         *    true for an approved trader whose metafields this page cannot read (see the note in
         *    the section) and is a fabrication to everyone else: it describes a record that does
         *    not exist. The three sibling views all say "sign in"; this one silently did not. */
        renderAccountSignedOut();
        /* ⛔ THE RAIL IS HIDDEN BY CSS KEYED ON THIS ATTRIBUTE, not by touching the nav here.
         *    A stranger was being offered Quote history, Trade account, Attach a schedule and
         *    Orders & details — six destinations into an account they do not have — and on a
         *    phone the rail sits ABOVE the heading, so it was the first thing on the page.
         *    Set on the ROOT because the grid that has to collapse with it is the root's own. */
        root.setAttribute("data-signed-out", "");
        root.removeAttribute("data-signed-in");
        /* Liquid could name the path but not the hash. A visitor who followed #history and then
         * pressed sign in should come back to #history, not the bare page. Same expression the
         * history view's own sign-in link uses — if one changes, change both. */
        var gate = root.querySelector("[data-gate-signin]");
        if (gate) {
          /* ⛔ /customer_authentication/login?return_to=, NOT /account/login?return_url=. Measured
           * on the live store, signed in: the second lands on the hosted account page (the bare
           * Orders screen the founder screenshotted) and the first lands on /pages/my-project.
           * This store runs new customer accounts, where return_url is not the supported key.
           * ⚠️ THIS LINE ESCAPED THE BULK EDIT because it wraps across two lines and my pattern
           *    matched the single-line form. Five siblings converted, this one did not — and it is
           *    the most prominent sign-in on the page. Caught by grepping for the OLD string
           *    afterwards rather than trusting the edit. */
          gate.setAttribute("href", "/customer_authentication/login?return_to=" +
            encodeURIComponent(location.pathname + (location.hash || "")));
        }
        return show("signed-out");
      }
      /* Already revealed at the top of this handler; this is the confirmed case. Kept as one call
       * rather than inlined attributes so the pair can never drift apart. */
      revealRail();

      /* ⛔ AN APPROVED TRADER MUST NOT BE SENT TO THE APPLICATION FORM. Dropping stay=1 hands them
       * back to the page's own redirect, which sends them to their project. Non-approved visitors
       * keep the parameter, because for them the form IS the destination.
       * ⚠ THIS IS THE RAIL ONLY. What the trade-programme PAGE should show an approved customer —
       *   their account status rather than a form — is ruled and owned elsewhere; this stops my
       *   own link delivering them to the wrong half of it. */
      var railApply = root.querySelector("[data-rail-apply]");
      if (railApply && d.trade && d.trade.approved) {
        railApply.setAttribute("href", String(railApply.getAttribute("href") || "").replace(/[?&]stay=1\b/, ""));
      }
      if (!d.trade || !d.trade.approved) {
        /* ⛔ THIS PRINTED THE RAW WIRE VALUE: `Status: not_approved`, an underscored enum shown to a
         * customer under a sentence about their own account, so it read as deliberate.
         *
         * ⛔ AND THE VOCABULARY IS NOT THE APPLY FORM'S. lfy-trade-apply.js maps ~16 reasons, but
         *    those refuse a SUBMISSION; this one describes an ACCOUNT'S STANDING — a different
         *    surface with a different set. Borrowing that list would have produced a mapping that
         *    looks thorough and misses every real value.
         *
         * Measured on the live wire for a pending account, trade is exactly:
         *     { "approved": false, "reason": "not_approved" }
         * ONE value. So one is mapped, and anything else stays SILENT rather than echoing a string
         * I have never seen and cannot phrase. An unexplained absence beats a leaked enum. */
        /* ⛔ THE VOCABULARY IS NOW KNOWN FROM CIPZO'S SOURCE, not from what I happened to observe.
         *    Cipzo PM, 2026-09-14, citing lib/trade/tradeStore.ts:82 — TradeAccessDenial is a closed
         *    union of four:
         *        not_signed_in | no_application | not_approved | read_error
         *    read_error is classified a FAULT (tradeAccessStatus.ts:139, status >= 500) and is
         *    answered with a status rather than the envelope, so THREE can reach this branch.
         *
         * ⛔ AND THE CARD'S COPY IS WRONG FOR ONE OF THEM. "Your application is with our team" is
         *    true for not_approved and a lie for no_application — telling somebody who has never
         *    applied that their application is being reviewed. I had mapped the one value I saw on
         *    the wire and let the other two fall through to a queue message that does not apply.
         *    Measuring a live account told me what Divyani's state was, not what the states ARE.
         *
         * ⚠ THE HEADLINE MOVES TOO, not just this line — a line under the wrong headline is still
         *   the wrong screen. */
        var why = root.querySelector("[data-not-approved-reason]");
        var title = root.querySelector("[data-not-approved-title]");
        var lede = root.querySelector("[data-not-approved-lede]");
        var badge = root.querySelector("[data-not-approved-badge]");
        var COPY = {
          not_approved: null,      /* the card's own queue copy is correct; say nothing extra */
          no_application: {
            badge: "No application yet",
            title: "You don’t have a trade account yet",
            lede: "We don’t have an application from you. Apply for a trade account and we’ll set you up — it takes a couple of minutes.",
            note: ""
          },
          not_signed_in: {
            badge: "Signed out",
            title: "Sign in to see your trade account",
            lede: "You’re signed out, so we can’t show your account. Sign in and this page becomes your project list.",
            note: ""
          }
        };
        var r2 = d.trade && d.trade.reason ? String(d.trade.reason) : "";
        var copy = Object.prototype.hasOwnProperty.call(COPY, r2) ? COPY[r2] : null;
        if (copy) {
          if (badge) text(badge, copy.badge);
          if (title) text(title, copy.title);
          if (lede) text(lede, copy.lede);
        }
        /* ⛔ THE PROGRESS SPINE IS A CLAIM TOO, and a stronger one than the headline. "1 Application
         * received ✓" next to "You don't have a trade account yet" would contradict the fix inside
         * the same card. Only the queue state has actually completed step 1. */
        var steps = root.querySelector("[data-not-approved-steps]");
        if (steps) steps.hidden = !!copy;
        /* An unmapped value says NOTHING rather than echoing an enum at a customer. If Cipzo adds a
         * state (suspended/expired/revoked), the PM has undertaken to tell this lane so copy exists
         * before the value ships — until then silence is the honest default. */
        if (why) {
          var phrase = copy ? copy.note : "";
          text(why, phrase);
          why.hidden = !phrase;
        }
        /* ⛔ HIDE THE RAIL FOR A PENDING APPLICANT TOO (founder's call). The signed-out rule keys on
         * :not([data-signed-in]) and CANNOT cover this reader — they ARE signed in, and revealRail()
         * has already run above. Every rail destination is empty for them: no quotes to list, no
         * project to attach to. Same defect the founder reported for strangers, wearing a different
         * hat, so it gets its own marker rather than a widened selector. */
        root.setAttribute("data-pending", "");
        showAdd(false, false);
        return show("not-approved");
      }
      root.removeAttribute("data-pending");

      /* project === null means either "never had one" or "just sent one". The submitted field is
       * what separates them, and getting that wrong shows a trader who has just submitted a quote
       * the words "Your project is empty". */
      // Adding is offered on every approved state, including the two with no project — those are
      // exactly the moments a trader needs to start one.
      openProjectId = d.project ? d.project.id : null;
      openProjectRef = d.project ? addressOf(d.project) : null;
      /* ⛔ KEPT SO THE SURFACE CAN BE REPAINTED WITHOUT A RE-READ. The panels are MOVED between
       *    the project and a quote, and moving an element carries its TEXT with it. */
      openProjectData = d.project ? { project: d.project, projectOps: d.projectOps } : null;
      paintMastheadActions();
      /* Remembered here, where the payload that owns this fact arrives, so opening a draft from a
       * link can repaint the panel instead of leaving the previous read's rows behind. */
      lastOtherDrafts = Array.isArray(d.otherDrafts) ? d.otherDrafts : [];
      lastOtherDraftsTruncated = d.otherDraftsTruncated === true;
      renderOtherDrafts(d);
      paintDraftEscape();
      /* Both directions: a deep link waiting to be confirmed, and the plain page which only now
       * knows what to call itself. */
      /* false means a deep link has been handed to loadProjectInto() and a DIFFERENT project is
       * being fetched for this screen. Everything below still runs — it is either guarded on
       * currentView or redone by loadProjectInto for its own project — but the final paint must
       * not overwrite that project with this one. */
      var keepsOpenProject = resolvePendingProject() !== false;
      /* ⛔ A PLAIN VISIT MUST NOT REWRITE THE ADDRESS. Founder, 2026-09-18: "why my project is
       * going to #project/Q-260908-003" — he typed /pages/my-project and the page stamped a
       * project reference onto the URL under him.
       *
       * This is the 2026-09-17 nav-click rule extended to the one entry it did not cover. That
       * ruling said: clicking "My project" means "take me to my project area" and leaves a clean
       * address, while anything DELIBERATELY OPENED still deep-links so it can be shared. A bare
       * page load is the same intent as the nav click — the trader asked for their area, not for
       * a named project — and it was the only path still stamping.
       *
       * ⛔ SCOPED TO THE LOAD, NOT TO syncProjectUrl. The other five callers are deliberate opens
       * (a history row, the escape button, a quote link, loadProjectInto, the project read after
       * an explicit open) and every one of them still produces a shareable URL. Changing the
       * function itself would have silently taken the address away from all of them — the
       * trigger-not-the-thing error.
       *
       * ⚠️ IT ONLY EVER SHOWED UP FOR SOMEONE HOLDING AN OPEN DRAFT. On an account whose project
       * is already submitted the state is "empty", there is nothing to name, and the URL stayed
       * clean — which is why this survived a walk-through on a test account and was reported by
       * the founder on his own. */
      if (urlStampedOnLoad) {
        syncProjectUrl();   /* the open read may land after the quote read, or before it */
      } else {
        urlStampedOnLoad = true;   /* every later read is a deliberate open and may name itself */
      }
      /* The same gates as the quote: declared, or absent. Nothing is inferred from status. */
      if (openProjectId) {
        var cPanel = root.querySelector("[data-q-comments-panel]");
        var cCompose = root.querySelector("[data-q-compose]");
        var canComment = Array.isArray(d.projectOps) && d.projectOps.indexOf("comment") !== -1;
        /* ⛔ FOURTH INSTANCE, AND THE GUARD BELOW WAS ALREADY HERE — THESE TWO LINES SIMPLY SAT
         *    OUTSIDE IT. The warning under this block describes exactly this bug and the fix
         *    stopped one statement short: loadComments and paintAttachPanel were moved inside
         *    `currentView === "project"`, the two `.hidden` writes that REVEAL the panel were not.
         *
         *    Measured on live, signed in, opening #quote/Q-260908-003 (a quote this account does
         *    not own): GET /projects/Q-260908-003 -> 404 unknown_project, loadQuote() correctly
         *    printed "That quote isn't available." and called hideQuoteChrome(). Then the open-
         *    project read landed ~2s later and re-revealed the panel. Result on screen: a refusal
         *    heading above a live "Add a comment" box and an enabled Send comment button, on a
         *    quote the reader had just been told was not theirs. data-q-actions, -attach-panel,
         *    -totals and -steps were all correctly hidden — only these two came back, which is why
         *    it reads as a styling oddity rather than the ownership leak it is.
         *
         *    The quote view has its own writer for these two elements (renderComments, which sets
         *    them from the QUOTE's projectOps), so leaving them untouched here is not "no one
         *    paints them" — it is the surface's own read painting its own surface, which is the
         *    rule this block already states. */
        /* ⛔ ONLY WHEN THE PROJECT IS THE SURFACE ON SCREEN. THIRD INSTANCE of this shape, and I
         *    caused it: I fixed the JOURNEY I had reproduced (project -> quote -> back) and left
         *    the general rule unfixed, so it came straight back on the journey I had not tried —
         *    a quote opened DIRECTLY by url. This read resolves ~2s after the quote has painted
         *    and overwrote the label with its own project.
         *
         *    Founder screenshot, #quote/Q-260908-002: heading Q-260908-002, attach panel "Files
         *    you add here join Q-260908-004". The upload TARGET was Q-260908-002 throughout —
         *    activeId() follows the view — so once again the words and the action disagreed and
         *    only the words were visible.
         *
         * ⛔ THE RULE, not the journey: a read paints the surface it belongs to, never the one
         *    that happens to be showing when it lands. repaintPanels() paints on arrival at a
         *    surface; this paints on arrival of data. Both must agree about whose data it is. */
        if (currentView === "project") {
          if (cPanel) cPanel.hidden = !canComment;
          if (cCompose) cCompose.hidden = !canComment;
          if (canComment) loadComments(openProjectId, null);
          paintAttachPanel({ project: d.project, projectOps: d.projectOps });
        }
      }
      addAllowed = opsOf(d).indexOf("add") !== -1;
      /* Third argument is the `submitted` state computed from the payload — the same test the
         branch below uses to call show("submitted"). Derived here because showAdd runs BEFORE
         that branch, so it cannot read the state variable. */
      showAdd(addAllowed, !!d.project, !d.project && !!lastSubmitted(d));
      loadHistory(d);
      renderAccount(d);

      if (!d.project) {
        var sent = lastSubmitted(d);
        if (sent) {
          text(root.querySelector("[data-sent-ref]"), sent.reference || "");
          var bits = [];
          // The contract carries no name on lastSubmitted, so none is shown rather than a blank
          // separator where one would have been.
          if (sent.status && sent.status !== "submitted") bits.push(sent.status);
          if (typeof sent.lineCount === "number") bits.push(lineCountText(sent.lineCount));
          if (sent.draftOrderName) bits.push(sent.draftOrderName);
          text(root.querySelector("[data-sent-meta]"), bits.join(" · "));
          return show("submitted");
        }
        return show("empty");
      }

      /* ⛔ NOT WHEN A DEEP LINK HAS TAKEN THE SCREEN. Painting here would put the open project's
       *    name, reference, meta and lines over the draft the address asked for, for as long as
       *    the second fetch takes — roughly a second, measured. The surface belongs to whoever the
       *    address named; this read still did all its other work above. */
      if (keepsOpenProject) paintProject(d);
    }))
    .catch(settle(function () {
      // Transport failure is not a refusal, and must not read as "you have no project".
      show("unavailable");
    }));
  };

  /* ⛔ EXTRACTED, NOT REWRITTEN — and the distinction is the whole point of the change.
   *
   * This body was inline inside the open read's .then(settle(...)) callback. It is lifted verbatim
   * so a SECOND project's payload can be painted through the same code, which is what "open any
   * draft for editing" needs: the founder asked twice how to add a product to a draft that is not
   * the current one, and the honest answer was that the surface could only ever paint the one
   * project GET /trade calls open.
   *
   * ⚠️ WHY AN EXTRACTION AND NOT A NEW PAINTER: a second painter would drift from this one on the
   *    first change to either, and this surface has already produced three documented cases of two
   *    writers disagreeing about one element. One painter, two callers.
   *
   * WHAT MAKES THE CUT SAFE, checked rather than assumed:
   *   - it closes over `d` only; `r` (the response wrapper) appears nowhere in it, so there is no
   *     hidden dependency on the fetch result;
   *   - every `var` it declares is local to it and moved with it;
   *   - the four flags it assigns — canSubmit, canRename, canUpdate, canDelete — are module scope
   *     (:263, :2736), so a sibling function still reaches them;
   *   - every early return (`404`, non-200, signed-out, not-approved, submitted, empty) happens
   *     ABOVE the cut, so `d.project` is non-null here by construction, exactly as before.
   *
   * ⚠️ reload() IS NOT ONLY THE FIRST PAINT. afterWrite() calls it after every add, update and
   *    delete, so a regression here would surface on every write, not just on load. Verified
   *    against a recorded before/after snapshot rather than by eye. */
  function paintProject(d) {
      text(root.querySelector("[data-project-name]"), d.project.name || "Untitled project");
      var meta = [];
      if (d.project.reference) meta.push(d.project.reference);
      if (d.trade.companyName) meta.push(d.trade.companyName);
      /* ⛔ d.project, NOT pr — THIS SCOPE HAS NO pr. I wrote pr.createdAt here while replacing five
       * date formatters at once, and it threw a ReferenceError that killed the whole open read, so
       * the page fell back to its STATIC MARKUP and rendered a plausible English sentence with no
       * date in it. That is the same symptom as a stale session, which I had diagnosed correctly
       * ten minutes earlier — so the failure arrived already wearing a disguise I had just seen
       * through. A mechanical rename across scopes needs each site read, not each site matched. */
      var st2 = fmtDate(d.project.createdAt);
      if (st2) meta.push("Started " + st2);
      // ⛔ THE COUNT FOLLOWS THE SAME RULE AS THE HEADER PILL. When the page was CUT, lines.length
      // understates the project, so no number is shown at all — "12 products" on a truncated
      // 40-line project is a figure the trader would plan around.
      if (d.truncated === false && Array.isArray(d.lines)) {
        meta.push(lineCountText(d.lines.length));
      }
      text(root.querySelector("[data-project-meta]"), meta.join(" · "));

      var chip = root.querySelector("[data-project-status]");
      if (chip) {
        // Status is REPORTED, never derived — no inferring "expired" from a date here.
        if (d.project.status) {
          chip.textContent = d.project.status;
          chip.className = "lfy-portal__chip is-" + String(d.project.status).toLowerCase().replace(/[^a-z]+/g, "-");
          chip.hidden = false;
        } else {
          chip.hidden = true;
        }
      }

      // Read BEFORE rendering: renderLines() draws the controls, so capabilities decided
      // afterwards arrive too late and the first render is the one the trader sees.
      canSubmit = submitDeclared(d);
      canRename = renameDeclared(d);
      var renameBtn = root.querySelector("[data-rename]");
      if (renameBtn) renameBtn.hidden = !canRename;
      // The rail's schedule item becomes real only when the server says attaching works.
      var railAttach = root.querySelector("[data-rail-attach]");
      if (railAttach && attachDeclared(d)) {
        railAttach.classList.remove("is-disabled");
        railAttach.removeAttribute("aria-disabled");
        var soon = railAttach.querySelector(".lfy-portal__railSoon");
        if (soon) soon.remove();
      }
      var submitBtn = root.querySelector("[data-portal-submit]");
      // Declared AND there is something to price. An empty project cannot be sent, and offering it
      // only to be refused with empty_project is a message the page could have avoided.
      if (submitBtn) submitBtn.hidden = !(canSubmit && d.lines && d.lines.length);

      var ops = opsOf(d);
      canUpdate = ops.indexOf("update") !== -1;
      canDelete = ops.indexOf("delete") !== -1;
      // ⛔ enriched IS TOP-LEVEL, not per line. Measured: exactly one occurrence in the whole
      // payload, at path "enriched", value true. It describes THE READ, not a row. My client was
      // testing l.enriched, which is always undefined, so every line fell through to the local
      // SKU/title resolver -- correct output (the proof gate saw to that) at two wasted requests
      // per line. Passed down once instead.
      renderLines(Array.isArray(d.lines) ? d.lines : [], d.enriched === true);

      var trunc = root.querySelector("[data-truncated]");
      if (d.truncated) {
        // Stated, not measured. Saying "showing N of N" from the array length would be the exact
        // lie this flag exists to prevent.
        text(trunc, "This project has more lines than are shown here.");
        trunc.hidden = false;
      } else {
        trunc.hidden = true;
      }

      var pending = root.querySelector("[data-editing-pending]");
      if (pending) pending.hidden = (canUpdate && canDelete) || !(d.lines && d.lines.length);

      show("project");
  }
  reload();
  wireSearch();
  wireViews();
  wireCompose();
  wireUpload();
  wireStart();
  wireRename();
  wireStartProject();
  wireSubmit();
  /* ⛔ THIS LINE IS THE WHOLE DIFFERENCE BETWEEN A BUTTON AND AN ORNAMENT, and I wrote wireAccept()
   * without it. The control rendered, gated correctly on projectOps, carried the right version —
   * and did nothing at all on click. Built-and-unreachable is this file's signature defect: the
   * sign-in link's dead return_url, the add panel that outlived its read, the [data-others] panel
   * nobody rendered. I read all three notes today and produced a fourth within the hour.
   * Caught by asking "is it called?" rather than by testing, which is luck I should not repeat. */
  /* ⛔ DISARMED ON THE FOUNDER'S INSTRUCTION, 2026-09-15. He was asked directly and chose "pull it
   * now": every press returns 500, deterministically, across 19+ paced and unpaced calls on the
   * only project that can exercise it. Nothing is written — confirmed from the API and from the
   * database independently — so the failure is in the safe direction, but a trade customer pressing
   * a control that always fails is worse than no control.
   *
   * ⚠️ A PEER LANE RELAYED THE OPPOSITE ("the founder has ruled, leave it live"). It contradicted
   *    his own answer to me. A relayed decision is not the decision; his words in my session are.
   *
   * ONE LINE, so restoring is one line back. Everything else — markup, painter, POST, copy, CSS —
   * stays built and reviewed. The endpoint remains reachable for diagnosis without the button.
   * Cause as of disarming: Shopify renders a THEME PAGE for the proxy URL and returns 500
   * (render;dur=203, theme;desc=145377198164, 794KB body, no x-vercel-id), while the app lane's
   * runtime logs show their function also receiving the POST. Not yet explained. */
  wireAccept();
  wireRailHistory();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
